export const Tuples = [
    [
        {
            "words": [
                "उकळणे",
                " पेय",
                " दार्जिलिंग",
                " पाने "
            ],
            "theme": " चहा",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "टेकडी",
                " मंदिर",
                " पायऱ्या",
                " पुणे"
            ],
            "theme": "पुणे स्थित  पर्वती टेकडी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "भरती",
                " लाटा",
                " गाज",
                " पुळण "
            ],
            "theme": " समुद्र",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मृगजळ",
                " उंट",
                " निवडुंग",
                " उष्ण "
            ],
            "theme": " वाळवंट ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "कमला",
                " शांतता",
                " सखाराम",
                " कोतवाल"
            ],
            "theme": "विजय तेंडुलकर यांच्या नाटकांच्या  नावातील शब्द",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "भांगडा",
                " गरबा",
                " बिहू",
                " घूमर "
            ],
            "theme": " विविध नृत्य प्रकार",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इंदिरा संत",
                " शांता शेळके",
                " कुसुमाग्रज",
                " केशवसुत"
            ],
            "theme": " प्रसिद्ध मराठी कवी/कवयित्री",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "वि. स. खांडेकर",
                " शिवाजी सावंत",
                " रणजीत देसाई",
                " ना. सी. फडके"
            ],
            "theme": " प्रसिद्ध मराठी कादंबरीकार",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "अण्णासाहेब किर्लोस्कर",
                " मधुसूदन कालेलकर",
                " वसंत कानेटकर",
                " विद्याधर गोखले"
            ],
            "theme": " प्रसिद्ध मराठी नाटककार",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इथिओपिया",
                "बरंच काही",
                "चिकोरी",
                "अरॅबिका"
            ],
            "theme": "कॉफी - त्याचे जन्मस्थान, शास्त्रीय नाव, मिश्रण, चित्रपट इत्यादी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "इराणी",
                " बासुंदी",
                "तंदुरी",
                " गवती"
            ],
            "theme": " चहाचे प्रकार ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "चहा",
                "कागद",
                "दारू",
                "नूडल्स/शेवया"
            ],
            "theme": "चीनचे प्राचीन शोध",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कादंबरी",
                " नाटक",
                " कविता",
                " चरित्र"
            ],
            "theme": "वाङ्मयीन प्रकार  ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बुद्धिबळ",
                " संगीत",
                " ओरिगामी",
                " चित्रकला "
            ],
            "theme": " छंद",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "⁠बाग",
                " पुणे",
                " गणपती",
                " तळे"
            ],
            "theme": "पुणे स्थित सारसबाग संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सर्कस",
                " फौजी",
                " उम्मीद",
                " दूसरा केवल"
            ],
            "theme": "शाहरुख खान यांच्या दूरदर्शनवरील मालिका ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पैंजण",
                " ढोलकी",
                " बैठक",
                " नटरंग "
            ],
            "theme": " लावणीशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "आकाश",
                " खंड्या",
                " गोकर्ण",
                " नीलम"
            ],
            "theme": "निळ्या गोष्टी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मैदान ",
                " हार ",
                "जीत",
                " पंच "
            ],
            "theme": " मैदानी खेळ ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 0
        },
        {
            "words": [
                "उकळणे",
                "टॅनीन",
                " दार्जिलिंग",
                " पाने "
            ],
            "theme": " चहा",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "भरती",
                " लाटा",
                " गाज",
                " पुळण "
            ],
            "theme": " समुद्र",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाठ",
                " राखी",
                " तंबू ",
                " फास"
            ],
            "theme": "दोरी/दोरखंड इत्यादींशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लोकल",
                " डबेवाले",
                " व्यापार",
                " बंदर"
            ],
            "theme": "मुंबई",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मशाल",
                "इंजिन",
                "कमळ",
                "घड्याळ"
            ],
            "theme": "महाराष्ट्रातील पक्षांची निवडणूक चिन्हे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कांगारू",
                " कोआला",
                " उलुरु ",
                " ब्रॅडमन "
            ],
            "theme": " ऑस्ट्रेलिया",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "ज्योत",
                " वाढदिवस",
                " दिवाळी",
                " मेण"
            ],
            "theme": " मेणबत्तीशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "नंदी",
                "रेडा",
                "उंदीर",
                "गरुड"
            ],
            "theme": "काही देवांची वाहने ",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मुघल",
                " गड ",
                " मराठा",
                " राज्याभिषेक "
            ],
            "theme": " ​​शिवाजी महाराज ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "गाजर",
                " आले",
                " हळद",
                " वसाबी "
            ],
            "theme": " जमिनीखालच्या खाण्यायोग्य वनस्पती ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "कोन",
                " स्कूप",
                " दूध",
                " व्हॅनिला "
            ],
            "theme": " आईस्क्रीम ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काळजी",
                "विश्रांती",
                "झेप",
                "श्वास"
            ],
            "theme": "ज्या गोष्टी घेता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रं",
                "झोप",
                "खोडी",
                "पाणी"
            ],
            "theme": "ज्या गोष्टी काढता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "शोध",
                "विरजण",
                "झाड",
                "आग"
            ],
            "theme": "ज्या गोष्टी लावता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कॅडेट्स",
                " शिस्त",
                " परेड",
                " शौर्य"
            ],
            "theme": " भारतीय संरक्षण प्रबोधिनी (NDA) ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "रक्त",
                " जास्वंद",
                " माणिक",
                " सफरचंद"
            ],
            "theme": "लाल रंगाच्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भांगडा",
                " सलवारखमीज",
                " गहू",
                " हॉकी"
            ],
            "theme": " पंजाबशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढाल",
                "करंडक",
                "पदक",
                "चक्र"
            ],
            "theme": "पारितोषिके",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मेण",
                "आइस्क्रीम",
                "मीठ",
                "हृदय"
            ],
            "theme": "विरघळणार्या / पाघळणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "समुद्र",
                "पोफळी",
                "मोदक",
                "आंबा"
            ],
            "theme": "कोकणातील गोष्टी ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कविता",
                " हुजूरपागा",
                "आनंदाचे झाड",
                "ऋतू हिरवा"
            ],
            "theme": "कवयित्री शांता शेळके यांच्याशी संबंधित",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "हात",
                "चौकट",
                "हुकूम",
                "विदुषक"
            ],
            "theme": "पत्ते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "गाऊन",
                "तराजू",
                "सर्वोच्च",
                "कायदा"
            ],
            "theme": "न्यायालय",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सागरा धरणी",
                "संधी",
                "जागा",
                "नोकरी"
            ],
            "theme": "ही “मिळते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "गुंड्या",
                "मोरू",
                "मैना",
                "काऊ"
            ],
            "theme": "चिमणरावांचे चऱ्हाट (पुस्तक व मालिका) मधील पात्रे ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "नदी",
                "वीज",
                "वारा",
                "रस्ता"
            ],
            "theme": "वाहणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाणी",
                "काच",
                "हवा",
                "पोकळी"
            ],
            "theme": "पारदर्शक गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "विविध",
                "नाना",
                "अनेक",
                "निरनिराळे"
            ],
            "theme": "बरेच, खूप या अर्थी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आवाज",
                " जत्रा",
                " अक्षर",
                "किस्त्रीम"
            ],
            "theme": "काही प्रसिद्ध दिवाळी अंक ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भर",
                "ओढ",
                "ठेव",
                "बस"
            ],
            "theme": "नामरुपे आणि क्रियेची आज्ञार्थ रुपे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                42.195,
                " अथेन्स",
                "केनिया",
                "कीपटूम"
            ],
            "theme": " मॅरेथॉनशी संबंधित ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "दोर",
                " सुळका",
                "चढण",
                "खिळे"
            ],
            "theme": "गिर्यारोहणाशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिकीट",
                "आरक्षण",
                "स्थानक",
                "गंतव्य"
            ],
            "theme": "रेल्वे प्रवास ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 0
        },
        {
            "words": [
                "अमूल",
                "गवळी",
                "म्हैस",
                "गाय"
            ],
            "theme": "दूध देणारे :)",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "तलफ",
                "मंदी",
                "जाग",
                "शिंक"
            ],
            "theme": "ही “येते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कात",
                "शिडी",
                "खवले",
                "काटेरी जीभ"
            ],
            "theme": "'साप' या विषयाचा शब्दबंध",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चुना",
                "सुपारी",
                "बडीशेप",
                "गुलकंद"
            ],
            "theme": "विडा/पान बनवण्यासाठी पदार्थ ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "वासुकी",
                "तक्षक",
                "कालिया",
                "कर्कोटक"
            ],
            "theme": "पुराणातील काही नागांची नावे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बहर",
                "पालवी",
                "मोड",
                "कळी"
            ],
            "theme": "वनस्पतीं वर येणार्‍या नव्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "छापा",
                "टाकसाळ",
                "चिल्लर",
                "पावली"
            ],
            "theme": "चलनी नाणी या विषयावरील शब्दबंध ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "बाई",
                "श्याम",
                "कवडी",
                "दाम"
            ],
            "theme": "\"विकत घेतला श्याम\" गाण्यातले शब्द",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुदर्शन",
                "परमवीर",
                "अशोक",
                "मूलाधार"
            ],
            "theme": "चक्र",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गारुडी",
                "फणा",
                "पंचमी",
                "पुंगी"
            ],
            "theme": "'नाग' या विषयाचा शब्दबंध ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "झोप",
                "ठेच",
                "बस",
                "वाट"
            ],
            "theme": "ही “लागते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आग",
                "माल",
                "बैल",
                "घोडा"
            ],
            "theme": "गाडी प्रत्यय लावून अर्थपूर्ण ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "उचलणे",
                "जीभ",
                "लावणे",
                "टाळ्याला"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "काटा",
                " टिकटिक",
                "वेळ",
                "ठोके"
            ],
            "theme": " घड्याळ ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बहार",
                "नंद",
                "शिव",
                "चार"
            ],
            "theme": "'सदा' हा उपसर्ग लावून अर्थपूर्ण शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "मूळ",
                "स्वाती",
                "हस्त",
                "चित्रा"
            ],
            "theme": "नक्षत्रं",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "शह",
                "राणी",
                "घोडा",
                "मात"
            ],
            "theme": "बुद्धिबळाच्या पटावर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ग्रह",
                "तारे",
                "कृष्णविवर",
                "धूमकेतू"
            ],
            "theme": "खगोलशास्त्रीय",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "म्हैस",
                "गटणे",
                "पौष्टिक",
                "वरात"
            ],
            "theme": "पु लं च्या लिखाणातून ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "चक्राकार",
                "खमंग",
                "भाजणी",
                "कुरकुरीत"
            ],
            "theme": "चकली",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मानस",
                "दाल",
                "पिचोला",
                "वेण्णा"
            ],
            "theme": "तलाव",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "उत्प्रेक्षा",
                "यमक",
                "रूपक",
                "उपमा"
            ],
            "theme": "मराठी भाषालंकार",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "दैव",
                "देते",
                "कर्म",
                "नेते"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विद्या",
                "भूमी",
                "कृती",
                "श्रद्धा"
            ],
            "theme": "हिंदी चित्रपटांमधील मधील काही अभिनेत्री ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "आलीया",
                "भोगासी",
                "असावे",
                "सादर "
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विद्युत",
                "संथ",
                "वर्तुळाकार",
                "ब्राऊनिअन"
            ],
            "theme": "गती/हालचाली चे प्रकार",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फेस",
                "तुषार",
                "खळखळाट",
                "तरंग"
            ],
            "theme": "समुद्राच्या लाटां बाबत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कल्पवृक्ष",
                "पांचजन्य",
                "कामधेनू",
                "हलाहल"
            ],
            "theme": "समुद्र मंथनातून मिळालेल्या काही गोष्टी ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आग",
                "रामेश्वर",
                "बंब ",
                "सोमेश्वर"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बोट",
                "माड",
                "लाटा",
                "शिंपला"
            ],
            "theme": "समुद्र किनाऱ्यावर वर दिसणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अडीच",
                "चौसष्ट",
                "कॅसलिंग",
                "एन पासंट"
            ],
            "theme": "बुद्धिबळाच्या पटावर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दोन",
                "तीन",
                "पाच",
                "सात"
            ],
            "theme": "पहिल्या ४ मूळ संख्या",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कागद ",
                " छपाई",
                "संपादकीय",
                "पत्रकार "
            ],
            "theme": " वर्तमान पत्र ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "देव",
                "सराफ",
                "फुले",
                "लागू"
            ],
            "theme": "जुन्या मराठी चित्रपटातल्या अभिनेत्यांची आडनावे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पेला",
                "खिडकी",
                "भिंग",
                "दौत"
            ],
            "theme": "काचेच्या वस्तु",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंथरुण",
                "पाहणे",
                "पाय",
                "पसरणे"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "झरा",
                "झाडे",
                "पक्षी",
                "पाऊस"
            ],
            "theme": "निसर्ग ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 1
        },
        {
            "words": [
                "तिरंगा",
                "फडकवणे",
                "स्तंभ",
                "मानवंदना"
            ],
            "theme": "झेंड्या बाबत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भोवरा",
                "आकाशगंगा",
                "पंखा",
                "वावटळ"
            ],
            "theme": "फिरणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "भूलभुलैया",
                "माया",
                "चकवा",
                "शोभादर्शक"
            ],
            "theme": "ज्यानी फसवणूक होते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भक्ती",
                "प्रवचन",
                "नामजप",
                "पारायण"
            ],
            "theme": " अध्यात्म ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मूर्ती",
                "कळस",
                "गाभारा",
                "प्रसाद"
            ],
            "theme": "देऊळ ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "उथळ",
                "पाणी",
                "खळखळाट",
                "फार "
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वरूण",
                "धो धो",
                "मेघ",
                "वीज"
            ],
            "theme": "पाऊस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाऊस",
                "वीज",
                "उल्का",
                "गारा"
            ],
            "theme": "आकाशातून पडणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "क्वार्टझ",
                "टायटन",
                "पट्टा",
                "वेळ"
            ],
            "theme": "वॉच",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "किरण",
                "सुहास",
                "चारु",
                "शीतल"
            ],
            "theme": "मराठी “यूनिसेक्स्” नावं",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नास्तिक",
                "सरफरोशी",
                "बॉम्ब",
                "फाशी"
            ],
            "theme": "भगतसिंग यांच्या जीवनाशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गांधी",
                " राजवाडा",
                "संग्रहालय",
                "स्थानबद्ध"
            ],
            "theme": "आगा खान पॅलेस",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "उंदीर",
                "वाघ",
                "रेडा",
                "गरुड"
            ],
            "theme": "देवतांची वाहने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तांबड",
                "झुंजुमुंजु",
                "किलबिल",
                "भूपाळी"
            ],
            "theme": "पहाट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "देव",
                "यम",
                "मेघ",
                "राम"
            ],
            "theme": "ज्यांना \"दूत\" जोडलेले शब्द आहेत (मेघदूत, ...)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अशोक स्तंभ",
                "तवा",
                "ऐरण",
                "घण"
            ],
            "theme": "लोह",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वीट",
                "मडकं",
                "देशी दारू",
                "कोळसा"
            ],
            "theme": "भट्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पद",
                "गट",
                "तट",
                "फूट"
            ],
            "theme": "राजकारणातल्या उचित अनुचित गोष्टी ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 1
        },
        {
            "words": [
                "आग",
                "पुणे",
                " काका",
                "बाजीराव"
            ],
            "theme": "पुणे स्थित शनिवार वाडा वास्तू संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कागद",
                "रंग",
                "पाणी",
                "ब्रश"
            ],
            "theme": "चित्रकला (पेंटिंग)",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "दिल्ली",
                "गोंधळ",
                "गल्ली",
                "मुजरा"
            ],
            "theme": "राजकारण आणि त्या आधारित चित्रपटाचे नाव ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 1
        },
        {
            "words": [
                "सकाळ",
                "हिंदू",
                "एक्सप्रेस",
                "सामना"
            ],
            "theme": "वृत्तपत्रे ज्यांच्या नावाचा दुसरा अर्थही होतो",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "परदेश",
                "घर",
                "आनंद",
                "माहेर"
            ],
            "theme": "ज्याच्यात राहता येतं अश्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दही",
                "ताडी",
                "पाव",
                "इडली"
            ],
            "theme": "आंबवलेले पदार्थ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "नंदा",
                "नाथा",
                "लखू",
                "गजा"
            ],
            "theme": "व्यक्ती आणि वल्ली' मधील काही व्यक्तिरेखा ",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वानर",
                "अस्वल",
                "गिधाड",
                "मृग"
            ],
            "theme": "रामायणात उल्लेख असलेले  प्राणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "झेब्रा",
                "जिराफ",
                "चित्ता",
                "तरस"
            ],
            "theme": "आफ्रिकेत आढळणारे प्राणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मगर",
                "कासव",
                "पाणघोडा",
                "बेडूक"
            ],
            "theme": "उभयचर प्राणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लिफाफा",
                " आंतरदेशीय",
                " खुशाली ",
                "मुद्रांक"
            ],
            "theme": "पत्रव्यवहार संबंधी ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "पाट",
                "सतरंजी",
                "खुर्ची",
                "मोडा"
            ],
            "theme": " यावर बसतात  ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "काख",
                "कळसा",
                "गाव",
                "वळसा "
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंक",
                "फराळ",
                "उटणं",
                "लक्ष्मी"
            ],
            "theme": "दिवाळी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "नाच",
                "येणे",
                "अंगण",
                "वाकडे"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "केदार",
                "आसावरी",
                "सारंग",
                "कल्याण"
            ],
            "theme": "काही राग",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वारा",
                "तापमान",
                " अतिवृष्टी",
                "चक्रीवादळ"
            ],
            "theme": "हवामानशास्त्र वेधशाळा आदींशी  संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "समुद्र",
                "जाळे",
                "होडी",
                "मासळी"
            ],
            "theme": "कोळ्याच्या जीवनाशी संबंधित ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "चतुर्दशी",
                "बिज",
                "बारस",
                "पूजन"
            ],
            "theme": "दिवाळीच्या दिवसांचे दुसरे शब्द प्रत्यय",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आधी",
                "पोट",
                "मग",
                "विठ्ठल"
            ],
            "theme": "एका मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "इकडे",
                "आड",
                "तिकडे",
                "विहीर"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सूर्यफूल",
                "जवस",
                "ऑलिव्ह",
                "शेंगदाणा"
            ],
            "theme": "तेल बिया ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पक्ष",
                " मत",
                " चिन्ह",
                "सभा"
            ],
            "theme": "निवडणूक ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 0
        },
        {
            "words": [
                "⁠व्यक्ती",
                " बटाटा",
                " तुजपाशी",
                "सुंदर"
            ],
            "theme": " पु. ल. देशपांडे यांच्या पुस्तकांच्या नावातील शब्द",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "चाखणे",
                "चावणे",
                "गिळणे",
                "खाणे"
            ],
            "theme": "खाण्याशी संबंधित क्रिया",
            "sharedBy": "AI प्रणाली",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मूर्ती",
                "मिरवणूक",
                "भाद्रपद",
                "आरती"
            ],
            "theme": "गणेशोत्सव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ग्वाल्हेर",
                "जयपूर",
                "मेवाती",
                "भेंडी बाजार"
            ],
            "theme": "हिंदुस्थानी शास्त्रीय संगीतातली घराणी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "नांगरणी",
                "रब्बी",
                "खरीप",
                "पेरणी"
            ],
            "theme": "कृषीशी निगडित संज्ञा",
            "sharedBy": "AI प्रणाली",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दव",
                "सुपारी",
                "भोजन",
                "चुना"
            ],
            "theme": "पानावर सापडणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "लता",
                "ममता",
                "गांधी",
                "गुलजार"
            ],
            "theme": "नेहेमी पांढरी वस्त्रे परिधान करणारे लोक ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वामकुक्षी",
                "पेन्शन",
                "नातवंडं",
                "निवृत्ती"
            ],
            "theme": "ज्येष्ठ नागरिक ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रियो",
                "ॲमेझॉन",
                "पोर्तुगिज",
                "फुटबॉल"
            ],
            "theme": "ब्राझील",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पिझ्झा",
                "गॅलेलियो",
                "फेरारी",
                "व्हेनीस"
            ],
            "theme": "ईटली",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सुशी",
                "फ्युजी",
                "टोयोटा",
                "बुलेट ट्रेन"
            ],
            "theme": "जपान",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काडेपेटी",
                "भिंग",
                "गारगोट्या",
                "लायटर"
            ],
            "theme": "ज्या गोष्टींनी आग पेटवता येते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "घोंगडं",
                "पाणी",
                "माती",
                "अग्नीरोधक"
            ],
            "theme": "ज्या गोष्टींनी आग विजवता येते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "स्वयंपाक",
                "समई",
                "भट्टी",
                "शेकोटी"
            ],
            "theme": "अग्नीचे ऊपयोग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उद्घाटनाची रिबिन",
                "पगार",
                "भाताचं पिक",
                "केस"
            ],
            "theme": "ज्या गोष्टी कापल्या जातात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चाकू",
                "विळी",
                "करवत",
                "खुर्पं"
            ],
            "theme": "ज्या गोष्टी कापतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "शल्यविशारद",
                "शिंपी",
                "पाकीटमार",
                "स्वयंपाकी"
            ],
            "theme": "ज्यांच्या व्यवसायांत कापावे लागते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तोरण",
                "राखी",
                "मुंडावळ्या",
                "नाडी"
            ],
            "theme": "गाठ घालून बांधण्याच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "हार",
                "टायर",
                "मेदूवडा",
                "बांगडी"
            ],
            "theme": "लूप / नेढे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "चष्मा",
                "टक्कल",
                "हातमाग",
                "पांढरे धोतर"
            ],
            "theme": "महात्मा गांधी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ध्रुव",
                "गंगोत्री",
                "दक्षिण",
                "पेंगविन"
            ],
            "theme": "अंटार्क्टिका",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "व्याध",
                "अभिजित",
                "सूर्य",
                "अरुंधती"
            ],
            "theme": "तारे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सिंह",
                "मासे",
                "तराजू",
                "जोडपे"
            ],
            "theme": "राशी चिन्हे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पार्टी",
                "आतिषबाजी",
                "लाईटींग",
                "सोहळा"
            ],
            "theme": "सेलिब्रेशन, समारंभ, साजरा करणे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "स्पेशल",
                "प्रजासत्ताक दिन",
                "पुढले वर्ष",
                "मॅराथॉन"
            ],
            "theme": "२६ (सव्वीस)  - चित्रपट, वर्ष, मैल वगैरे ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ॲटलास",
                "क्रेन",
                "मल्लेश्वरी",
                "जॅक"
            ],
            "theme": "जड गोष्टी उचलणारे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नवीन",
                "मलम",
                "सरस",
                "सामोसा"
            ],
            "theme": "Palindromes (विलोमपदॆ)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "बारामती",
                "सुलक्षणी",
                "पराकोटी",
                "कासावीस"
            ],
            "theme": "\"संख्याशाली\" शब्द (शब्दांत एक संख्या लपलेली )",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "टाचणी",
                "नांगर",
                "सरळ नाक",
                "खिळा"
            ],
            "theme": "टोकदार गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिमिर",
                "मॆत्र",
                "सोयरे",
                "चेतना"
            ],
            "theme": "अजरामर \"पसायदाना\"तले शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "हिम",
                "कार्य",
                "विद्या",
                "रुग्ण"
            ],
            "theme": "यांची घरे (आलये) आहेत",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "रात्र",
                "राजा",
                "राग",
                "राहू"
            ],
            "theme": "रा' ने सुरू होणारे शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नवजीवन",
                "सकस",
                "कडक",
                "समास"
            ],
            "theme": "Palindromes, of course! (विलोमपदॆ)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "राम",
                "पॆसा",
                "तथ्य",
                "हेतू"
            ],
            "theme": "\"अर्था\"चे अनेक पर्यायी शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "बांधवगड",
                "कॉर्बेट",
                "पेरियार",
                "काझिरंगा"
            ],
            "theme": "नॅशनल पार्क",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कांचीपुरम",
                "रामेश्वर",
                "मीनाक्षी",
                "कावेरी"
            ],
            "theme": "तामिळनाडू",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "सुरत",
                "आनंद",
                "दांडी",
                "मोरबी"
            ],
            "theme": "गुजरात मधली गावे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "संक्षिप्त",
                "आकुंचन",
                "शुष्क",
                "केंद्रित"
            ],
            "theme": "कमी होणे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शांती श्लोक",
                "डेझर्ट खाणे",
                "रात्रीची झोप",
                "विसर्जन"
            ],
            "theme": "एखाद्या गोष्टीच्या शेवटी करायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मूळ",
                "हलवा",
                "ससा",
                "लाल"
            ],
            "theme": "गाजर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ईश्वर",
                "आत्मा",
                "वीर",
                "अणू"
            ],
            "theme": "ज्यांच्या आधी \"परम\" जोडलेले शब्द आहेत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंडं",
                "नारळ",
                "फुगा",
                "अमेरिकन फुटबॉल"
            ],
            "theme": "अंडाकृती गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दोरखंड",
                "जॅकेट",
                "काटेरी बूट",
                "धाडसीपणा"
            ],
            "theme": "ऐस माऊंटेनीयरींग ला लागणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भुयार",
                "विहीर",
                "तळघर",
                "खाण"
            ],
            "theme": "जमिनीत खोदून केलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वाईन",
                "जंतुनाशक",
                "व्यसन",
                "ज्वलनशील "
            ],
            "theme": "अल्कोहोल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ढोल",
                "वीज",
                "सायरन",
                "फटाका"
            ],
            "theme": "मोठा आवाज करणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "काथ्या",
                "खराटा",
                "करवंटी",
                "कॉयर"
            ],
            "theme": "नारळाच्या झाडापासून बनवलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लखोबा",
                "राधेश्शाम",
                "दिवाकर",
                "अशोक"
            ],
            "theme": "लोखंडे, महाराज, दातार, परांजपे -- छे, छे, तो मी नव्हेच!",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्रस्थ",
                "स्वप्न",
                "क्रुद्ध",
                "व्रात्य"
            ],
            "theme": "दोन जोडाक्षरांचे शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "ओतप्रोत",
                "उदंड",
                "ओसंडून",
                "तुडुंब"
            ],
            "theme": "अती, खूप जास्त   ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "डॉन",
                "राहीन",
                "सीन",
                "थेम्स"
            ],
            "theme": "युरोपियन नद्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मैफल",
                "मेंदी",
                "स्वप्नं",
                "संध्याकाळचं आकाश"
            ],
            "theme": "ज्या गोष्टी रंगतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ततकार",
                "तोडा",
                "मुद्रा",
                "चक्कर"
            ],
            "theme": "कथ्थक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धर्म",
                "ग्लानी",
                "भारत",
                "यदा"
            ],
            "theme": "यदा यदा ही धर्मस्य...",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "साधु",
                "विनाश",
                "संभव",
                "युग"
            ],
            "theme": "परितत्राणाय साधूनां .... ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "देवदत्त",
                "अनंतविजय",
                "सुघोष",
                "मणिपुष्पक"
            ],
            "theme": "पांडवांच्या शंखांची नावे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घोडा",
                "हॅट",
                "पिस्तूल ",
                "बूट"
            ],
            "theme": "काऊबॉय संबंधी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ठाकुर",
                "बसंती",
                "विरु",
                "जय"
            ],
            "theme": "शोले सिनेमातील पात्रे ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दोस्ती",
                "मेहबुबा",
                "होली",
                "हसिना"
            ],
            "theme": "शोले सिनेमातल्या गाण्यांमधले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "करोड ",
                "राष्ट्र ",
                "गण",
                "सेना "
            ],
            "theme": "ज्यांना \"पती\" जोडता येतं ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शांती ",
                "शिव ",
                "वानर",
                "वायू "
            ],
            "theme": "ज्यांना \"सेना\" जोडता येतं ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "हिरा ",
                "धूमकेतू ",
                "हॅट ट्रीक",
                "प्लॅटिनम "
            ],
            "theme": "दुर्मिळ गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दही ",
                "पाणी ",
                "ओम ",
                "कोल्हा "
            ],
            "theme": "ज्यांना \"पुरी\" जोडून शब्द आहेत ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चहा ",
                "सिल्क ",
                "कुंगफू",
                "कागद "
            ],
            "theme": "चीन मध्ये उत्पत्ती झालेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "किमची",
                "गंगनम",
                "तायक्वांदो",
                "ह्युनडाई"
            ],
            "theme": "साऊथ कोरिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छाती ",
                "खिळा ",
                "तंबू",
                "थाप"
            ],
            "theme": "ज्या गोष्टी ठोकता येतात ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कठडा ",
                "जर ",
                "कुंपण ",
                "समास/मार्जिन"
            ],
            "theme": "एखाद्या गोष्टीच्या बाजूने असलेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वय",
                "नखं",
                "लोकसंख्या",
                "केस "
            ],
            "theme": "कायम वाढणाऱ्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बटाटा ",
                "टोमॅटो ",
                "पेरू ",
                "काजू "
            ],
            "theme": "दक्षिण अमेरिकेत उत्पत्ती झालेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गोपूर",
                "मंडप",
                "गाभारा",
                "मूर्ती"
            ],
            "theme": "मंदिराचे भाग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मुकुट",
                "टोपली",
                "ओझं",
                "टोपी"
            ],
            "theme": "डोक्यावर ठेवता येणाऱ्या गोष्टी  ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चिंब",
                "श्रावण ",
                "धारा",
                "छत्री"
            ],
            "theme": "पाऊस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बिंब",
                "होळी",
                "ससा",
                "रोमँटिक"
            ],
            "theme": "पोर्णिमेचा चंद्र",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "टिंब",
                "पूर्णविराम",
                "कुंकू ",
                "तीळ"
            ],
            "theme": "ठिपका",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जुगार",
                "तंबाखू",
                "रील",
                "खरेदी"
            ],
            "theme": "व्यसने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शेयर्स",
                "कर्ज",
                "गहाण ठेव",
                "वेठबिगारी"
            ],
            "theme": "भांडवल उभं करण्याची साधने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "विपणन",
                "विक्री",
                "आयटी",
                "वित्त"
            ],
            "theme": "कंपनीतील विभाग (डिपार्टमेंटस्)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काटकोन",
                "वर्ग",
                "ग्रीस",
                "सिद्धांत "
            ],
            "theme": "पायथॅगोरस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "क्वांटम",
                "मांजर",
                "वेव्ह",
                "संभाव्यता"
            ],
            "theme": "श्रोडिंगर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ऑडिओ उपकरणे",
                "आईन्स्टाईन कंडेंन्सेट ",
                "पद्म विभूषण",
                "बोझॉन"
            ],
            "theme": "बोस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "राहुल",
                "राजीव",
                "फिरोझ",
                "संजय"
            ],
            "theme": "गांधी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शक्ती",
                "महेंद्र ",
                "अनिल",
                "संजीव "
            ],
            "theme": "कपूर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "जहांगीर",
                "रतन",
                "नवल",
                "दोराब"
            ],
            "theme": "टाटा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "करनम",
                "लोवलीना",
                "साक्षी",
                "मीराबाई"
            ],
            "theme": "भारतीय ऑलिंपिक पदक विजेत्या स्त्रिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अल्का",
                "उषा",
                "श्रेया",
                "अनुराधा"
            ],
            "theme": "हिंदी गायिका ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "लक्ष्मी",
                "अहिल्या",
                "तारा",
                "दुर्गावती"
            ],
            "theme": "शूर ऐतिहासिक राण्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सत्यभामा",
                "भद्रा",
                "रुक्मिणी ",
                "कालिंदी"
            ],
            "theme": "कृष्णाच्या पत्नी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "सुप्रिया",
                "ललिता",
                "ममता",
                "सुषमा"
            ],
            "theme": "स्त्री राजकारणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आशा",
                "शर्मिला",
                "माला",
                "साधना"
            ],
            "theme": "1960s मधल्या हिन्दी अभिनेत्री ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जना",
                "सखु",
                "मुक्ता",
                "मीरा"
            ],
            "theme": "स्त्री संत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रेखा",
                "सुष्मिता",
                "अमिशा",
                "कंगना"
            ],
            "theme": "अविवाहीत हिंदी अभिनेत्री ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "रंजना",
                "सीमा ",
                "चित्रा",
                "आशा "
            ],
            "theme": "जुन्या काळातल्या मराठी अभिनेत्री",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सरस",
                "कारीका",
                "मलम",
                "नयन"
            ],
            "theme": "Palindromes (विलोमपदॆ)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "टॉनिक ",
                "अंडं",
                "दुध ",
                "डिंकाचे लाडू"
            ],
            "theme": "पौष्टिक पदार्थ ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "साबण ",
                "बियर ",
                "समुद्राची लाट ",
                "सोडा "
            ],
            "theme": "फेस येणार्‍या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुर्बीण ",
                "बासरी ",
                "पुंगळी ",
                "पेने पास्ता"
            ],
            "theme": "पोकळ दंडगोलाकार वस्तु ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दृष्टी",
                "श्रवण",
                "स्पर्श",
                "चव"
            ],
            "theme": "ज्ञानेंद्रिये",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "देखावा",
                "संगीत ",
                "रेशीम ",
                "मसाला"
            ],
            "theme": "पंचेंद्रियांना सुखकारक गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दहा",
                "क्ष किरणे",
                "चूक",
                "गुणाकार"
            ],
            "theme": "X",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पतंग ",
                "विमान ",
                "डॉल्फिन ",
                "हनुमान"
            ],
            "theme": "शेपटी असलेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "फुलबाजी",
                "जातं",
                "सुकाणू ",
                "आरती"
            ],
            "theme": "हाताने गोल फिरवलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तोठरा",
                "गायन",
                "थायरॉईड",
                "मंगळसूत्र "
            ],
            "theme": "गळ्या संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "टिचकी",
                "अंगठी",
                "नखं",
                "सतार वादन"
            ],
            "theme": "बोटां संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मधुचंद्र ",
                "निरोप",
                "स्वागत समारंभ",
                "हुश्श्य"
            ],
            "theme": "लग्न कार्या नंतर करायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गोकर्ण",
                "उडुपी",
                "जोग",
                "मंगलोर "
            ],
            "theme": "कोस्टल कर्नाटक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चामुंडी",
                "पाक",
                "पॅलेस",
                "चंदन"
            ],
            "theme": "मैसूर संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दूध",
                "कामधेनू",
                "गवत",
                "रवंथ"
            ],
            "theme": "गाई संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हवेली",
                "भोर",
                "मावळ",
                "खेड"
            ],
            "theme": "पणे जिल्ह्यातील तालुके",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "वाडा",
                "अर्धा दिवस",
                "सॅटर्न",
                "ओंकारेश्वर मंदिर "
            ],
            "theme": "शनिवार संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "लाल",
                "ताज",
                "हवा",
                "मोती"
            ],
            "theme": "‐ महाल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्वार",
                "पेरू",
                "इंडिया",
                "चर्च"
            ],
            "theme": "- गेट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पंचवटी",
                "वेताळ",
                "तळजाई",
                "हनुमान"
            ],
            "theme": "पुण्यातल्या टेकड्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भस्म",
                "भोळा",
                "तप",
                "गंगा"
            ],
            "theme": "शंकरा संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सतगुरु",
                "जमशेटजी",
                "सांता क्लाॅज",
                "मोदी"
            ],
            "theme": "पांढरी दाढी वाले",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रामदेव ",
                "साई",
                "अली",
                "आई"
            ],
            "theme": "- बाबा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पेस्तन काका",
                "भाभा",
                "वाडिया",
                "सॅम बहाद्दुर"
            ],
            "theme": "पारसी लोकं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "येसूबाई",
                "छावा",
                "तुळापूर",
                "शिवाजी"
            ],
            "theme": "संभाजी संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "हुबळीकर",
                "शेळके",
                "कार्टं",
                "बाई"
            ],
            "theme": "शांता संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "महेश",
                "काजळ",
                "पैसे",
                "कारनामे"
            ],
            "theme": "काळे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंचल",
                "शीतल ",
                "निर्मल",
                "कोमल"
            ],
            "theme": "\"सत्यम शिवम् सुंदरम\" मधिल गाण्याचे बोल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "खैबर",
                "पावन",
                "सिंबायोसिस ",
                "शेलार"
            ],
            "theme": "खिंड",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "योग",
                "चित्त",
                "वृत्ती",
                "निरोध"
            ],
            "theme": "पतंजली योगसूत्रातील दुसर्‍या वाक्यातील शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विधी",
                "रुद्र",
                "बच्चन",
                "पंचामृत"
            ],
            "theme": "अभिषेक ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अक्रोड",
                "रुद्राक्षं",
                "सफरचंद",
                "जरदाळू "
            ],
            "theme": "हिमालयात उगवणारी फळे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पोहे",
                "कढिपत्ता",
                "फोडणी",
                "दाणे"
            ],
            "theme": "चिवड्याचे घटक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कालि",
                "राम",
                "यशु",
                "तुलसी"
            ],
            "theme": " - दास नावाच्या प्रसिद्ध व्यक्ती",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गरम तेल",
                "कृष्ण ",
                "आगाशे",
                "गांधी"
            ],
            "theme": "मोहन",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ताडदेव",
                "शीव",
                "फोर्ट",
                "प्रभादेवी"
            ],
            "theme": "मुंबईचे भाग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मत",
                "सत्ता",
                "शाही",
                "मान्य"
            ],
            "theme": "लोक - ...",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पदर",
                "शबनम",
                "डोली",
                "झोळी"
            ],
            "theme": "खांद्यावर घ्ययच्या / टांगायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "फटका",
                "बांबू",
                "पाण्यात",
                "वाया"
            ],
            "theme": "पैसे गमावणे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चिवडा",
                "लाडू",
                "चकली",
                "करंजी"
            ],
            "theme": "दिवाळीचे पदार्थ ",
            "sharedBy": "शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तिळगुळ",
                "पतंग",
                "काळे कपडे",
                "मकर"
            ],
            "theme": "संक्रांत ",
            "sharedBy": "स्नेहा",
            "difficulty": 1
        },
        {
            "words": [
                "पानं",
                " छपाई ",
                " मूल्य",
                " मुखपृष्ठ"
            ],
            "theme": "पुस्तक",
            "sharedBy": "शिरीष केळकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुलकेशी",
                " हर्षवर्धन",
                " समुद्रगुप्त",
                " ललितादित्य"
            ],
            "theme": "पहिले सहस्रक",
            "sharedBy": "विकास पाटणकर",
            "difficulty": 0
        },
        {
            "words": [
                "समीकरण",
                " कर्ण",
                " कंस",
                " सूत्र"
            ],
            "theme": "गणित!",
            "sharedBy": "नुपुरा डोरले",
            "difficulty": 1
        },
        {
            "words": [
                "जम",
                "घसा",
                "तबलजी",
                "धक्का"
            ],
            "theme": "बसणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लोह",
                "सिंह ",
                "राज",
                "बांधव"
            ],
            "theme": "- गड",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "यष्टी",
                "झेल",
                "कप्तान",
                "पंच"
            ],
            "theme": "क्रिकेट मधील संज्ञा",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 1
        },
        {
            "words": [
                "शमी",
                "सुंदर",
                "विराट",
                "यशस्वी"
            ],
            "theme": "क्रिकेटपटूंची नावे ",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चिंचोका",
                "चॉकलेट ",
                "शिसवी लाकूड",
                "खजूर "
            ],
            "theme": "चॉकलेटी रंगाच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "जहाज ",
                " लाकूड ",
                " तेल ",
                " कापूस"
            ],
            "theme": "पाण्यावर तरंगणाऱ्या गोष्टी",
            "sharedBy": "कौशिक कुलकर्णी ",
            "difficulty": 1
        },
        {
            "words": [
                "बेल",
                "तुळस",
                "आघाडा",
                "दुर्वा"
            ],
            "theme": "देवाला वाहायची पाने",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नारळ",
                "विहीर ",
                "डोळे",
                "निवडुंग"
            ],
            "theme": "ज्यात पाणी असते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "धंदा",
                "हवा",
                "तेल",
                "औषध "
            ],
            "theme": "या शब्दांना \"पाणी\" जोडतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "जळगांवकर",
                "भाता",
                "सूर",
                "रीड"
            ],
            "theme": "हार्मोनियम",
            "sharedBy": "शिरीष केळकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रेडा",
                "गुराखी",
                "पु. ल.",
                "दुध "
            ],
            "theme": "म्हैस संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ओंजळ ",
                "नव्याण्णव ",
                "ऑक्सिजन (O2) ",
                "टाळी"
            ],
            "theme": "दोन समान गोष्टीतून जोडून केलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "उडी",
                "सागर",
                "कमला",
                " जन्मठेप"
            ],
            "theme": "सावरकर",
            "sharedBy": "नुपुरा डोरले",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हळद",
                "टॅल्कम",
                "त्रिफळा",
                "गुलाल"
            ],
            "theme": "पूड, चूर्ण ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "नाका",
                "नस",
                "तट",
                "जमाव"
            ],
            "theme": "--- बंदी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "समुद्र ",
                " हवा ",
                " रस्ते ",
                " रूळ"
            ],
            "theme": "वाहतूकीचे मार्ग ",
            "sharedBy": "कौशिक कुलकर्णी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हस्त",
                "स्वाती",
                "मृग",
                "रेवती"
            ],
            "theme": "नक्षत्र",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 0
        },
        {
            "words": [
                "कंठ",
                "कटी",
                "नेत्र",
                "कर्ण"
            ],
            "theme": "अवयव",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 1
        },
        {
            "words": [
                "द्रोण",
                "कृप",
                "धर्म",
                "गंगा"
            ],
            "theme": "महाभारत व्यक्तिरेखा",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेळा",
                "विवाह",
                "रास",
                "कर्ण"
            ],
            "theme": "कुंभ---",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बाजू",
                "पंधरवडा",
                "संघटना",
                "पंख"
            ],
            "theme": "पक्ष चे विविध अर्थ",
            "sharedBy": "समीर जोशी ",
            "difficulty": 1
        },
        {
            "words": [
                "लस",
                "सुई",
                "कान",
                "काटा"
            ],
            "theme": "टोचायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "यष्टी",
                "झेल",
                "कप्तान",
                "पंच"
            ],
            "theme": "क्रिकेट मधील संज्ञा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "आरती",
                " आश्रम",
                "परिक्रमा",
                " कन्यापूजन"
            ],
            "theme": "नर्मदा  परिक्रमा",
            "sharedBy": "अनघा अनिल जोशी",
            "difficulty": 1
        },
        {
            "words": [
                "पोलीस ",
                "जेम्स बॉण्ड",
                "मूळ बिंदू (origin)",
                "शतक"
            ],
            "theme": "शून्य शून्य (दोन शून्यांचा समावेश)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "केदार",
                " मधुवंती",
                " मालकंस",
                "भूप"
            ],
            "theme": "हिंदुस्थानी संगीत राग",
            "sharedBy": "नुपुरा डोरले",
            "difficulty": 0
        },
        {
            "words": [
                "कट",
                "पॅक उप",
                "टेक",
                "रोल"
            ],
            "theme": "फिल्म शूटिंग करताना वापरात येणारे शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वर",
                "पाक",
                "भू",
                "चलित"
            ],
            "theme": "स्वयं __",
            "sharedBy": "समीर जोशी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तर्री",
                "पेज",
                "शोर्बा",
                "सॅम्पल "
            ],
            "theme": "पातळ खाद्य पदार्थ ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कान",
                "नाग",
                "जय",
                "खड्ग"
            ],
            "theme": " -- पूर नावाची भारतातील प्रसिद्ध गावे ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "रवा ",
                " साखर ",
                " तूप ",
                " काजू"
            ],
            "theme": "शिऱ्याचे घटक",
            "sharedBy": "कौशिक कुलकर्णी",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इन्दु",
                "मृगांक",
                " सुधांशु",
                " सोम"
            ],
            "theme": "चंद्राची काही नावे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "रस",
                "गोडी",
                "रुची",
                "कल"
            ],
            "theme": "स्वारस्य या अर्थी",
            "sharedBy": "समीर जोशी ",
            "difficulty": 1
        },
        {
            "words": [
                "भरती",
                "ओहोटी",
                "ग्रहण",
                "अपोलो"
            ],
            "theme": "चंद्र कारणीभूत असणाऱ्या काही गोष्टी  ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्राण",
                "जीवन ",
                "प्रेम ",
                "शक्ती"
            ],
            "theme": "जुन्या हिंदी चित्रपटांमधील खलनायक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "जंगल",
                "लूट",
                "पंडित",
                "गुरु"
            ],
            "theme": "भारतीय उत्पत्तीचे इंग्रजीत वापरले जाणारे शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "हिरकणी",
                " टकमक",
                " छत्रपती",
                " राजधानी"
            ],
            "theme": "किल्ले रायगड",
            "sharedBy": "विवेक वासुदेव चितळे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाचू",
                "पुष्कराज",
                "माणिक",
                "नीलम"
            ],
            "theme": "मौल्यवान रत्ने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पाखरू",
                " बाजी",
                " झाडे",
                " वडी"
            ],
            "theme": "फूल उपसर्ग लागून अर्थपूर्ण शब्द",
            "sharedBy": "आहना आगाशे",
            "difficulty": 1
        },
        {
            "words": [
                "लता",
                "सुमन",
                "किशोरी",
                "आशा"
            ],
            "theme": "प्रसिद्ध गायिका",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंतुले",
                " पवार",
                " राणे",
                " नाईक"
            ],
            "theme": "महाराष्ट्राचे माजी मुख्यमंत्री",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "ठोसर",
                " रेळेकर",
                " आंबिले",
                " कुलकर्णी"
            ],
            "theme": "महाराष्ट्रातील प्रसिद्ध संतांची आडनावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "राम",
                "सिद्ध",
                "हाय",
                "मिस"
            ],
            "theme": "--- टेक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पिंड",
                "भोज्जा",
                "आभ्रे",
                "कपडे"
            ],
            "theme": "शिवण्याच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "माल",
                "भाऊ",
                "वीज ",
                "आश्चर्य "
            ],
            "theme": "‐‐- चा धक्का",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "घोडा",
                "लोट",
                "चक्की",
                "चट"
            ],
            "theme": "पाण ---",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धोबी",
                "खंबाटकी ",
                "मणिकर्णिका ",
                "अंबा"
            ],
            "theme": "--- घाट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पाचगणी",
                " सप्तशृंगी",
                " हजारीबाग",
                " सोलापूर"
            ],
            "theme": "नावात अंक असलेली शहरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "गंज",
                "पूर",
                "बाद",
                "वाडी"
            ],
            "theme": "गावांच्या नावांचे शेवट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दमयंती ",
                "शकुंतला ",
                "मेनका,",
                "चित्रलेखा"
            ],
            "theme": "राजा रवी वर्मा यांच्या चित्रातील स्त्रिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अंबिका",
                "गंगा",
                "सत्यवती",
                "माद्री"
            ],
            "theme": "महाभारत पूर्वार्धातील स्त्रिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "द्रौपदी",
                " उलुपी",
                " चित्रांगदा",
                " सुभद्रा"
            ],
            "theme": "महाभारतातील अर्जुन पत्नी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मीठ",
                "सुरमई ",
                "मोती",
                "पोवळं"
            ],
            "theme": "समुद्रात अढळणार्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कोशी",
                "अलकनंदा ",
                "पद्मा",
                "गोमाती"
            ],
            "theme": "गंगेला डाव्याबाजूने मिळणार्या नद्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मयुराक्षी",
                "सोने",
                "काली ",
                "दामोदर"
            ],
            "theme": "गंगेला उजव्याबाजूने मिळणार्या नद्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सोनल",
                "रोहिणी",
                "मल्लिका",
                "शोभना"
            ],
            "theme": "प्रसिद्ध शास्त्रीय नृत्यांगना",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दौंड",
                " पुरंदर",
                " हवेली",
                " इंदापूर"
            ],
            "theme": "पुणे जिल्ह्यातील तालुके",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "फडणवीस",
                " बावनकुळे",
                " सातपुते",
                " आठवले"
            ],
            "theme": "नावात अंक असलेली आडनावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढोबळी मिरची",
                "द्राक्षं",
                "सफरचंद ",
                "टोमॅटो "
            ],
            "theme": "दोन, तीन वा अधिक वेगवेगळ्या रंगात येणाऱ्या भाज्या/फळं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कांदा ",
                "बटाटा ",
                "पालक ",
                "मिरची "
            ],
            "theme": "ज्याची भजी केली जातात ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आवकाडो",
                "ऑलिव्ह",
                "ब्रोकोली",
                "चेरी"
            ],
            "theme": "आजकाल मंडईत सर्रास मिळणारी परदेशी भाज्या/फळं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कर्क",
                "ह्रदय ",
                "क्षय",
                "कृष्ठ"
            ],
            "theme": "--- रोग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गळ",
                "पतंग",
                "सुई",
                "भवरा"
            ],
            "theme": "ज्यानां लांब दोरा लावतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "व्यायाम",
                "ताप",
                "कॉफी ",
                "भीती"
            ],
            "theme": "हृदयची गती वाढवणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भितीदायक स्वप्न",
                "कडाडणारी वीज",
                "सळसळणारा साप",
                "किंकाळी"
            ],
            "theme": "दचकवणार्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "नेत्याचं भाषण ",
                "सिनेमातील हीरोगीरी",
                "सैनिकांची वीरता",
                "दुसर्‍याचे यश"
            ],
            "theme": "प्रोत्साहित करणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "कार्टून",
                "निवडक पु. ल.",
                "गुदगुल्या",
                "नायट्रस ऑक्साईड (N2O)"
            ],
            "theme": "हसवणार्या गोष्टी (N2O - Laughing Gas)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाऊन",
                "हस्तांदोलन ",
                "पदवी",
                "चौकोनी टोपी"
            ],
            "theme": "दीक्षांत समारंभ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "भव्य इमारती",
                "प्राध्यापक",
                "ग्रंथालय ",
                "उच्च शिक्षण "
            ],
            "theme": "विद्यापीठ ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "परीक्षा",
                "अर्ज",
                "शुल्क",
                "बारावी पास "
            ],
            "theme": "विद्यापीठात प्रवेश मिळवण्यासाठी लागणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चेन्नई",
                " धाराशिव",
                "प्रयागराज",
                " अहिल्यानगर"
            ],
            "theme": "नामांतरीत शहरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सहन",
                " स्मरण",
                " स्त्री",
                " महा"
            ],
            "theme": " ___ शक्ती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "विंध्य",
                " गंगा",
                " मराठा",
                " गण"
            ],
            "theme": "राष्ट्रगीतातील शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुट्टी",
                " ऊन",
                " हापूस",
                " पंखा"
            ],
            "theme": "उन्हाळा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मोहरी",
                " जवस",
                " सोयाबीन",
                " एरंड"
            ],
            "theme": "तेलबिया",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चित्र",
                " हाहा",
                " कला",
                " चर्म"
            ],
            "theme": "____ कार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ताक",
                "बेसन",
                "कढीपत्ता",
                "आलं"
            ],
            "theme": "कढीतले पदार्थ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "फ्लावर",
                "बटाटा",
                "ढोबळी मिरची ",
                "मटार"
            ],
            "theme": "पावभाजीतील पदार्थ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मेथी",
                "पालक",
                "आळू",
                "चाकवत"
            ],
            "theme": "ज्यांची पातळ भाजी बनवतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रंग",
                " सूर",
                " ऋषी",
                " सिंधू"
            ],
            "theme": "सप्त ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "वड",
                " माले",
                " जळ",
                " माझ"
            ],
            "theme": "___ गाव",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "पाल",
                " देव",
                " घर",
                " लाड"
            ],
            "theme": "_____घर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खास",
                "जरूर ",
                "तुफान ",
                "कैद"
            ],
            "theme": "अरबी भाषेतून मराठीत आलेले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ऑफिस ",
                "फोन",
                "बिस्किट ",
                "फोटो"
            ],
            "theme": "इंग्रजी भाषेतून मराठीत आलेले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अक्का",
                "चप्पल ",
                "बांगडी",
                "किल्ली"
            ],
            "theme": "कानडी भाषेतून मराठीत आलेले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तीर",
                " पात्र",
                " वाळू",
                " घाट"
            ],
            "theme": "नदी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "वतन",
                " ठाणे",
                " दम",
                " दुकान"
            ],
            "theme": "____दार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अशोकस्तंभ",
                " गीर",
                " सिंबा",
                " छावा"
            ],
            "theme": "सिंह",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सिंघम",
                " खाकी",
                " चौकी",
                " गस्त"
            ],
            "theme": "पोलिस",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गांधी",
                " रॉय",
                " बोस",
                " शाहरुख"
            ],
            "theme": "राहुल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मीना",
                " तेजस",
                " बाळ",
                " श्रीकांत"
            ],
            "theme": "ठाकरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आदित्य",
                " मुकेश",
                " राहुल",
                " रतन"
            ],
            "theme": "उद्योग समूह प्रमुख",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "राज",
                " समाज",
                " अर्थ",
                " विना"
            ],
            "theme": "__ कारण",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मीना",
                " तेजस",
                " बाळ",
                " श्रीकांत"
            ],
            "theme": "ठाकरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लीला",
                " गरबा",
                " ढीग",
                " मेष"
            ],
            "theme": "रास",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पूजा",
                "ऋषी",
                " दार",
                " दास"
            ],
            "theme": "देव ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रेखा",
                " उर्मिला",
                " सौमित्र",
                " शेष"
            ],
            "theme": "लक्ष्मण",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हात गाडी",
                "टोपली",
                "ठेला",
                "पथारी"
            ],
            "theme": "भाजी विक्रेत्यांची साधने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रुखवत ",
                "डाव",
                "हिशेब ",
                "पंगत"
            ],
            "theme": "मांडता येणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पद्म",
                " वज्र",
                " हल",
                " शीर्ष"
            ],
            "theme": "___आसन",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गदा",
                " त्रिशूल",
                " खड्ग",
                " परशू"
            ],
            "theme": "अस्त्रे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "अंकुश",
                " पाश",
                " मोदक",
                " आशीर्वाद"
            ],
            "theme": "गणपती चे चार हात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "खजूर",
                "उजाड ",
                "वाळू",
                "निवडुंग"
            ],
            "theme": "वाळवंटाची वैशिष्ट्य ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुबई ",
                "पॅरिस ",
                "टोकिओ ",
                "क्वालालंपूर"
            ],
            "theme": "प्रसिद्ध टॉवर असलेली शहरे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "भिंत",
                "प्रगती",
                "साम्यवाद",
                " अलीबाबा"
            ],
            "theme": "चीन",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "लामा",
                " मेटा",
                " जेमिनी",
                "जीपीटी"
            ],
            "theme": "एआय मॉडेल्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नामंजूर",
                " मोर्चा",
                " दिवस",
                " आयुष्य"
            ],
            "theme": "संदीप खरे गाणी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "लाल",
                " मृत",
                " अरब",
                " बंगाल"
            ],
            "theme": "समुद्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दिल",
                " कस",
                " वजन",
                " भर"
            ],
            "theme": "___ दार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्फूर्ती",
                " वेदना",
                " दिलासा",
                " आल्हाद"
            ],
            "theme": "____दायक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "राज",
                " सिंह",
                " देव",
                " हरिश्चंद्र"
            ],
            "theme": "___ गड",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वाघ",
                " उंदीर",
                " मोर",
                " ऐरावत"
            ],
            "theme": "देवांची वाहने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंद्र",
                " गंगा",
                " साप",
                " नंदी"
            ],
            "theme": "शंकराशी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेटी",
                " मेंढी",
                " भुई",
                " कडे"
            ],
            "theme": "__ कोट",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "ढील",
                " शेपूट",
                "बेंजामिन फ्रँकलिन ",
                "मांजा"
            ],
            "theme": "पतंग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंगठी",
                " बांगडी",
                " हातमोजा",
                " घड्याळ"
            ],
            "theme": "हातात घालायच्या वस्तू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हातमोजे",
                "चाकू",
                "प्रखर दिवे",
                "मास्क"
            ],
            "theme": "सर्जन",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "लाल",
                "मोहर",
                "पेटी",
                "सिल बंद"
            ],
            "theme": "लाख",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नेम",
                "सहा",
                "गब्बर ",
                "कट्टा"
            ],
            "theme": "पिस्तूल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ऊब",
                "दुध",
                "झोप",
                "प्रेम"
            ],
            "theme": "तान्ह्या बळाला गरजेच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अग्नी",
                "पातेलं",
                "साखर",
                "हळद"
            ],
            "theme": "स्वयंपाकघरात अढळणार्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाग",
                "ऋषि",
                "रंग",
                "वसंत"
            ],
            "theme": "---पंचमी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कट",
                "जवळ",
                "रण",
                "चीड"
            ],
            "theme": "मागोमाग दोनदा वापरता येणारे शब्द",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "शॉवर",
                "हत्ती",
                "कारंजे ",
                "अग्निशमन दल"
            ],
            "theme": "पाण्याचा फवारा मारणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सोडा",
                "टूथपेस्ट ",
                "समुद्राची लाट",
                "डिटर्जंट"
            ],
            "theme": "फेस येणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मूर्ती",
                "समई ",
                "घंटा",
                "बिगुल"
            ],
            "theme": "पितळ्याच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वाटा",
                "आंब्याच्या फोडी",
                "खडी",
                "चिंध्या"
            ],
            "theme": "एखाद्या गोष्टीचे तुकडे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "माहीम ",
                "दुधी",
                "मुग",
                "बदामी"
            ],
            "theme": "हलवा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "राजस्थान ",
                "इराण ",
                "ईजिप्त ",
                "ॲरिझोना"
            ],
            "theme": "वाळवंटी प्रदेश ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "प्रेम ",
                "विहीर ",
                "विचार",
                "संकट"
            ],
            "theme": "ज्यात पडता येतं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाणी",
                "उपास",
                "गाठ",
                "बाण"
            ],
            "theme": "ज्या गोष्टी सोडता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "फांदी",
                "झेंडा",
                "केस",
                "ढग"
            ],
            "theme": "वार्‍याने हलणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "धूर",
                "प्लास्टिक ",
                "आवाज",
                "औद्योगिक रसायने"
            ],
            "theme": "प्रदुषण कारक गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "औषध ",
                "विश्रांती",
                "मोसंबी ",
                "धीर"
            ],
            "theme": "आजारी व्यक्तिला द्यायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ओला कचरा",
                "पेट्री डिश",
                "ईडलीचे पीठ",
                "पचनसंस्था"
            ],
            "theme": "ज्यात बॅक्टेरिया अढळतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "बुबुळ",
                "उत्तप्पा",
                "सी डी ",
                "फ्रिस्बी"
            ],
            "theme": "गोलाकार गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कॅमेरा",
                "फोन ",
                "जी.पी.एस",
                "स्क्रिन"
            ],
            "theme": "स्मार्ट फोन ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बुद्धी ",
                "दुर्",
                "निर्",
                "भुज"
            ],
            "theme": "---बळ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "धन",
                "आरोग्य ",
                "दीप ",
                "शत्रु"
            ],
            "theme": "शुभंकरोतीतले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वात",
                "गादी",
                "मलमपट्टी",
                "चरखा"
            ],
            "theme": "कापसाशी संबंधित गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शरद",
                "अवरोह ",
                "संध्याकाळ",
                "घसरगुंडी"
            ],
            "theme": "ज्यात उतरत्या गोष्टी अढळतात (तापमान, सूर्य, सुर, इत्यादी)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वर्षा",
                "मल्हार",
                "गणेश चतुर्थी",
                "धारा"
            ],
            "theme": "पावसाळ्या संबंधित (ऋतु, राग, सण, इत्यादी)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बुजगावणं",
                "पीक",
                "पाटाचं पाणी",
                "ट्रॅक्टर"
            ],
            "theme": "शेत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "हिमालय",
                "तप",
                "विरक्ती",
                "लांब दाढी"
            ],
            "theme": "साधू",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भाव",
                "भक्ती",
                "राष्ट्र",
                "अंगाई"
            ],
            "theme": "ज्यांना \"गीत\" जोडता येतं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाणे",
                "दिवे",
                "कात्रज",
                "खंडाळा"
            ],
            "theme": "घाट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "माती",
                "स्पंज",
                "पाझर खड्डे",
                "कापुस"
            ],
            "theme": "ज्याच्यात पाणी मुरते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "नवीन",
                "मलम",
                "सरस",
                "सामोसा"
            ],
            "theme": "Palindromes (विलोमपदॆ)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शारदा",
                "आरंभ",
                "चत्वार",
                "आनंत"
            ],
            "theme": "पहिल्या \"मनाचे श्लोका\"तील शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "सिम",
                "रेशन",
                "आधार",
                "आय"
            ],
            "theme": "कार्ड",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "नदीचा प्रवाह",
                "घाट",
                "साप",
                "एस"
            ],
            "theme": "नागमोडी गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बंब",
                "भस्म",
                "तेल",
                "लाकूड"
            ],
            "theme": "यांचा आगीशी खेळ!",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्मण",
                "फडणीस",
                "मिरांडा",
                "ठाकरे"
            ],
            "theme": "व्यंगचित्रकार",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "स्वप्नं",
                "कल्पना",
                "भूत",
                "सँताक्लॉज"
            ],
            "theme": "वास्तवात नसलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अणू",
                "फेस",
                "आकाशगंगा",
                "बबल रॅप"
            ],
            "theme": "ज्यात बहुतांशी पोकळी असते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कांत",
                "संत",
                "गोळे",
                "सुर्वे"
            ],
            "theme": "काही मराठी साहित्यिकांची आडनावे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "ज्योतिर्लिंग",
                "रास",
                "महिना",
                "..खडी"
            ],
            "theme": "बाराच्या संखेने असलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झोप",
                "खाद्य",
                "संगीत",
                "मद्य"
            ],
            "theme": "श्रमपरिहाराची साधने",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "मेधा",
                "स्मृति",
                "आठवण",
                "स्मरण"
            ],
            "theme": "मेंदूच्या क्षमता ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दशा",
                "व्यथा",
                "परिस्थिती",
                "अवस्था"
            ],
            "theme": "स्थिती चे सामानार्थी शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मोहरी",
                "तेल",
                "हिंग",
                "हळद"
            ],
            "theme": "फोडणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "उपनिषद",
                "नचिकेत",
                "यम",
                "मोक्ष"
            ],
            "theme": "कठोपनिषद्",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अभ्यास",
                "रियाज",
                "सराव",
                "मेहनत"
            ],
            "theme": "शिक्षण ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सूर्य",
                "लेझर",
                "दीपस्तंभ",
                "ट्यूबलाईट"
            ],
            "theme": "प्रखर गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "निर्या",
                "जर",
                "घडी",
                "कांचीपुरम"
            ],
            "theme": "साडी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सोनं",
                "मणि",
                "गोल",
                "बोट"
            ],
            "theme": "अंगठी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढीग",
                "कविता",
                "मनोरा",
                "लगोरी"
            ],
            "theme": "ज्या गोष्टी रचता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बाळ",
                "प्रेक्षक",
                "चांभार",
                "पर्यटक"
            ],
            "theme": "ज्यांना कुतूहल असते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "घनिष्ठ",
                "संगत",
                "यार",
                "गट्टी"
            ],
            "theme": "मैत्री",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वानर",
                "वेताळ",
                "वाघुळ",
                "टारझन"
            ],
            "theme": "झाडाला लोंबकळणाऱे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गोबी",
                "थार",
                "कलहरी",
                "मोहावी"
            ],
            "theme": "वाळवंटं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आरोह",
                "गिर्यारोहक",
                "मद्य",
                "ताप"
            ],
            "theme": "चढणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अभिजित",
                "अमर्त्य",
                "रवींद्र",
                "कॆलाश"
            ],
            "theme": "भारतीय नोबेल विजेत्यांची पहिली नावे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "गांधी",
                "फुले",
                "विदुर",
                "बसवेश्वर"
            ],
            "theme": "\"महात्मा\" पदवी असलेले",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "बिड",
                "बिम",
                "बित",
                "बिर"
            ],
            "theme": "अर्थहीन पहिले, पण अर्थपूर्ण दुसरे शब्द (हाड-, काम-, हात-, घर-)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मध्यस्त",
                "पूल",
                "लग्न",
                "फोन कॉल"
            ],
            "theme": "दोन घटकांना जोडणारे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रक्त",
                "कुंकू",
                "जास्वंद",
                "थांबा"
            ],
            "theme": "लाल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वेफर्स ",
                "दाबेली ",
                "उकडलेला",
                "कंद"
            ],
            "theme": "बटाटा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भजी",
                "अक्कलेचा",
                "चिरलेला",
                "पात"
            ],
            "theme": "कांदा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कायदा",
                "ताल",
                "लग्गी",
                "सम"
            ],
            "theme": "तबला",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "चौखूर धाव",
                "हयः",
                "तबेला",
                "झुपकेदार"
            ],
            "theme": "घोडा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बांबू",
                "कृष्ण",
                "छिद्रं",
                "फुंकर"
            ],
            "theme": "बासरी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गुप्त",
                "निशा",
                "जल",
                "अगो"
            ],
            "theme": "___ चर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मच्छर",
                "नाम",
                "नटसम्राट",
                "छप्पन"
            ],
            "theme": "नाना पाटेकर यांच्याशी संबंधित (चित्रपट/संस्था)",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अठ्ठावीस",
                "तुळस",
                "राही",
                "गरूड"
            ],
            "theme": "विठ्ठल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्रेम",
                "तुळशी",
                "मुखत्यार",
                "मृत्यू"
            ],
            "theme": "___पत्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रंग",
                "कृष्ण",
                "वल्ली",
                "निवास"
            ],
            "theme": "नावे श्री___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मामा",
                "हळद",
                "माळ",
                "अग्नी"
            ],
            "theme": "लग्नाशी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मधु",
                "भाल",
                "हरीश",
                "अर्ध"
            ],
            "theme": "___ चंद्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "प्रदूषण",
                "थंडी",
                "चांदणी चौक",
                "विराट"
            ],
            "theme": "दिल्ली",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सचिन",
                "प्रणव",
                "भूपेन",
                "लता"
            ],
            "theme": "भारतरत्न",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्रथम",
                "अव्वल",
                "सुवर्ण",
                "अजिंक्य"
            ],
            "theme": "विजेता",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "ताम्र",
                "बुद्धिबळ",
                "कथा",
                "वर्धन"
            ],
            "theme": "पट",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जस्त",
                "पोलाद",
                "कांस्य",
                "पितळ"
            ],
            "theme": "मिश्रधातू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गावसकर",
                "प्रभू",
                "पाल",
                "दत्त"
            ],
            "theme": "सुनील _____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "भैरव",
                "सारंग",
                "दुर्गा",
                "मल्हार"
            ],
            "theme": "शास्त्रीय संगीताचे राग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गुरू",
                "संदीप",
                "वैभव",
                "किशोर"
            ],
            "theme": "मराठी कवी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "संकोच",
                "संशय",
                "विकार",
                "विवाद"
            ],
            "theme": "नि: प्रत्यय लागू शकणारे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रक्त",
                "हत्यार",
                "तपास",
                "बेड्या"
            ],
            "theme": "गुन्ह्याची उकल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कान",
                "नाक",
                "डोळे",
                "जीभ"
            ],
            "theme": "ज्ञानेंद्रिये",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "बहार",
                "नंद",
                "चार",
                "हरित"
            ],
            "theme": "सदा ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "सूर",
                "व्यक्त",
                "समर्थ",
                "सत्य"
            ],
            "theme": "आधी अ लावल्यास विरुद्धार्थी शब्द बनतो",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वार्ता",
                "प्रेम",
                "नुर्वी",
                "मंगलमूर्ती"
            ],
            "theme": "गणपती आरती मधील शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मेकअप",
                "दुर्बीण",
                "कार",
                "सौरचूल"
            ],
            "theme": "आरसा चे उपयोग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "लाईट",
                "संगीत",
                "तालीम",
                "मंच"
            ],
            "theme": "नाटक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दोरी",
                "गॉगल",
                "बूट",
                "कंपास"
            ],
            "theme": "गिर्यारोहणाची साधने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेशी",
                "तुरुंग",
                "मोबाईल",
                "बॅटरी"
            ],
            "theme": "सेल या शब्दाचे अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "काश्मीर",
                "आयफोन",
                "न्यूटन",
                "ज्यूस"
            ],
            "theme": "सफरचंद",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गोवा",
                "सिक्कीम",
                "सिल्वासा",
                "पाँडिचेरी"
            ],
            "theme": "१९५० नंतर भारतात समाविष्ट झालेले प्रदेश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "खडा",
                "गोडा",
                "काळा",
                "गरम"
            ],
            "theme": "मसाला",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अंत्य",
                "तीर्थ",
                "शोभा",
                "विदेश"
            ],
            "theme": "यात्रा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जन्म",
                "मृत्यू",
                "पदवी",
                "जात"
            ],
            "theme": "प्रमाणपत्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "लोकमान्य",
                "तर्कतीर्थ",
                "महात्मा",
                "स्वातंत्र्यवीर"
            ],
            "theme": "पदव्या",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चाचा",
                "बापू",
                "सरदार",
                "मौलाना"
            ],
            "theme": "टोपण नावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गांधी",
                "नेहरू",
                "पटेल",
                "आंबेडकर"
            ],
            "theme": "आडनावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "ब्रेक",
                "सालसा",
                "टँगो",
                "कथ्थक"
            ],
            "theme": "नृत्य",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चाक",
                "गिअर",
                "ब्रेक",
                "टायर"
            ],
            "theme": "कार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जॅझ",
                "सिटी",
                "एलिव्हेट",
                "अमेझ"
            ],
            "theme": "होंडा कार मॉडेल्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "चंद्र",
                "नाग",
                "जय",
                "मिर्झा"
            ],
            "theme": "___ पूर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "नंदी",
                "मठ्ठ",
                "जिवा",
                "पोळा"
            ],
            "theme": "बैल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कंठ",
                "गाय",
                "मणी",
                "गिरी"
            ],
            "theme": "नील___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "एक",
                "केदार",
                "नाग",
                "आदित्य"
            ],
            "theme": "___नाथ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मीठ",
                "चहा",
                "कार",
                "घड्याळ"
            ],
            "theme": "टाटा उत्पादने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बारा",
                "बिगुल",
                "सूप",
                "बँड"
            ],
            "theme": "___ वाजणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शिक्षा",
                "यातायात",
                "चेष्टा",
                "साक्षात्कार"
            ],
            "theme": "मराठी आणि हिंदी मध्ये वेगळ्या अर्थाने वापरले जाणारे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "गाठी",
                "काठी",
                "साडी",
                "तांब्या"
            ],
            "theme": "गुढी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धर्म",
                "नर",
                "देव",
                "जीत"
            ],
            "theme": "__इंद्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सम",
                "ताल",
                "राग",
                "छंद"
            ],
            "theme": "गाणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "विषम",
                "मूळ",
                "घन",
                "समीकरण"
            ],
            "theme": "गणितातील संज्ञा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सूर",
                "थाप",
                "हाक",
                "चक्कर"
            ],
            "theme": "____ मारणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "विराट",
                "सुनील",
                "जसप्रीत",
                "सचिन"
            ],
            "theme": "IPL मध्ये फक्त एकच टीम कडून खेळलेले प्लेअर्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रोहित",
                "धोनी",
                "श्रेयस",
                "हार्दिक"
            ],
            "theme": "IPL जिंकलेले कॅप्टन",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छोटा",
                "आंबेडकर",
                "पांडव",
                "गदा"
            ],
            "theme": "भीम",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हजारे",
                "पाटील",
                "साठे",
                "पंक्चर"
            ],
            "theme": "अण्णा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "केसरी",
                "माती",
                "डाव",
                "गादी"
            ],
            "theme": "कुस्ती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शकील",
                "भीम",
                "राजन",
                "चेतन"
            ],
            "theme": "छोटा___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "राजीव",
                "अनिल",
                "अर्जुन",
                "रणबीर"
            ],
            "theme": "__ कपूर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "धर्म",
                "क्रांती",
                "परम",
                "शूर"
            ],
            "theme": "____ वीर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लब्ध",
                "रती",
                "करण",
                "वर"
            ],
            "theme": "उप ___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हात",
                "चेहरा",
                "पोपट",
                "पत्रिका"
            ],
            "theme": "ज्योतिषी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मेंदी",
                "मांडव",
                "भटजी",
                "वाजंत्री"
            ],
            "theme": "लग्न",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "केशव",
                "माधव",
                "राजेंद्र",
                "सुदर्शन"
            ],
            "theme": "सरसंघचालक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "द्रौपदी",
                "प्रतिभा",
                "झाकीर",
                "प्रणव"
            ],
            "theme": "राष्ट्रपती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "तेजस्वी",
                "तेजप्रताप",
                "मिसा",
                "रोहिणी"
            ],
            "theme": "लालूप्रसाद यादव यांची मुले",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घोडा",
                "राजा",
                "वजीर",
                "हत्ती"
            ],
            "theme": "बुद्धिबळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेशवा",
                "अमात्य",
                "सेनापती",
                "न्यायाधीश"
            ],
            "theme": "अष्टप्रधान मंडळातील पदे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "उंट",
                "नांगर",
                "समुद्र",
                "विक्रांत"
            ],
            "theme": "जहाज",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फवारणी",
                "पेरणी",
                "कापणी",
                "सिंचन"
            ],
            "theme": "शेती संबंधी ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "माप",
                "धागा",
                "कात्री",
                "टीप"
            ],
            "theme": "शिंपी (टेलर) शी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दोर",
                "भू",
                "आम्र",
                "उप"
            ],
            "theme": "__खंड",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाझा",
                "पाणी",
                "मलम",
                "किनार"
            ],
            "theme": "__पट्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गंध",
                "माहिती",
                "बातमी",
                "पत्ता"
            ],
            "theme": "एखाद्या गोष्टीबद्दल माहिती असणे किंबहुना नसणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "पोत",
                "रंग",
                "किंमत",
                "वार"
            ],
            "theme": "साडी घेताना पहायच्या गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आठवडा",
                "निर्भेळ",
                "अचाट",
                "पुरिया"
            ],
            "theme": "शब्दात एक चटपटीत खाद्य पदार्थ लपलेला शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "अबोली",
                "राणी",
                "पिस्ता",
                "मोरपंखी"
            ],
            "theme": "काही विशिष्ठ रंग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "बृहन्नला",
                "पार्थ",
                "अर्जुन",
                "गुडाकेश"
            ],
            "theme": "अर्जुनाची वेगवेगळी नावे किंवा रूपे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अफगाणिस्तान",
                "पाकिस्तान",
                "बांगलादेश",
                "नेपाळ"
            ],
            "theme": "भारताचे शेजारी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "कझाकिस्तान",
                "किर्गिस्तान",
                "ताजिकिस्तान",
                "उझबेकिस्तान"
            ],
            "theme": "पूर्वीच्या सोविएत रशियातून निर्मित देश ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अग्र",
                "ज्येष्ठ",
                "मुख्य",
                "प्रधान"
            ],
            "theme": "पहिला किंवा महत्त्वाचा या अर्थी ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अष्ट",
                "पंत",
                "ग. प्र.",
                "पुरुष"
            ],
            "theme": "___ प्रधान जोडून अर्थपूर्ण शब्द / व्यक्ती ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शाळा",
                "देव",
                "खेळाडू",
                "केस"
            ],
            "theme": "ज्यांचे एकवचन आणि बहुवचन सारखे आहे असे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वेध",
                "स्पर्श",
                "मध्य",
                "मोक्ष"
            ],
            "theme": "ग्रहणाच्या स्थिती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बाकर",
                "पाट",
                "अळू",
                "कोथिंबीर"
            ],
            "theme": "___वडी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "कलिंगड",
                "पेरू",
                "पोपट",
                "ट्रॅफिक सिग्नल"
            ],
            "theme": "लाल आणि हिरव्या रंगाच्या गोष्टी ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "माठ",
                "टोमॅटो",
                "मिर्ची",
                "द्राक्षे"
            ],
            "theme": "या गोष्टी लाल किंवा हिरव्या असतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घुबड",
                "अमावस्या",
                "तेरा",
                "कोल्हेकुई"
            ],
            "theme": "अशुभ मानल्या जाणाऱ्या अंधश्रद्धा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "बी",
                "अंकूर",
                "रोप",
                "कलम"
            ],
            "theme": "झाडा संबंधी ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "अंडे",
                "अळी",
                "कोष",
                "पाखरू"
            ],
            "theme": "फुलपाखरु/पतंग यांचे जीवनचक्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जलाशय",
                "वाफ",
                "ढग",
                "पाऊस"
            ],
            "theme": "पाण्याचे निसर्गचक्र ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "रेवा",
                "दर्शन",
                "चालणे",
                "अमरकंटक"
            ],
            "theme": "नर्मदा परिक्रमा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आषाढ",
                "पाऊस",
                "विठोबा",
                "उपवास"
            ],
            "theme": "आषाढी एकादशी",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रेवा",
                "सरस्वती",
                "अलकनंदा",
                "गायत्री"
            ],
            "theme": "भारतातील नद्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वाळू",
                "खारट",
                "मासे",
                "क्षितीज"
            ],
            "theme": "समुद्र",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "जमीन",
                "बी",
                "पाणी",
                "खत"
            ],
            "theme": "धान्य/शेती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कापूस",
                "चरखा",
                "सूत",
                "धागा"
            ],
            "theme": "आत्मनिर्भर वस्त्र निर्मिती",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "वाळू",
                "खारट",
                "पाणी",
                "मासे"
            ],
            "theme": "समुद्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तार",
                "प्रवाह",
                "धक्का",
                "कडकडाट"
            ],
            "theme": "वीज ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पावकी",
                "निमकी",
                "पाऊणकी",
                "दिडकी"
            ],
            "theme": "शाळेतील पाठांतर (फार पूर्वी)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शालिवाहन",
                "विक्रम",
                "हिजरी",
                "ग्रेगोरियन"
            ],
            "theme": "कालमापन",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "प्रतिबंध",
                "चिकित्सा",
                "औषध",
                "आराम"
            ],
            "theme": "उपचार पद्धती आणि रोगमुक्ती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पृथ्वी",
                "गुरू",
                "शनी",
                "बुध"
            ],
            "theme": "सौरमाला",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "रिचर्ड",
                "रोहिणी",
                "ऑस्कर",
                "बेन"
            ],
            "theme": "गांधी सिनेमाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "क्रिश",
                "पुष्पा",
                "डॉन",
                "झिम्मा"
            ],
            "theme": "सिक्वेल निघालेले सिनेमा",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संपदा",
                "दक्षता",
                "किर्लोस्कर",
                "स्त्री"
            ],
            "theme": "नवी जुनी प्रसिद्ध मासिके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मलखांब",
                "हॉकी",
                "क्रिकेट",
                "विटी-दांडू"
            ],
            "theme": "लाकूड वापरण्यात येणारे खेळ ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "फुटबॉल",
                "रग्बी",
                "कबड्डी",
                "बास्केटबॉल"
            ],
            "theme": "मैदानी खेळ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उदक",
                "जल",
                "तोय",
                "नीर"
            ],
            "theme": "पाण्याशी समानार्थी ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "पाणि",
                "कर",
                "भुजा",
                "बाहू"
            ],
            "theme": "हात समानार्थी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कोलंबिया",
                "अर्जेंटिना",
                "व्हेनेझुएला",
                "पेरू"
            ],
            "theme": "दक्षिण अमेरिकेतील मुख्य देश",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आंबा",
                "केळी",
                "पपई",
                "चिकू"
            ],
            "theme": "उष्णकटिबंधीय फळे",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "रनवे34",
                "बेल बॉटम",
                "विजेता",
                "एअरलिफ्ट"
            ],
            "theme": "विमानाशी संबंधित हिंदी सिनेमे",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "प्रथम",
                "आधी",
                "सुरुवात",
                "आरंभ"
            ],
            "theme": "पहिला या अर्थाचे शब्द",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "यशस्वी",
                "पृथ्वी",
                "रोहित",
                "सुनील"
            ],
            "theme": "कसोटीतील सलामीचे फलंदाज",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "सदाशिव",
                "पांडू",
                "गंगाराम",
                "चंदू"
            ],
            "theme": "दादा कोंडके यांचे नायक",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "जोडवी",
                "बिछवा",
                "मासोळी",
                "करंगुळ्या"
            ],
            "theme": "स्त्रीच्या पायाच्या बोटातील दागिने",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हँड",
                "बेस",
                "व्हॉली",
                "बास्केट"
            ],
            "theme": "_बॉल खेळ..",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "तबला",
                "डमरू",
                "संबळ",
                "टाळ"
            ],
            "theme": "ताल वाद्य",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "पोपट",
                "मोर",
                "उंदीर",
                "हंस"
            ],
            "theme": "हिंदू देवतांची वाहने",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेघा",
                "पूर्वा",
                "हस्त",
                "चित्रा"
            ],
            "theme": "पावसाळी नक्षत्रे ",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "वाघ",
                "चित्ता",
                "बिबट्या",
                "सिंह"
            ],
            "theme": "मांजर समूहातील प्रजाती",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "स्मृतिचित्रे",
                "शंवाकिय",
                "स्मरणगाथा",
                "कृष्णकाठ"
            ],
            "theme": "काही आत्मचरित्रे",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शरद",
                "हेमंत",
                "वर्षा",
                "वसंत"
            ],
            "theme": "मराठी ऋतू",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "आभाळमाया",
                "असंभव",
                "वादळवाट",
                "राधा ही बावरी"
            ],
            "theme": "झी वाहिनी वरच्या काही मालिका",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "सर्कस",
                "हमलोग",
                "मिस्टर योगी",
                "स्वाभिमान"
            ],
            "theme": "दूरदर्शन वरील काही जुन्या मालिका",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वैशाख",
                "आश्विन",
                "जेष्ठ",
                "कार्तिक"
            ],
            "theme": "मराठी महिने",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "कनिष्ठ",
                "दुय्यम",
                "हलका",
                "निकृष्ट"
            ],
            "theme": "कमी प्रतीचा या अर्थाचे शब्द",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "बासरी",
                "मोरपीस",
                "त्रिभंग मुद्रा",
                "सुदर्शन चक्र"
            ],
            "theme": "श्रीकृष्णाचे दर्शन",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आग",
                "आह",
                "अंदाज",
                "आवारा"
            ],
            "theme": "राज कपूर चित्रपट",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 0
        },
        {
            "words": [
                "बॉबी",
                "सरगम",
                "हिना",
                "दामिनी"
            ],
            "theme": "ऋषी कपूर चित्रपट",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 1
        },
        {
            "words": [
                "दगड",
                "वीट",
                "काँक्रिट",
                "लाकूड"
            ],
            "theme": "घराच्या भिंती बनवण्याची विविध साहित्य ",
            "sharedBy": "कुलदीप क्षीरसागर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जळ",
                "स्थळ",
                "काष्ठ",
                "पाषाण"
            ],
            "theme": "सर्व संभव जागा ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "साम",
                "दाम",
                "दंड",
                "भेद"
            ],
            "theme": "लोकांकडून काम करवून घेण्याच्या युक्ती ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "आहार",
                "निद्रा",
                "भय",
                "मैथुन"
            ],
            "theme": "मनुष्य आणि प्राणिमात्रांमधील मूळ प्रवृत्ती ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंदिगढ",
                "दिल्ली",
                "पाँडिचेरी",
                "दमण"
            ],
            "theme": "केंद्रशासित प्रदेश",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मुंबई",
                "पाटणा",
                "जयपूर",
                "भोपाळ"
            ],
            "theme": "राजधान्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "लखनौ",
                "प्रयागराज",
                "कानपुर",
                "अयोध्या"
            ],
            "theme": "उत्तर प्रदेशातील शहरे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुनील",
                "संदीप",
                "रवी",
                "दिलीप"
            ],
            "theme": "८०-९० मधील मुंबई क्रिकेटपटू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "भानू",
                "आदित्य",
                "मरीची",
                "भास्कर"
            ],
            "theme": "सूर्याची नावे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "सखा",
                "मित्र",
                "सवंगडी",
                "सोबती"
            ],
            "theme": "मैत्र या अर्थी ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सकाळ",
                "प्रभात",
                "प्रातः",
                "झुंजूमुंजू"
            ],
            "theme": "दिवसाची सुरुवात या अर्थी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दूधवाला",
                "गजर",
                "वर्तमानपत्र",
                "चहा"
            ],
            "theme": "दिवसाच्या सुरुवातीला होणाऱ्या गोष्टी ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "चूल",
                "फूल",
                "नमस्कार",
                "कुमार यादव"
            ],
            "theme": "सूर्य-- ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सलाते",
                "नेईशी",
                "चाचीचे",
                "तईआ"
            ],
            "theme": "विभक्ती प्रत्यय एकवचनी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सलानाते",
                "नीहीशी",
                "चेच्याची",
                "नो"
            ],
            "theme": "विभक्ती प्रत्यय अनेक वचनी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चूभूदेघे",
                "भापो",
                "ताक",
                "सनविवि"
            ],
            "theme": "मराठीतील संक्षिप्तरूपे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कै",
                "श्री",
                "सौ",
                "कु"
            ],
            "theme": "नावापुढील एकाक्षरी लघु रूपे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ढ",
                "तू",
                "व",
                "ऊ"
            ],
            "theme": "एकाक्षरी शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "जा",
                "घे",
                "ये",
                "दे"
            ],
            "theme": "एकाक्षरी आज्ञारुपी क्रियापदे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "श्रीकांत",
                "साईना",
                "सिंधू",
                "लक्ष्य"
            ],
            "theme": "भारतीय बॅडमिंटनपटू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "श्रेयस",
                "ऋषभ",
                "संजू",
                "ऋतुराज"
            ],
            "theme": "तरुण क्रिकेटपटू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "स्वप्नील",
                "मनू",
                "अभिनव",
                "राज्यवर्धन"
            ],
            "theme": "पदक विजेते भारतीय नेमबाज ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दोन",
                "सतरा",
                "एकोणतीस",
                "त्र्याहत्तर"
            ],
            "theme": "मूळ संख्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "एक",
                "आठ",
                "सत्तावीस",
                "चौसष्ठ"
            ],
            "theme": "घन संख्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "नऊ",
                "पंचवीस",
                "छत्तीस",
                "एक्क्यांशी"
            ],
            "theme": "वर्ग संख्या ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काच",
                "पाणी",
                "हवा",
                "तेल"
            ],
            "theme": "पारदर्शक पदार्थ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कोळसा",
                "केस",
                "कावळा",
                "डांबर"
            ],
            "theme": "काळ्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "√-१",
                "टाइम मशीन",
                "भूत",
                "शाश्वत गती यंत्र"
            ],
            "theme": "काल्पनिक गोष्टी (Imaginary) ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सतार",
                "मेंडोलिन",
                "सरोद",
                "इसराज"
            ],
            "theme": "तंतुवाद्ये ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "तबला",
                "ढोलकी",
                "मृदुन्ग",
                "मादल"
            ],
            "theme": "ताल वाद्ये",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "बासरी",
                "क्लॅरॉनेट",
                "सनई",
                "हार्मोनियम"
            ],
            "theme": "वायू वाद्ये  ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नेहेरु",
                "गुजराल",
                "वाजपेयी",
                "मोदी"
            ],
            "theme": "पंतप्रधान",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मुर्मू",
                "पाटील",
                "कलाम",
                "मुखर्जी"
            ],
            "theme": "राष्ट्रपती ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "अंतुले",
                "नाईक",
                "कन्नमवार",
                "पवार"
            ],
            "theme": "महाराष्ट्र मुख्यमंत्री",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "होंडा",
                "टोयोटा",
                "मित्सुबिशी",
                "तोशिबा"
            ],
            "theme": "जपानी कंपन्या ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "गूगल",
                "टेस्ला",
                "फोर्ड",
                "अमेझॉन"
            ],
            "theme": "अमेरिकन कंपन्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "शेल",
                "व्होडाफोन",
                "बार्कले",
                "युनिलिव्हर"
            ],
            "theme": "ब्रिटिश कंपन्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आदिनाथ",
                "महावीर",
                "संभव",
                "सुपार्श्व"
            ],
            "theme": "जैन तीर्थांकर ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "नानक",
                "तेगबहादूर",
                "गोविंद",
                "हरगोविंद"
            ],
            "theme": "शीख गुरु",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "गोरख",
                "मच्छिन्द्र",
                "कानिफ",
                "ओंकार"
            ],
            "theme": "नाथ संप्रदायातील संत",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नकुल",
                "अर्जुन",
                "युधिष्ठीर",
                "भीम"
            ],
            "theme": "पांडव ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "राम",
                "लक्ष्मण",
                "भरत",
                "शत्रुघ्न"
            ],
            "theme": "दशरथ पुत्र   ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "विकर्ण",
                "दुःशासन",
                "युयुत्सु",
                "दुर्योधन"
            ],
            "theme": "कौरव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पारिजात",
                "कामधेनू",
                "हलाहल",
                "अमृत"
            ],
            "theme": "समुद्रमंथनातील रत्ने",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "जास्वंद",
                "गुलाब",
                "कमळ",
                "चाफा"
            ],
            "theme": "झाडांवरील फुले",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "जाई",
                "जुई",
                "मोगरा",
                "बोगनवेल"
            ],
            "theme": "वेलींवरील फुले",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्राण",
                "रणजीत",
                "अमजद",
                "प्रेम"
            ],
            "theme": "हिंदी चित्रपट खलनायक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "पेंटल",
                "असरानी",
                "मेहमूद",
                "जगदीप"
            ],
            "theme": "हिंदी चित्रपट हास्य अभिनेता   ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "डेव्हिड",
                "अनुपम",
                "अशोक",
                "बलराज"
            ],
            "theme": "हिंदी चित्रपट चरित्र अभिनेता",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पूर्वरंग",
                "अपूर्वाई",
                "व्यक्ती आणि वल्ली",
                "खोगीरभरती"
            ],
            "theme": "पुलं वाङ्मय",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "विशाखा",
                "मारवा",
                "रसयात्रा",
                "नटसम्राट"
            ],
            "theme": "कुसुमाग्रज वाङ्मय",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "रक्तचंदन",
                "काजळमाया",
                "हिरवे रावे",
                "पिंगळा वेळ"
            ],
            "theme": "जी. ए. कुलकर्णी वाङ्मय ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बिंदू",
                "हेलन",
                "जयश्री टी",
                "कम्मो"
            ],
            "theme": "हिंदी चित्रपट नृत्यांगना",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "सुरैय्या",
                "सुलक्षणा",
                "सलमा",
                "परिणीती"
            ],
            "theme": "हिंदी चित्रपट अभिनेत्री गायिका",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "शशिकला",
                "मनोरमा",
                "ललिता",
                "नादिरा"
            ],
            "theme": "हिंदी चित्रपट खलनायिका ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुरणपोळी",
                "पायस",
                "पंचामृत",
                "उकडीचे मोदक"
            ],
            "theme": "सणासुदीचे पदार्थ",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "हिंग",
                "दालचिनी",
                "लवंग",
                "तमालपत्र "
            ],
            "theme": "मसाले",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "तुळस",
                "दुर्वा",
                "आघाडा ",
                "बेल"
            ],
            "theme": "पवित्र वनस्पती",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गणपती",
                "नवरात्र",
                "दिवाळी",
                "होळी"
            ],
            "theme": "भारतीय सण",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "गाय",
                "बैल",
                "म्हैस",
                "शेळी"
            ],
            "theme": "पाळीव प्राणी",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कोल्हापूर",
                "नाशिक",
                "पुणे",
                "औरंगाबाद"
            ],
            "theme": "महाराष्ट्रातील शहरे",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाऊस",
                "वीज",
                "ढग",
                "गारपीट"
            ],
            "theme": "हवामानाशी संबंधित",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "छडी",
                "वर्ग",
                "शिक्षक",
                "घंटा"
            ],
            "theme": "शालेय जीवन",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "शिवाजी महाराज",
                "तानाजी",
                "बाजी प्रभू",
                "जिजामाता"
            ],
            "theme": "मराठा इतिहासातील व्यक्तिरेखा",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छत्री",
                "रेनकोट",
                "बूट",
                "टोपी"
            ],
            "theme": "पावसात लागणाऱ्या वस्तू",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "पुस्तक",
                "वाचनालय",
                "वाचक",
                "पान"
            ],
            "theme": "वाचन",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "गजर",
                "काटा",
                "वाळू",
                "बारा"
            ],
            "theme": "घड्याळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इरसाल",
                "तासगाव",
                "औक्षण",
                "अदमास"
            ],
            "theme": "ज्या शब्दात कालवाचक शब्द दडला आले असे शब्द ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "इगतपुरी",
                "सुप्रभात",
                "आवरण",
                "कुडाळ"
            ],
            "theme": "ज्या शब्दात खायचे पदार्थ दडले आहेत असे शब्द ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "कायम",
                "नादब्रह्म",
                "कृष्णधवल",
                "महेश्वरी"
            ],
            "theme": "देवाचे नाव लपलेले शब्द ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इडली",
                "रझिया",
                "चालना",
                "पजामा"
            ],
            "theme": "मधले अक्षर बदललेली देशांची नावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्लाझ्मा",
                "स्मार्ट",
                "एल ई डी",
                "एच डी"
            ],
            "theme": "टीव्ही चे प्रकार ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "थांब",
                "पाच",
                "आशीर्वाद",
                "टाटा"
            ],
            "theme": "हाताचा पंजा दाखवणे याचे संभाव्य अर्थ ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मीन",
                "कालवण",
                "काटा",
                "गळ"
            ],
            "theme": "माश्याशी संबंधित ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "अहम",
                "मदन",
                "नगर",
                "अगर"
            ],
            "theme": "अहमदनगर शब्दातील अक्षरे वापरून तयार होणारे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "गल",
                "सर",
                "अल",
                "खल"
            ],
            "theme": "____बत ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भोभो",
                "म्याव",
                "डराव",
                "मेंमें"
            ],
            "theme": "प्राण्यांचे ओरडण्याचे आवाज",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "भुंकणे",
                "आरवणे",
                "कूजन",
                "हंबरणे"
            ],
            "theme": "प्राणीपक्ष्यांच्या ओरडण्याला दिलेले नाव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "चिवचिव",
                "कावकाव",
                "कुहूकुहू",
                "गुटर्गु"
            ],
            "theme": "पक्ष्यांचे ओरडण्याचे आवाज",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फौजदारी",
                "दिवाणी",
                "कौटुंबिक",
                "औद्योगिक"
            ],
            "theme": "न्यायालयातील खटल्याचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "सर्वोच्च",
                "उच्च",
                "जिल्हा",
                "तलाठी/ग्राम"
            ],
            "theme": "न्यायालयाच्या श्रेणी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "लिपिक",
                "साक्षीदार",
                "वकील",
                "न्यायाधीश"
            ],
            "theme": "न्यायालयातील व्यक्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाणीफवारा",
                "अशृधूर",
                "लाठीमार",
                "हवेत गोळीबार"
            ],
            "theme": "जमाव पांगवण्याच्या पद्धती",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "काठी",
                "लाठी",
                "सोटा",
                "छडी"
            ],
            "theme": "लाकडी दांडू",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दगडफेक",
                "नासधूस",
                "जाळणे",
                "दहशत"
            ],
            "theme": "दंगल",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धूर",
                "झुरका",
                "तंबाखू",
                "माचिस"
            ],
            "theme": "सिगारेट व्यसन",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "स्क्रीन",
                "रील",
                "स्क्रोल",
                "जागरण"
            ],
            "theme": "मोबाईल व्यसन",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पेग",
                "धुंद",
                "हँगओव्हर",
                "पुनर्वसन"
            ],
            "theme": "दारूचे व्यसन",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चल",
                "स्मरण",
                "व्यंग",
                "छाया"
            ],
            "theme": "____चित्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "बल",
                "धन",
                "गाडी",
                "नशीब"
            ],
            "theme": "___वान",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "भोज्जा",
                "शर्ट",
                "कावळा",
                "तोंड"
            ],
            "theme": "या गोष्टी शिवतात ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुबक ठेंगणी",
                "मधू मलुष्टे",
                "पुढारी",
                "मास्तर"
            ],
            "theme": "पुलंच्या म्हैस कथेतील पात्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ठाकूर",
                "इमाम साहेब",
                "कालिया",
                "जय"
            ],
            "theme": "शोले चित्रपटातील पात्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "बसेसर राम",
                "लल्लू",
                "दादी",
                "भागवंतीं"
            ],
            "theme": "हम लोग मालिकेतही पात्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "य",
                "लय",
                "खूप",
                "अती"
            ],
            "theme": "भरपूर ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "भारी",
                "छान",
                "मस्त",
                "वाह"
            ],
            "theme": "कौतुकाचे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रूप",
                "गम",
                "पूर",
                "अट"
            ],
            "theme": "शेवटी क लावल्यास नवीन अर्थाचा शब्द बनतो",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कुस्ती",
                "चेस",
                "पंजा लढवणे",
                "बॉक्सिंग"
            ],
            "theme": "२ जणांमध्ये खेळले जाणारे खेळ ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "भाला",
                "गोळा",
                "थाळी",
                "हातोडा"
            ],
            "theme": "या गोष्टी फेकण्याच्या स्पर्धा होतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "तोफ",
                "बासरी",
                "सिगारेट",
                "मुसळ"
            ],
            "theme": "दंडगोलाकार वस्तू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साक्ष",
                "पुरावा",
                "अटक",
                "कोठडी"
            ],
            "theme": "पोलीस आणि न्यायालय",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चोरी",
                "खून",
                "दरोडा",
                "घरफोडी"
            ],
            "theme": "गंभीर गुन्हे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "हवालदार",
                "फौजदार",
                "अधीक्षक",
                "महानिरीक्षक"
            ],
            "theme": "पोलिसांची श्रेणी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कझाकस्तान",
                "टर्की",
                "रशिया",
                "इजिप्त"
            ],
            "theme": "दोन खंडांमध्ये असलेले देश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "स्पेन",
                "अर्जेंटिना",
                "मेक्सिको",
                "पनामा"
            ],
            "theme": "स्पॅनिश भाषिक देश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मादागास्कर",
                "श्रीलंका",
                "जपान",
                "मालदीव"
            ],
            "theme": "बेट असलेले देश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सिमेंट",
                "डांबर",
                "दुभाजक",
                "गतिरोधक"
            ],
            "theme": "रस्ता ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "नकाशा",
                "शोध",
                "छायाचित्रे",
                "दिनदर्शिका"
            ],
            "theme": "गूगल प्रणाली (ॲप्स)",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दिनांक",
                "सही",
                "रक्कम",
                "नाव"
            ],
            "theme": "धनादेशावरील माहिती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धनगर",
                "मेंढपाळ",
                "गुराखी",
                "गोप"
            ],
            "theme": "पशु पालन",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दूध",
                "लोकर",
                "अंडी",
                "हस्तिदंत"
            ],
            "theme": "प्राण्यांपासून मिळणारे पदार्थ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "गोठा",
                "खुराडे",
                "कोंडवाडा",
                "तबेला"
            ],
            "theme": "प्राण्यांना ठेवण्याच्या जागा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चालुक्य",
                "राष्ट्रकुट",
                "सातवाहन",
                "यादव"
            ],
            "theme": "महाराष्ट्रातील राजवंश ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मगध",
                "अंग",
                "कोसला",
                "अवंती"
            ],
            "theme": "प्राचीन महाजनपदे ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चोल",
                "पंड्या",
                "पल्लव",
                "होयसळ"
            ],
            "theme": "दक्षिण भारतातील राजवंश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पोस्को",
                "टाडा",
                "मोका",
                "आरटीआय"
            ],
            "theme": "काही कायद्यांची लघु रुपे ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "आयएएफ",
                "बीआरएफ",
                "सीआरपीएफ",
                "रॉ"
            ],
            "theme": "सुरक्षा दलांच्या नावाची लघुरूपे ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "डीएसपी",
                "डीआयजी",
                "पीएसआय",
                "एचसी"
            ],
            "theme": "पोलिस दलातील पदांची लघुरूपे ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुर्वा",
                "मोदक",
                "आरती",
                "ढोल"
            ],
            "theme": "गणपतीशी संबंधित",
            "sharedBy": "कौस्तुभ",
            "difficulty": 0
        },
        {
            "words": [
                "साबुदाणा",
                "वरई",
                "रताळे",
                "काकडी"
            ],
            "theme": "उपवास संबंधित ",
            "sharedBy": "कौस्तुभ",
            "difficulty": 1
        },
        {
            "words": [
                "पन्हे",
                "लोणचे",
                "आमरस",
                "आम्रखंड"
            ],
            "theme": "आंबा संबंधित ",
            "sharedBy": "कौस्तुभ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कापूस",
                "रॉकेल",
                "लाकडाचा भुसा",
                "फटाके"
            ],
            "theme": "ज्वालाग्राही पदार्थ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "साखर",
                "मीठ",
                "व्हिनेगर",
                "कार्बन डाय ऑक्साईड"
            ],
            "theme": "पाण्यात विरघळणारी द्रव्ये",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "लवंगी",
                "सुतळी",
                "चमनचिडी",
                "आपटबार"
            ],
            "theme": "फटाक्यांचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेघ",
                "गडगडाट",
                "वीज",
                "मुसळधार"
            ],
            "theme": "पाऊस",
            "sharedBy": "स्मिता कोरडे",
            "difficulty": 0
        },
        {
            "words": [
                "मीनल",
                "मकरंद",
                "नरसिंह",
                "सुकन्या"
            ],
            "theme": "राशींची नावे लपलेली नावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वसंत",
                "हेमंत",
                "शरद",
                "शिशिर"
            ],
            "theme": "ऋतू ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आग",
                "रामेश्वर",
                "बंब",
                "सोमेश्वर"
            ],
            "theme": "एक म्हण",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रात्र",
                "थोडी",
                "सोंगं",
                "फार"
            ],
            "theme": "अजून एक म्हण",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आंधळा",
                "डोळा",
                "देव",
                "दोन"
            ],
            "theme": "ही पण एक म्हण",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्रिकेट कसोटी",
                "विंबल्डन",
                "शोकसभा",
                "होली"
            ],
            "theme": "यासाठी लोक पांढरे कपडे घालतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "रांगोळी",
                "फटाके",
                "आकाशकंदील",
                "दिवे"
            ],
            "theme": "दिवाळीशी संबंधित",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "भात",
                "आमटी ",
                "पोळी",
                "भाजी"
            ],
            "theme": "दैनंदिन आहार",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आंबा",
                "सफरचंद",
                "केळं",
                "डाळिंब"
            ],
            "theme": "फळे",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "सायकल",
                "गाडी",
                "बस",
                "ट्रक"
            ],
            "theme": "वाहनप्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "मराठी",
                "हिंदी",
                "इंग्रजी",
                "संस्कृत"
            ],
            "theme": "भाषा",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अक्राळविक्राळ",
                "भयानक",
                "क्रूर",
                "अवाढव्य"
            ],
            "theme": "राक्षसाची विशेषणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "प्रतापी",
                "न्यायप्रिय",
                "प्रजावत्सल",
                "चक्रवर्ती"
            ],
            "theme": "राजाची विशेषणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "सज्जन",
                "प्रामाणिक",
                "सूज्ञ",
                "कष्टाळू"
            ],
            "theme": "सभ्य माणसाची विशेषणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "निशा",
                "यामिनी",
                "रजनी",
                "विभावरी"
            ],
            "theme": "रात्र समानार्थी शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "वर्षा",
                "वृष्टी",
                "पर्जन्य",
                "जलधारा"
            ],
            "theme": "पाऊस",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वसुधा",
                "भूमी",
                "धरा",
                "अवनी"
            ],
            "theme": "पृथ्वी तत्त्व",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भिंग",
                "दुर्बीण",
                "शोभादर्शक",
                "सूक्ष्मदर्शक"
            ],
            "theme": "वेगळे दृश्य दाखवणाऱ्या वस्तू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दूरदर्शन",
                "आकाशवाणी",
                "वृत्तपत्रे",
                "इंटरनेट"
            ],
            "theme": "प्रसारमाध्यमे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वीट",
                "मडके",
                "पिझ्झा",
                "देशी दारू"
            ],
            "theme": "भट्टी मधे बनणाऱ्या गोष्टी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भाव",
                "भात",
                "वेळ",
                "हवा"
            ],
            "theme": "या गोष्टी खातात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मूग",
                "राग",
                "औषधाची गोळी",
                "पाणी"
            ],
            "theme": "या गोष्टी गिळतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "थाप",
                "बंदुकीची गोळी",
                "टोमणा",
                "लाथ"
            ],
            "theme": "या गोष्टी मारतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झाडू",
                "कचरापेटी",
                "पुनर्वापर (Recycle)",
                "निर्जंतुक"
            ],
            "theme": "स्वच्छता या विषयाशी संबंधित शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "साबण",
                "शॅम्पू",
                "टॉवेल",
                "बादली"
            ],
            "theme": "अंघोळ विषयी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "केस",
                "भांडी",
                "कपडे",
                "फरशी"
            ],
            "theme": "पाणी आणि साबणाचे वापर",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सागर",
                "नदी",
                "तलाव",
                "विहीर"
            ],
            "theme": "पाण्याचे स्रोत",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "पेन",
                "पेन्सिल",
                "खोडरबर",
                "कोनमापक"
            ],
            "theme": "शालेय साहित्य",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "चहा",
                "कॉफी",
                "दूध",
                "सरबत"
            ],
            "theme": "पेय",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झोप",
                "भूक",
                "श्वास",
                "तहान"
            ],
            "theme": "मूलभूत गरजा",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "नाटक",
                "स्फुटलेखन",
                "कविता",
                "कथा"
            ],
            "theme": "साहित्य प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कृष्णविवर",
                "ग्रह",
                "चंद्र",
                "आकाशगंगा"
            ],
            "theme": "अंतरिक्षाशी संबंधित",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लोकमत",
                "सकाळ",
                "लोकसत्ता",
                "पुढारी"
            ],
            "theme": "मराठी वर्तमानपत्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "एबीपी माझा",
                "साम",
                "स्टार प्रवाह",
                "सह्याद्री"
            ],
            "theme": "मराठी वाहिन्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "भाडीपा",
                "मित्र म्हणे",
                "अमुक तमुक",
                "मधुरा रेसिपीज"
            ],
            "theme": "मराठी युट्युब चॅनेल",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मामा",
                "मामेबहीण",
                "मावसभाऊ",
                "मावशी"
            ],
            "theme": "मातुल (आईच्या बाजूचे) नातेवाईक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चुलता",
                "आत्तेभाऊ",
                "काकू",
                "आत्या"
            ],
            "theme": "वडलांच्या बाजूचे नातेवाईक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "दीर",
                "नणंद",
                "सासू",
                "जाऊ"
            ],
            "theme": "पतीच्या बाजूचे नातेवाईक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वातानुकूलक",
                "आंबा",
                "सुट्ट्या",
                "घाम"
            ],
            "theme": "उन्हाळा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "धुके",
                "सण",
                "हातमोजे",
                "शेकोटी"
            ],
            "theme": "थंडी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "चिखल",
                "छत्री",
                "बेडूक",
                "ढग"
            ],
            "theme": "पावसाळा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लता",
                "आशा",
                "उषा",
                "मीना"
            ],
            "theme": "मंगेशकर भगिनी ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "शिंपी",
                "सुतार",
                "लोहार",
                "गवंडी"
            ],
            "theme": "कारागीर",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "पोहणे",
                "सायकल",
                "धावणे",
                "उड्या मारणे "
            ],
            "theme": "व्यायाम",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकाश",
                "धरती",
                "पाणी",
                "वारा"
            ],
            "theme": "निसर्ग",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "टोमॅटो",
                "कांदा",
                "वांगी",
                "कारलं"
            ],
            "theme": "भाजीपाला",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "शिवणकाम",
                "भरतकाम",
                "चित्रकला",
                "ओरिगामी"
            ],
            "theme": "हस्तकला",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्वाभीमान",
                "निरामय",
                "मुळाक्षरे",
                "संतापी"
            ],
            "theme": "नद्यांची नावे लपलेले शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "चंद्र",
                "मेला",
                "विराम",
                "वट"
            ],
            "theme": "अर्ध____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "हार",
                "चादर",
                "मेणबत्ती",
                "नैवेद्य"
            ],
            "theme": "विविध धर्मातील देवाला वाहायच्या वस्तू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाडी",
                "सत्व",
                "वधू",
                "चाचणी"
            ],
            "theme": "____परीक्षा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "वमन",
                "विरेचन",
                "बस्ती",
                "नस्य"
            ],
            "theme": "आयुर्वेदिक पंचकर्म",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चूर्ण",
                "तेल",
                "गोळी",
                "मलम"
            ],
            "theme": "औषधांचे प्रकार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंबा",
                "अदा",
                "अडवा",
                "कला"
            ],
            "theme": "शेवटी नी लावल्यास आडनाव बनते",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "थांबा",
                "स्थानक",
                "वाहक",
                "चालक"
            ],
            "theme": "बस शी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "ठेला",
                "देठ",
                "पिंक",
                "मसाला"
            ],
            "theme": "पानाशी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "श्वेत",
                "धवल",
                "शुभ्र",
                "उजळ"
            ],
            "theme": "पांढरा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "जन्म",
                "भेट",
                "वसन",
                "विवाह"
            ],
            "theme": "पुनर् ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "उपाय",
                "गोमुख",
                "सुकर",
                "खतरनाक"
            ],
            "theme": "अवयव लपलेले शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पापण्या",
                "भुवया",
                "मिशा",
                "दाढी"
            ],
            "theme": "केस",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कात्री",
                "वस्तरा",
                "कंगवा",
                "ब्लेड"
            ],
            "theme": "केश कर्तनालय साधने",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वेणी",
                "साधनाकट",
                "खोपा",
                "अंबाडा"
            ],
            "theme": "केशरचना",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अणु",
                "शीत",
                "महा",
                "मल्ल"
            ],
            "theme": "___युद्ध",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गरम",
                "पावभाजी",
                "काळा",
                "पान"
            ],
            "theme": "___मसाला",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "लघु",
                "उप",
                "अनु",
                "पूर्व"
            ],
            "theme": "_____ग्रह",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चॉप",
                "रबर",
                "टेबल",
                "स्पिन"
            ],
            "theme": "टेबल टेनिस",
            "sharedBy": "क्रीडाप्रेमी",
            "difficulty": 0
        },
        {
            "words": [
                "स्मॅश",
                "ड्रॉप",
                "टॉस",
                "पदलालित्य(foot work)"
            ],
            "theme": "बॅडमिंटन",
            "sharedBy": "क्रीडाप्रेमी",
            "difficulty": 1
        },
        {
            "words": [
                "स्विंग",
                "ड्राइव्ह",
                "झेल (catch)",
                "रन"
            ],
            "theme": "क्रिकेट",
            "sharedBy": "क्रीडाप्रेमी",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विमा",
                "समभाग",
                "जमीन",
                "सोने"
            ],
            "theme": "गुंतवणूक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सूर्य",
                "वारा",
                "कोळसा",
                "धरण"
            ],
            "theme": "यापासून वीज निर्मिती करतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "आकाश",
                "साधू",
                "संत",
                "अन"
            ],
            "theme": "____वाणी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "परीघ",
                "कोन",
                "त्रिज्या",
                "कर्ण"
            ],
            "theme": "भूमितीय संज्ञा",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "कृपाचार्य",
                "व्यास",
                "अश्वत्थामा",
                "बली"
            ],
            "theme": "चिरंजीव",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "विश्वामित्र",
                "वसिष्ठ",
                "वाल्मिकी",
                "गौतम"
            ],
            "theme": "रामायणातील साधू",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कोलाहल",
                "पूजा",
                "चूक",
                "धुडगूस"
            ],
            "theme": "गोंधळ या शब्दाचे संभाव्य अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "अर्घ्य",
                "कन्या",
                "अन्न",
                "रक्त"
            ],
            "theme": "____दान",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दिवा",
                "फुलं",
                "घंटा",
                "पोथी"
            ],
            "theme": "देवघरातील वस्तू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चुना",
                "केशर",
                "वेलदोडा",
                "लवंग"
            ],
            "theme": "पानात वापरण्याचे पदार्थ",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "पिलू",
                "भूप",
                "अडाणा",
                "चारुकेशी"
            ],
            "theme": "राग",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "शर्मिष्ठा",
                "कच",
                "देवयानी",
                "शुक्राचार्य"
            ],
            "theme": "ययाती कादंबरीतली पात्र",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तार",
                "सांडणीस्वार",
                "कबुतर",
                "आंतरजाल"
            ],
            "theme": "संदेश पाठवण्याची माध्यमे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "भूर्जपत्र",
                "कागद",
                "फलक",
                "संगणक"
            ],
            "theme": "यावर संदेश लिहितात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "टाक",
                "झरणी",
                "टंकलेखनयंत्र",
                "तर्जनी"
            ],
            "theme": "या आधारे संदेश लिहितात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बालाजी",
                "बद्रीनाथ",
                "जगन्नाथ",
                "द्वारकाधीश"
            ],
            "theme": "भगवान विष्णू ची रूपे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मल्लिकार्जुन",
                "सोमनाथ",
                "केदारनाथ",
                "महाकालेश्वर"
            ],
            "theme": "भगवान शंकराची रूपे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "बल्लाळेश्वर",
                "मोरेश्वर",
                "चिंतामणी",
                "गिरिजात्मज"
            ],
            "theme": "गणपती ची रूपे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "महान",
                "संत",
                "दयाळू",
                "उदार"
            ],
            "theme": "उत्तम व्यक्ती वैशिष्टये",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "धूर्त",
                "महत्त्वाकांक्षी",
                "कंजूष",
                "अधीर"
            ],
            "theme": "मध्यम व्यक्ति वैशिष्टये",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "क्रूर",
                "कपटी",
                "दुष्ट",
                "नराधम"
            ],
            "theme": "नीचतम व्यक्ति वैशिष्टये",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रक्तवाहिनी",
                "बलरामपत्नी",
                "नक्षत्र",
                "हट्टंगडी"
            ],
            "theme": "रोहिणी",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "संगमा",
                "जाखड",
                "जोशी",
                "महाजन"
            ],
            "theme": "लोकसभा अध्यक्ष",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "संत",
                "शेळके",
                "चौधरी",
                "गोळे"
            ],
            "theme": "मराठी कवयित्री",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुरण",
                "गुळ",
                "आंबा",
                "खवा"
            ],
            "theme": "____ पोळी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "दारू",
                "शेअर बाजार",
                "रक्तदाब",
                "गिर्यारोहक"
            ],
            "theme": "या गोष्टी चढतात उतरतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चंद्र",
                "काजू",
                "केळी",
                "अंतर्वक्र आरसा"
            ],
            "theme": "अर्ध वक्र आकाराच्या गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठिय्या",
                "लाच",
                "मान",
                "लक्ष"
            ],
            "theme": "... देणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "रुबाब",
                "आरसा",
                "आस्मान",
                "दिवसा तारे"
            ],
            "theme": "... दाखवणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "उपास",
                "विचार",
                "सही",
                "भांडण"
            ],
            "theme": "... करणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ऑलिम्पिक",
                "एशियन",
                "स्क्विड",
                "कॉमनवेल्थ"
            ],
            "theme": "गेम्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शार्क",
                "स्विमिंग",
                "वॉटर",
                "फ्युएल"
            ],
            "theme": "टँक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "ब्ल्यू व्हेल",
                "पोकेमॉन",
                "पब्जी",
                "इम्पॉस्टर"
            ],
            "theme": "मोबाईल गेम्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बोटे",
                "ज्ञानेंद्रिय",
                "महासागर",
                "तारामासा (स्टारफिश)"
            ],
            "theme": "पाच(५)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ज्योतिर्लिंग",
                "एकताल",
                "डझन",
                "इंच"
            ],
            "theme": "बारा(१२)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "स्वर",
                "आश्चर्य",
                "आठवडा",
                "रूपक ताल"
            ],
            "theme": "सात(७)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मोजा",
                "म्यान",
                "आभरा",
                "पापण्या"
            ],
            "theme": "आवरण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कुबडी",
                "पांगुळगाडा",
                "टेकू",
                "अनाथालय/वृद्धाश्रम"
            ],
            "theme": "आधार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "तलवार",
                "भाला",
                "बाण",
                "गदा"
            ],
            "theme": "शस्त्रास्त्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सिंह",
                "वाघ",
                "गेंडा",
                "हत्ती"
            ],
            "theme": "जंगली प्राणी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मोबाईल",
                "लॅपटॉप",
                "टॅब्लेट",
                "टीव्ही"
            ],
            "theme": "इलेक्ट्रॉनिक साधने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "फुटबॉल",
                "क्रिकेट",
                "कबड्डी",
                "हॉकी"
            ],
            "theme": "खेळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढोल",
                "ताशा",
                "डीजे",
                "गर्दी"
            ],
            "theme": "गणपती मिरवणूक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "टाळ्या",
                "झांजा",
                "पाठांतर",
                "सामूहिक उच्चारण"
            ],
            "theme": "गणपती आरती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "शाडू",
                "पेण",
                "साचा",
                "सुबक"
            ],
            "theme": "गणेश मूर्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ओ पी",
                "एस डी",
                "आर डी",
                "ए आर"
            ],
            "theme": "हिंदी संगीतकारांची अद्याक्षरे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "केके",
                "मुकेश",
                "मन्नाडे",
                "के एल सैगल"
            ],
            "theme": "हिंदी गायक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "आर के",
                "बी आर",
                "प्रभात",
                "बॉंबे टॉकीज"
            ],
            "theme": "जुन्या हिंदी चित्रपट निर्मिती संस्था",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चक्रीवादळ",
                "भूकंप",
                "वणवा",
                "सुनामी"
            ],
            "theme": "नैसर्गिक आपत्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "वाटमारी",
                "दरोडा",
                "खून",
                "दंगल"
            ],
            "theme": "मानवनिर्मित आपत्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "टोळधाड",
                "कुत्रा चावणे",
                "प्लेगची साथ",
                "शार्क हल्ला"
            ],
            "theme": "प्राणी/सूक्ष्मजीव निर्मित आपत्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कर्तरी",
                "रसायनशास्त्र",
                "नाटक",
                "भावे"
            ],
            "theme": "प्रयोग (भाषा आणि इतर)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "श्लेष",
                "यमक",
                "सरगम",
                "मोहनमाळ"
            ],
            "theme": "अलंकार (भाषा आणि इतर)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "द्वंद्व",
                "तत्पुरुष",
                "बहुव्रीही",
                "अव्ययीभाव"
            ],
            "theme": "मराठी समास",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हिवाळा",
                "पावसाळा",
                "उन्हाळा",
                "शरद"
            ],
            "theme": "ऋतू",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "हात",
                "पाय",
                "डोळे",
                "कान"
            ],
            "theme": "शरीराचे अवयव",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "पराठा",
                "इडली",
                "डोसा",
                "उपमा"
            ],
            "theme": "नाश्ता",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नवरा",
                "आशिर्वाद",
                "अजून/जास्तीचे",
                "उंच"
            ],
            "theme": "वर या शब्दाचे अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "कचरा",
                "पाणी",
                "रस्ता",
                "दिवे"
            ],
            "theme": "नगरपालिकेची कामे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "कुंडी",
                "माठ",
                "पणती",
                "विटा"
            ],
            "theme": "माती पासून बनलेल्या वस्तू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उत्पत्ती",
                "उगम",
                "आरंभ",
                "महाविस्फोट"
            ],
            "theme": "सुरुवात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शेवट",
                "अंतिम",
                "निकाल",
                "पराकाष्ठा"
            ],
            "theme": "समाप्ती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "पर्यवेक्षक",
                "पुरवणी",
                "मौखिक",
                "मूल्यांकन"
            ],
            "theme": "परीक्षा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बोर",
                "मोहन",
                "जप",
                "तुळशी"
            ],
            "theme": "____माळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पाऊले",
                "झोप",
                "अंतर",
                "ठोके"
            ],
            "theme": "स्मार्ट वॉच या गोष्टी मोजते",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "सुरावट",
                "वर्तन",
                "रीत",
                "डाव"
            ],
            "theme": "चाल या शब्दाचे विविध अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंग",
                "क्षेत्र",
                "संस्कृती",
                "सुरक्षा"
            ],
            "theme": "_____रक्षक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गाव",
                "गड",
                "माळ",
                "कष्ट"
            ],
            "theme": "_____करी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "गढी",
                "हवेली",
                "वाडा",
                "कोठी"
            ],
            "theme": "जुन्या काळातील मोठी घरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मनगट",
                "गुडघा",
                "खांदा",
                "कोपर"
            ],
            "theme": "सांधे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "जीभ",
                "दंड",
                "मांडी",
                "पोटरी"
            ],
            "theme": "स्नायू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "डोळा",
                "त्वचा",
                "नाक",
                "कान"
            ],
            "theme": "ज्ञानेंद्रिय",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कर्ज",
                "ठेव",
                "बचत",
                "चालू"
            ],
            "theme": "बँकेतील खात्याचे प्रकार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "वाहन",
                "वैयक्तिक",
                "घर",
                "शिक्षण"
            ],
            "theme": "कर्जाचे प्रकार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "हप्ता",
                "दर",
                "मुदत",
                "तारण"
            ],
            "theme": "कर्जाची परिमाणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वार",
                "दिनांक",
                "मथळा",
                "बातमी"
            ],
            "theme": "वर्तमानपत्राच्या मुख्य पानावरील गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "घेवडा",
                "बाळ",
                "सरी",
                "मास"
            ],
            "theme": "श्रावण_____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "आमटी",
                "रहस्य",
                "तात्पर्य",
                "सरकव"
            ],
            "theme": "सार या शब्दाचे संभाव्य अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धावपट्टी",
                "उड्डाण",
                "डिजियात्रा",
                "चेकिन"
            ],
            "theme": "विमान प्रवास",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "स्टेशन",
                "रूळ",
                "बर्थ",
                "बोगदे"
            ],
            "theme": "रेल्वे प्रवास ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "टायर",
                "लाल परी",
                "घाट",
                "चालक"
            ],
            "theme": "रस्त्याने प्रवास ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झोप",
                "मृत्यू",
                "विचार",
                "ध्यान"
            ],
            "theme": "एकट्याच्या क्रिया/उपक्रम ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "पिकनिक",
                "क्रिकेट",
                "संमेलन",
                "सभा"
            ],
            "theme": "समूहाच्या क्रिया/उपक्रम  ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "बुद्धिबळ",
                "लग्न",
                "हस्तांदोलन",
                "द्वंद्वगीत"
            ],
            "theme": "दोन माणसांच्या क्रिया/उपक्रम ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घोडा",
                "गाढव",
                "उंट",
                "झेब्रा"
            ],
            "theme": "चार पायांचे प्राणी",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "रेडिओ",
                "टेलिव्हिजन",
                "वर्तमानपत्र",
                "इंटरनेट"
            ],
            "theme": "माहितीचे स्रोत",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "बालगीत",
                "गोष्टी",
                "फुगे",
                "खेळणी"
            ],
            "theme": "बालपणाशी संबंधित",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "व्याघ्रम्भर",
                "लवथवती",
                "कुरवंड्या",
                "फणिवरबंधना"
            ],
            "theme": "विविध आरत्यांमधील शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "पाताळदेवताहंता",
                "काळरुद्राग्नी",
                "मंद्राद्रीसारिखा",
                "भूतप्रेतसमंधादी"
            ],
            "theme": "मारुतीस्तोत्रातील शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "जानकीलक्षणोपेताम्",
                "द्रष्टुमपि शक्तास्ते",
                "चापबाण धरो",
                "विप्रप्रियम्"
            ],
            "theme": "रामरक्षेतील शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आंबा",
                "लायकी",
                "स्तर",
                "शिडी"
            ],
            "theme": "पायरी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "लकाकी",
                "वेदना",
                "धमक",
                "तेज"
            ],
            "theme": "चमक या शब्दाचे विविध अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "शिक्का",
                "चेहरा",
                "नाणी",
                "हावभाव"
            ],
            "theme": "मुद्रा या शब्दाचे विविध अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाळणा",
                "दूध",
                "अंगाई",
                "रांगणे"
            ],
            "theme": "बालपण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "पहिलं प्रेम",
                "महाविद्यालय",
                "नोकरी",
                "स्वप्न"
            ],
            "theme": "तारुण्य",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "आठवणी",
                "नातवंड",
                "निवृत्ती",
                "चष्मा"
            ],
            "theme": "वार्धक्य",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पद्मश्री",
                "ज्ञानपीठ",
                "साहित्य अकादमी",
                "पद्मभूषण"
            ],
            "theme": "भारतीय नागरी सन्मान",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "परमवीर",
                "शौर्य",
                "कीर्ती",
                "वीर"
            ],
            "theme": "__चक्र - सैन्य दलातील सन्मान",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "नोबेल",
                "मॅगसेसे",
                "पुलित्झर",
                "ऑस्कर"
            ],
            "theme": "आंतरराष्ट्रीय पारितोषिके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "किलबिल",
                "ढोल",
                "संगीत",
                "भरणे"
            ],
            "theme": "कानाचे अनुभव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दीपणे",
                "रंग",
                "प्रतिबिंब",
                "चित्र"
            ],
            "theme": "डोळ्याचे अनुभव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "श्वास",
                "कांदे सोलणे",
                "अत्तर",
                "सर्दी"
            ],
            "theme": "नाकासंबंधी अनुभव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वार",
                "घटिका",
                "सन",
                "तिथी"
            ],
            "theme": "दिन/समय दर्शक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कार",
                "वंत",
                "कृती",
                "कंद"
            ],
            "theme": "कला---",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "दार",
                "चोरवाट",
                "भुयार",
                "खिडकी"
            ],
            "theme": "प्रवेश मार्ग",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पंचम",
                "षड्ज",
                "गंधार",
                "धैवत"
            ],
            "theme": "संगीत स्वर",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ललित",
                "भिन्न षड्ज",
                "छायानट",
                "पिलू"
            ],
            "theme": "संगीत राग",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "एक",
                "खेमटा",
                "झप",
                "भजनी"
            ],
            "theme": "संगीत ताल",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अश्रूंची झाली",
                "प्रेमाच्या गावा",
                "रायगडाला जेंव्हा",
                "प्रेमा तुझा"
            ],
            "theme": "वसंत कानेटकर नाटके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दुरितांचे तिमिर",
                "देव दीनाघरी",
                "वाहतो ही",
                "सीमेवरून परत"
            ],
            "theme": "बाळ कोल्हटकर नाटके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "शांतता कोर्ट",
                "अशी पाखरे",
                "घाशीराम",
                "सखाराम"
            ],
            "theme": "विजय तेंडुलकर नाटके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अवतार",
                "दिशा",
                "बोटे",
                "दसरा"
            ],
            "theme": "दहा/दश ___",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "गुण",
                "काळ",
                "दोष",
                "देव"
            ],
            "theme": "तीन/त्रि ___",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "विनायक",
                "प्रहर",
                "योग",
                "पैलू"
            ],
            "theme": "आठ/अष्ट/अष्टांग ___",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विधिलिखित",
                "दैव",
                "प्राक्तन",
                "प्रारब्ध"
            ],
            "theme": "नशीब",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "परिणाम",
                "फळ",
                "निकाल",
                "निष्पत्ती"
            ],
            "theme": "अखेरीस जे मिळते/घडते",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "मनसुबा",
                "इच्छा",
                "इरादा",
                "उद्दिष्ट"
            ],
            "theme": "हेतू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मराठी",
                "हिंदी",
                "संस्कृत",
                "नेपाळी"
            ],
            "theme": "देवनागरी लिपी वापरणाऱ्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "देवनागरी",
                "रोमन",
                "अरबी",
                "कांजी"
            ],
            "theme": "विविध लिप्या",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "लॅटिन",
                "प्राकृत",
                "पाली",
                "अर्धमागधी"
            ],
            "theme": "लुप्त (आता वापरात नसलेल्या) भाषा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धडधड",
                "पत्र",
                "नजरानजर",
                "ओढ"
            ],
            "theme": "पाहिलं प्रेम",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "वधू",
                "मंडप",
                "सप्तपदी",
                "संसार"
            ],
            "theme": "लग्न",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "विभक्त",
                "न्यायालय",
                "पालकत्व",
                "पोटगी"
            ],
            "theme": "घटस्फोट",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बद्धकोष्ठ",
                "आम्लपित्त",
                "अपचन",
                "आमांश(डिसेंट्री)"
            ],
            "theme": "पोटाचे आजार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "रक्तदाब",
                "मधुमेह",
                "डोकेदुखी(मायग्रेन)",
                "लठ्ठपणा"
            ],
            "theme": "जीवनशैलीचे आजार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "क्षय",
                "धनुर्वात",
                "कॉलरा",
                "कुष्ठरोग"
            ],
            "theme": "जंतुजन्य आजार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "किसणी",
                "सुरी",
                "विळी",
                "कातणं"
            ],
            "theme": "स्वयंपाक घर - कापण्याची अवजारे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कुकर",
                "तवा",
                "कढई",
                "लंगरी"
            ],
            "theme": "स्वयंपाकघर - पदार्थ गरम करण्यासाठी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "डाव",
                "झारी",
                "चिमटा",
                "लाटणं"
            ],
            "theme": "स्वयंपाक घर लांबट अवजारे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "टाळाटाळ",
                "दिरंगाई",
                "आळस",
                "कंटाळा"
            ],
            "theme": "चालढकल/procrastination",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्य",
                "ध्यास",
                "महत्वाकांक्षा",
                "संकल्प"
            ],
            "theme": "ध्येय/goal",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "भिंग",
                "तन्मयता",
                "व्यग्रतामुक्तता",
                "निग्रह"
            ],
            "theme": "एकाग्रता/focus",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रामन",
                "मॅक्सवेल",
                "आईन्स्टाईन",
                "गॅलिलिओ"
            ],
            "theme": "प्रसिद्द भौतिक शास्त्र वैज्ञानिक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मेरी क्युरी",
                "लावासिये",
                "मेंडेलिव्ह",
                "प्रफुल्लचंद्र रे"
            ],
            "theme": "प्रसिद्द रसायनशास्त्र शास्त्र वैज्ञानिक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "युक्लिड",
                "युलर",
                "रामानुजन",
                "लाप्लास"
            ],
            "theme": "प्रसिद्ध गणितज्ञ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मंडाले",
                "एस. एन. गोएंका",
                "हेलन",
                "पांढरे हत्ती"
            ],
            "theme": "ब्रह्मदेश (म्यानमार)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मलमल",
                "रुना लैला",
                "डॉ. महम्मद युनूस",
                "ब्रह्मपुत्रेचे पूर"
            ],
            "theme": "बांगलादेश",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "ऋण कर्बभार(कार्बन फूटप्रिंट)",
                "राष्ट्रीय आनंद निर्देशांक(GHI)",
                "थिंफू",
                "दोचुला खिंड"
            ],
            "theme": "भूतान",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिहार",
                "अंदमान",
                "ग्वाटेमाला बे",
                "मंडाले"
            ],
            "theme": "तुरुंग",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "अहमदाबाद",
                "कलकत्ता",
                "बंगलोर",
                "लखनौ"
            ],
            "theme": "IIM संस्था शहरे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "मुंबई",
                "खड्गपूर",
                "दिल्ली",
                "चेन्नई"
            ],
            "theme": "IIT संस्था शहरे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घेराव",
                "मोर्चा",
                "संप",
                "निदर्शने"
            ],
            "theme": "सामूहिक निषेध",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "खड्डे",
                "बेशिस्त चालक",
                "मिरवणूक",
                "सिग्नल बिघाड"
            ],
            "theme": "ट्रॅफिक जॅम ची करणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "सायकल रिक्षा",
                "टांगा",
                "डोली",
                "व्हील चेअर"
            ],
            "theme": "स्वयंचलित नसलेली वाहने",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लघुकोन",
                "बर्मुडा",
                "प्रेमाचा ___",
                "१८० अंश"
            ],
            "theme": "त्रिकोण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "समलंब",
                "ते __ कुटुंब",
                "पतंगाकृती",
                "सुवर्ण महामार्ग प्रकल्प"
            ],
            "theme": "चौकोन/चौकोनी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "पिरॅमिड",
                "नाईल",
                "क्लिओपात्रा",
                "कैरो"
            ],
            "theme": "इजिप्त",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गण",
                "वर्ण",
                "योनी",
                "नाड"
            ],
            "theme": "पत्रिकेतील गुणमिलन",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "ओव्या",
                "अभंग",
                "श्लोक",
                "आर्या"
            ],
            "theme": "काव्य रचनेचे प्रकार",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "मघई",
                "बनारसी",
                "बंगला",
                "कपुरी"
            ],
            "theme": "विड्याची पाने",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बीळ",
                "वारूळ",
                "ढोली",
                "पोळं"
            ],
            "theme": "पक्षी/प्राणी/कीटक घरे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "गजेंद्र",
                "ऐरावत",
                "अश्वत्थामा",
                "जम्बो"
            ],
            "theme": "हत्ती",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "वासरू",
                "कोकरू",
                "बछडा",
                "रेडकू"
            ],
            "theme": "जनावरांची पिल्ले",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कळस",
                "माथा",
                "शिखर",
                "शेंडा"
            ],
            "theme": "उंची वरचा भाग",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "कडाप्पा",
                "ग्रॅनाईट",
                "संगमरवर",
                "कोटा"
            ],
            "theme": "थर असलेले दगड",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "शब्दवेधी",
                "वाक्",
                "मदन",
                "हवा"
            ],
            "theme": "बाण",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "एकेरी",
                "दुहेरी",
                "चक्राकार",
                "भुयारी"
            ],
            "theme": "वाहतुकीचे रस्ते",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "सहाण",
                "साळीच्या लाह्या",
                "मुंडावळी",
                "होमकुंड"
            ],
            "theme": "लग्नविधी",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "भरतनाट्यम",
                "मोहिनीअट्टम",
                "कत्थक",
                "ओडिसी"
            ],
            "theme": "नृत्यप्रकार",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दौलत",
                "चक्र",
                "पार्टनर",
                "गारंबीचा बापू"
            ],
            "theme": "प्रसिद्ध कादंबऱ्या",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "तर्जनी",
                "अनामिका",
                "करंगळी",
                "अंगठा"
            ],
            "theme": "बोटांची नावे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "रजनी",
                "यामिनी",
                "शर्वरी",
                "निशा"
            ],
            "theme": "रात्र",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अश्विनी",
                "भरणी",
                "कृतिका",
                "रोहिणी"
            ],
            "theme": "नक्षत्रं",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कविता",
                "शायरी",
                "दोहे",
                "अभंग"
            ],
            "theme": "काव्य प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "बायो",
                "केमिस्ट्री",
                "फिजिक्स",
                "गणित"
            ],
            "theme": "शालेय विषय",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झेंडा",
                "राष्ट्रगीत",
                "संविधान",
                "स्वातंत्र्य"
            ],
            "theme": "देशप्रेम",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "मामा",
                "काका",
                "आजोबा",
                "चुलता"
            ],
            "theme": "नातेसंबंध",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "उषःकाल",
                "सकाळ",
                "दुपार",
                "संध्याकाळ"
            ],
            "theme": "दिवसाचे भाग",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काजू",
                "बदाम",
                "अक्रोड",
                "मनुका"
            ],
            "theme": "सुकामेवा",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "घर",
                "बंगला",
                "अपार्टमेंट",
                "झोपडी"
            ],
            "theme": "निवास",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "रस्ता",
                "पूल",
                "महामार्ग",
                "चौक"
            ],
            "theme": "वाहतूक",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दिनांक",
                "महापौर",
                "केशकर्तनालय",
                "अद्ययावत"
            ],
            "theme": "स्वा. सावरकरांनी मराठी भाषेला दिलेले शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "नगरपालिका",
                "ग्रामपंचायत",
                "महानगरपालिका",
                "छावणी मंडळ"
            ],
            "theme": "स्थानिक नियामक मंडळे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "लाडकी बहिण",
                "प्रधानमंत्री आवास",
                "जनधन",
                "आयुष्मान भारत"
            ],
            "theme": "सरकारी योजना",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "देवनागरी",
                "चित्र",
                "ब्रेल",
                "ब्राह्मी"
            ],
            "theme": "लिपी",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "बोधी",
                "वट",
                "अजान",
                "देवदार"
            ],
            "theme": "दीर्घायु वृक्षांची नावे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "अभ्रक",
                "सोने",
                "गंधक",
                "कोळसा"
            ],
            "theme": "खाणीतून मिळणारे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मणका",
                "खुबा",
                "मनगट",
                "माकड"
            ],
            "theme": "हाड/सांधे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "किराणा",
                "जयपूर",
                "मेवाती",
                "पतियाळा"
            ],
            "theme": "शास्त्रीय संगीत घराणी",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "यामिनी",
                "शर्वरी",
                "निशा",
                "रजनी"
            ],
            "theme": "रात्र",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मरिना",
                "कलंगुट",
                "हंसा",
                "दोनापावला"
            ],
            "theme": "गोव्यातील बीच",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "कुंभार्ली",
                "नाणे",
                "बोर",
                "मेळ"
            ],
            "theme": "घाट",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "हेक्टर",
                "बिघा",
                "गुंठा",
                "एकर"
            ],
            "theme": "जमिनीचे मोजमाप",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झारी",
                "फवारणी",
                "खुरपी",
                "कलम"
            ],
            "theme": "बागकाम",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "हस्तिदंत",
                "चामडे",
                "ज्यूट",
                "नारळाच्या शेंड्या"
            ],
            "theme": "शोभेच्या वस्तूंसाठी वापर",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "मंदार",
                "बकुळ",
                "धोतरा",
                "नर्गिस"
            ],
            "theme": "फुलांची नावे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "निषाद",
                "मध्यम",
                "पंचम",
                "रिषभ"
            ],
            "theme": "सप्तसुरांतील चार सूर",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "पारद",
                "लोह",
                "ताम्र",
                "रजत"
            ],
            "theme": "धातू-संस्कृत नावे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "रव",
                "पथ",
                "यात्रा",
                "लालित्य"
            ],
            "theme": "पद___",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "महोत्सव",
                "मंदिर",
                "पदक",
                "तुला"
            ],
            "theme": "सुवर्ण___",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "रुची",
                "रस",
                "कल",
                "गोडी"
            ],
            "theme": "एखाद्या गोष्टीची आवड",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "अळी",
                "बटनहोल",
                "उलटी टीप",
                "गहू"
            ],
            "theme": "भारतकामातील टाके",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्रेम",
                "मृत्यू",
                "प्रतिज्ञा",
                "मुखत्यार"
            ],
            "theme": "पत्र",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "टका",
                "रुबल",
                "दीराम",
                "येन"
            ],
            "theme": "परदेशी चलन",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "नाणी",
                "चेक",
                "कार्ड",
                "युपीआय"
            ],
            "theme": "पैशाच्या व्यवहाराची माध्यमे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाञ्चजन्य",
                "अनंतविजय",
                "देवदत्त",
                "सुघोष"
            ],
            "theme": "शंखांची नावे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "अवयव",
                "पिंड",
                "कन्या",
                "अन्न"
            ],
            "theme": "दान",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "रास",
                "बलुतेदार",
                "मास",
                "ज्योतिर्लिंगे"
            ],
            "theme": "या गोष्टी बारा असतात",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठणठणपाळ",
                "लोकहितवादी",
                "बी",
                "ज्युलियन"
            ],
            "theme": "साहित्यिकांची टोपण नावे",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 0
        },
        {
            "words": [
                "लहसुनिया",
                "नीलम",
                "पोवळे",
                "गोमेद"
            ],
            "theme": "रत्न",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 1
        },
        {
            "words": [
                "हंबरणे",
                "केका",
                "आरवणे",
                "भुंकणे"
            ],
            "theme": "प्राण्यांचे आवाज",
            "sharedBy": "सुनंदा केळकर",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्षण",
                "वेळ",
                "पळ",
                "युग"
            ],
            "theme": "काळ/समय सूचक",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "नाद",
                "ध्वनी",
                "सूर",
                "गजर"
            ],
            "theme": "आवाज संबंधी",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "तेज",
                "प्रकाश",
                "झळाळी",
                "किरण"
            ],
            "theme": "प्रकाशासंबंधी",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाळ",
                "बंध",
                "गाठ",
                "जोड"
            ],
            "theme": "जवळचा संबंध",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "जाळं",
                "कोळी",
                "मासा",
                "होडी"
            ],
            "theme": "मत्स्य व्यवसाय",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "नाखवा",
                "सारंगा",
                "डोलकर",
                "कोलीवारा"
            ],
            "theme": "कोळी गीतातील शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "एकटा",
                "वर्षाव",
                "डोंगर सपाटी",
                "पखरण"
            ],
            "theme": "सडा या शब्दाचे विविध अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "जमाव",
                "संचार",
                "दारू",
                "नजर"
            ],
            "theme": "____बंदी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अंकुर",
                "सुट्टे",
                "तुटकी भांडी",
                "वळण"
            ],
            "theme": "मोड या शब्दाचे विविध अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विहीर",
                "हातपंप",
                "नळ",
                "हंडा"
            ],
            "theme": "पिण्याच्या पाण्याची व्यवस्था",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "बोगदा",
                "मूळ",
                "खनिज",
                "भूजल"
            ],
            "theme": "जमिनी खालच्या गोष्टी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "नांगर",
                "बी",
                "पीक",
                "खत"
            ],
            "theme": "शेतीशी संबंधित",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "थंड",
                "गरम",
                "कोमट",
                "उबदार"
            ],
            "theme": "तापमान",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "आंबट",
                "तिखट",
                "गोड",
                "खारट"
            ],
            "theme": "चवी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "मीठ",
                "मसाला",
                "तेल",
                "साखर"
            ],
            "theme": "स्वयंपाकातील पदार्थ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काच",
                "आरसा",
                "प्रकाश",
                "प्रतिबिंब"
            ],
            "theme": "परावर्तनाशी संबंधित",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "वृत्तपत्र",
                "वार्ता",
                "शीर्षक",
                "संपादक"
            ],
            "theme": "बातमीशी संबंधित",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "नदी",
                "किनारा",
                "तरंग",
                "सागर"
            ],
            "theme": "पाण्याशी संबंधित पण भिन्न पातळ्यांवर",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साधू",
                "संत",
                "दिवाळी",
                "दसरा"
            ],
            "theme": "येति घरा.. एक म्हण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "नागपंचमी",
                "गोकुळाष्टमी",
                "रक्षाबंधन",
                "मंगळागौर"
            ],
            "theme": "श्रावणातील सण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "घोणस",
                "नाग",
                "तस्कर",
                "नानेटी"
            ],
            "theme": "सापांचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "केळे",
                "टॅपिओका",
                "बटाटा",
                "रताळे"
            ],
            "theme": "यांचे चिप्स (पातळ काप) करतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कांदा",
                "घोसाळे",
                "मिरची",
                "ओव्याची पाने"
            ],
            "theme": "यांची भजी करतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "दुधी",
                "गाजर",
                "मूग",
                "काटेरी"
            ],
            "theme": "... हलवा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाय",
                "सायकल",
                "रिक्षा",
                "बस"
            ],
            "theme": "प्रवासाची साधने",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "गोमूत्र",
                "हळद",
                "कुंकू",
                "फुलं"
            ],
            "theme": "पूजेसाठी उपयोगी",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "इन्स्टा",
                "व्हाट्सअप",
                "फेसबुक",
                "यूट्यूब"
            ],
            "theme": "सोशल मीडिया",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साडी",
                "धोतर",
                "शर्ट",
                "कुर्ता"
            ],
            "theme": "कपडे",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "जणू",
                "खरं तर",
                "बहुधा",
                "केवळ"
            ],
            "theme": "क्रियाविशेषणे",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "गड",
                "किल्ला",
                "तट",
                "बुरुज"
            ],
            "theme": "दुर्गशास्त्र",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कुरकुरीत",
                "चविष्ट",
                "गोडसर",
                "तिखट"
            ],
            "theme": "चव वर्णन",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "झाड",
                "फुलं",
                "पाने",
                "फळं"
            ],
            "theme": "वनस्पती",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कारखाना",
                "शेत",
                "दुकान",
                "कार्यालय"
            ],
            "theme": "कामाची ठिकाणं",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मंचाव",
                "पाखडणी",
                "गणेशाचे कान",
                "शोरबा"
            ],
            "theme": "सूप (मराठी व इंग्रजी)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "उफणणी",
                "कापणी",
                "नांगरणी",
                "मळणी"
            ],
            "theme": "शेतीतील कामे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नांगर",
                "तिफण",
                "विळा",
                "डवरा"
            ],
            "theme": "शेतीतील अवजारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठेचा",
                "चटणी",
                "छुन्दा",
                "लोणचं"
            ],
            "theme": "भोजनासोबत खाल्ले जाणारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चाटण",
                "लेह्य",
                "अवलेह",
                "रसायन"
            ],
            "theme": "आयुर्वेदिक चाटून खायची औषधे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ज्योतिष",
                "वास्तू",
                "खगोल",
                "भाषा"
            ],
            "theme": "काही प्राचीन शास्त्र पद्धती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खडतर",
                "कंटाळवाणे",
                "सुरळीत",
                "धकाधकीचे"
            ],
            "theme": "आयुष्याची विशेषणे",
            "sharedBy": "makj9",
            "difficulty": 0
        },
        {
            "words": [
                "नागमोडी",
                "खडबडीत",
                "सरळसोट",
                "चिंचोळा"
            ],
            "theme": "रस्त्याची विशेषणे",
            "sharedBy": "makj9",
            "difficulty": 1
        },
        {
            "words": [
                "गुगल मॅप्स",
                "नकाशा",
                "होकायंत्र",
                "ध्रुव तारा"
            ],
            "theme": "दिशा दर्शक",
            "sharedBy": "makj9",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चतुर",
                "मधमाशी",
                "झुरळ",
                "डास"
            ],
            "theme": "उडते किडे",
            "sharedBy": "makj9",
            "difficulty": 0
        },
        {
            "words": [
                "चलाख",
                "धूर्त",
                "वस्ताद",
                "पक्का"
            ],
            "theme": "हुशार माणूस",
            "sharedBy": "makj9",
            "difficulty": 1
        },
        {
            "words": [
                "मंद",
                "जलद",
                "सुसाट",
                "धीमा"
            ],
            "theme": "वेग",
            "sharedBy": "makj9",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हंगेरी",
                "जपान",
                "इटली",
                "जर्मनी"
            ],
            "theme": "महायुद्ध-२:अक्ष (axis) राष्ट्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "सोव्हिएत संघ",
                "अमेरिका",
                "ब्रिटन",
                "फ्रान्स"
            ],
            "theme": "महायुद्ध-२:मित्र राष्ट्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "स्वित्झर्लंड",
                "स्वीडन",
                "पोर्तुगाल",
                "तुर्कस्तान"
            ],
            "theme": "महायुद्ध-२:तटस्थ राष्ट्रे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "व्हेनेझुएला",
                "चिली",
                "पेरू",
                "अर्जेंटिना"
            ],
            "theme": "दक्षिण अमेरिका देश",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "सीताफळ",
                "लिची",
                "सफरचंद",
                "द्राक्ष"
            ],
            "theme": "फळे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "मेसी",
                "टॅंगो",
                "इग्वाझू",
                "फुटबॉल"
            ],
            "theme": "अर्जेंटिना",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुळसुळीत",
                "राठ",
                "दाट",
                "विरळ"
            ],
            "theme": "केस",
            "sharedBy": "makj9",
            "difficulty": 0
        },
        {
            "words": [
                "पर्णपाती",
                "घनदाट",
                "सदाहरित",
                "खारफुटी"
            ],
            "theme": "जंगलांचे प्रकार",
            "sharedBy": "makj9",
            "difficulty": 1
        },
        {
            "words": [
                "गुळगुळीत",
                "खडबडीत",
                "चिकट",
                "मखमली"
            ],
            "theme": "पृष्ठभागाचे पोत/texture प्रकार",
            "sharedBy": "makj9",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घंटा",
                "बासरी",
                "ढोल",
                "तबला"
            ],
            "theme": "वाद्ये",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "दात",
                "नाक",
                "डोळे",
                "कान"
            ],
            "theme": "इंद्रिये",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "हरभरा",
                "मूग",
                "मसूर",
                "उडीद"
            ],
            "theme": "डाळी",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सायकल",
                "ट्रक",
                "बाईक",
                "स्कूटर"
            ],
            "theme": "रस्त्यावरील वाहनं",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "पहाट",
                "संध्याकाळ",
                "मध्यरात्र",
                "मध्यान्ह"
            ],
            "theme": "वेळ",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "झाडं",
                "जनावरे",
                "माणसं",
                "पक्षी"
            ],
            "theme": "जीवसृष्टी",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अमनदीप",
                "दीप्ती",
                "स्मृती",
                "ऋचा"
            ],
            "theme": "क्रिकेट विश्वविजेत्या खेळाडू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ज्वाला",
                "सिंधू",
                "साईना",
                "अश्विनी"
            ],
            "theme": "बॅडमिंटनपटू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "साक्षी",
                "मीराबाई",
                "मनू",
                "मल्लेश्वरी"
            ],
            "theme": "ऑलिम्पिक पदक विजेत्या खेळाडू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साद",
                "हाळी",
                "हाक",
                "आवाज"
            ],
            "theme": "मोठ्याने बोलावणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "वाद",
                "कलह",
                "भांडण",
                "तंटा"
            ],
            "theme": "झगडा वैर",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "त्रुटी",
                "खोट",
                "बिघाड",
                "दोष"
            ],
            "theme": "लहान मोठी कमतरता",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धागा",
                "सुई",
                "कापड",
                "काजे"
            ],
            "theme": "शिवणकाम",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "लाकूड",
                "खिळा",
                "करवत",
                "रंधा"
            ],
            "theme": "सुतारकाम",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "भट्टी",
                "हातोडा",
                "निखारा",
                "लोखंड"
            ],
            "theme": "लोहारकाम",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंद्र",
                "सूर्य",
                "नक्षत्र",
                "ग्रह"
            ],
            "theme": "आकाशीय वस्तू",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "थंडी",
                "गरम",
                "ओलसर",
                "कोरडे"
            ],
            "theme": "हवामान",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "गोल",
                "चौरस",
                "त्रिकोण",
                "आयत"
            ],
            "theme": "आकार",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "त्रिज्या",
                "परीघ",
                "जिवा",
                "पाय"
            ],
            "theme": "भूमितीतील वर्तुळ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "शेपूट",
                "वशिंड",
                "खूर",
                "शिंग"
            ],
            "theme": "गाय/बैल",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "टाच",
                "बोटे",
                "नखे",
                "चवडा"
            ],
            "theme": "तळपाय",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फुगा",
                "तुतारी",
                "मेणबत्ती",
                "शिट्टी"
            ],
            "theme": "फुंकण्याशी संबंधित",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "केक",
                "टोपी",
                "मित्रमैत्रिणी",
                "भेटवस्तू"
            ],
            "theme": "वाढदिवस साजरा करणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "गांधी",
                "पगडी",
                "बॅगी",
                "साफा"
            ],
            "theme": "टोप्यांचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्रोध",
                "लोभ",
                "मत्सर",
                "मद"
            ],
            "theme": "मानवी षड्रिपू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "भीती",
                "स्पर्धा",
                "कुतूहल",
                "आळस"
            ],
            "theme": "मानवी प्रवृत्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "सेवा",
                "संयम",
                "दानशूरता",
                "विवेक"
            ],
            "theme": "मानवी सद्गुण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हरभजन",
                "दोशी",
                "कुंबळे",
                "हिरवाणी"
            ],
            "theme": "क्रिकेट - फिरकी गोलंदाज",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कपिल",
                "अक्षर",
                "शास्त्री",
                "युवराज"
            ],
            "theme": "क्रिकेट - अष्टपैलू खेळाडू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "किरमाणी",
                "किरण",
                "महेंद्र",
                "मोंगिया"
            ],
            "theme": "क्रिकेट - यष्टीरक्षक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झाडू",
                "निर्जंतुक",
                "चकाचक",
                "सफाई"
            ],
            "theme": "स्वच्छते संबंधी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "विषाणू",
                "संसर्ग",
                "कॉलरा",
                "जीवाणू"
            ],
            "theme": "रोग जंतू विषयी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "कृमी",
                "हायड्रा",
                "प्रवाळ",
                "बुरशी"
            ],
            "theme": "बहूपेशीय सूक्ष जीव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "त्रिविक्रीम",
                "जनार्दन",
                "अच्युत",
                "नारायण"
            ],
            "theme": "श्री विष्णू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चतुरानन",
                "प्रजापती",
                "वेदज्ञ",
                "कमलासन"
            ],
            "theme": "श्री ब्रह्मदेव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "रुद्र",
                "गंगाधर",
                "विश्वनाथ",
                "पशुपती"
            ],
            "theme": "श्री शंकर",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पिठलं",
                "भाकरी",
                "भाजी",
                "लोणचं"
            ],
            "theme": "ग्रामीण जेवण",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "कढई",
                "तवा",
                "भांडे",
                "झारा"
            ],
            "theme": "स्वयंपाक भांडी",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "हसणं",
                "रडणं",
                "ओरडणं",
                "कुजबुजणं"
            ],
            "theme": "प्रतिक्रिया",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्रेषित",
                "यक्षांची देणगी",
                "अंतराळातील स्फोट",
                "टाइम मशीनची किमया"
            ],
            "theme": "जयंत नारळीकर पुस्तके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चंद्राची सावली",
                "इक्माई",
                "पारंब्यांचे जग",
                "समर्थांचिया सेवका"
            ],
            "theme": "नारायण धारप पुस्तके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "पिंगळा वेळ",
                "रक्तचंदन",
                "सांजशकुन",
                "काजळमाया"
            ],
            "theme": "जी ए कुलकर्णी पुस्तके",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्रसव",
                "उद्गम",
                "उत्पत्ती",
                "प्रकटन"
            ],
            "theme": "जन्म",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "प्राण",
                "अस्तित्व",
                "जीवन",
                "चेतना"
            ],
            "theme": "जगणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "श्वास",
                "धडधड",
                "नाडी",
                "पचन"
            ],
            "theme": "जीवन क्रिया",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लोकल",
                "पावभाजी",
                "बॉलिवूड",
                "डबेवाला"
            ],
            "theme": "मुंबई",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दुर्गापूजा",
                "संदेश",
                "हावडा पूल",
                "ट्राम"
            ],
            "theme": "कोलकत्ता",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "कुतुब मिनार",
                "छोले भटुरे",
                "संसद",
                "चांदणी चौक"
            ],
            "theme": "दिल्ली",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पट",
                "चेक",
                "प्यादे",
                "एल पसांट"
            ],
            "theme": "बुद्धिबळ शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ऑफसाईड",
                "गोल",
                "पेनल्टी",
                "पास"
            ],
            "theme": "फुटबॉल (सॉकर) शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "ड्यूस",
                "व्हॉली",
                "एस",
                "फॉल्ट"
            ],
            "theme": "टेनिस शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकाश",
                "पाणी",
                "माती",
                "अग्नी"
            ],
            "theme": "पंचमहाभूत",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "ढगाळ",
                "कोसळणारा",
                "हलकासा",
                "वीजांसह"
            ],
            "theme": "पावसाचे प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "सोमवार",
                "मंगळवार",
                "बुधवार",
                "गुरुवार"
            ],
            "theme": "आठवड्याचे दिवस",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घर",
                "कुटुंब",
                "नातेसंबंध",
                "प्रेम"
            ],
            "theme": "कौटुंबिक जीवन",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "भिंत",
                "छत",
                "दरवाजा",
                "खिडकी"
            ],
            "theme": "घराचे भाग",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "पाटी",
                "खडू",
                "वह्या",
                "पुस्तके"
            ],
            "theme": "शालेय साहित्य",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घड्याळ",
                "कॅलेंडर",
                "वेळ",
                "दिनांक"
            ],
            "theme": "वेळ दर्शक गोष्टी",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "शुद्धलेखन",
                "व्याकरण",
                "वाचन",
                "लेखन"
            ],
            "theme": "भाषाशिक्षण",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "स्वयंपाकघर",
                "हॉल",
                "बेडरूम",
                "बाथरूम"
            ],
            "theme": "घरातली खोली",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "परवा",
                "काल",
                "आज",
                "उद्या"
            ],
            "theme": "काळ",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "दही",
                "ताक",
                "लोणी",
                "तूप"
            ],
            "theme": "दुग्धजन्य पदार्थ",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "ओढा",
                "प्रवाह",
                "धबधबा",
                "सरोवर"
            ],
            "theme": "पाण्याचे प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नदी",
                "समुद्र",
                "तलाव",
                "विहीर"
            ],
            "theme": "जलस्रोत",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "भात",
                "पोहे",
                "साबुदाणा",
                "उपमा"
            ],
            "theme": "उपाहाराचे पदार्थ",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "मंद",
                "जोरदार",
                "सोसाट्याचा",
                "झुळूक"
            ],
            "theme": "वाऱ्याचे प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दंड",
                "कैद",
                "फाशी",
                "शासन"
            ],
            "theme": "शिक्षेच्या संबंधित",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 0
        },
        {
            "words": [
                "आसन",
                "प्राण",
                "ध्यान",
                "मुद्रा"
            ],
            "theme": "योग संबंधित",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 1
        },
        {
            "words": [
                "मुकुट",
                "राजदंड",
                "छत्र",
                "राजमुद्रा"
            ],
            "theme": "राजाशी संबंधित",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हातमाग",
                "नतमस्तक",
                "तरणोपाय",
                "खतरनाक"
            ],
            "theme": "अवयव लपलेले शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "तत्वज्ञान",
                "रहस्यमय",
                "चरित्र",
                "अध्यात्मिक"
            ],
            "theme": "साहित्य प्रकार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वेड",
                "लय भारी",
                "माऊली",
                "अदृश्य"
            ],
            "theme": "रितेश देशमुख चित्रपट",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चमू",
                "गट",
                "संघ",
                "मंडळ"
            ],
            "theme": "समूह",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शाखा",
                "जय",
                "तरण",
                "वाद"
            ],
            "theme": "वि ___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वाचा",
                "व्यापारी",
                "बोली",
                "सरस्वती"
            ],
            "theme": "वाणी या शब्दाचे विविध अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गवळी",
                "कासकर",
                "सुर्वे",
                "निकाजळे"
            ],
            "theme": "मुंबई अंडरवर्ल्ड",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेपरवाला",
                "स्कूल बस",
                "जॉगिंग",
                "सफाई कामगार"
            ],
            "theme": "सकाळी लवकर दिसणाऱ्या गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वानखेडे",
                "होळकर",
                "पाटील",
                "मोदी"
            ],
            "theme": "प्रसिद्ध क्रिकेट मैदानं",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आईस्क्रीम",
                "पान",
                "ताक",
                "सुपारी"
            ],
            "theme": "जेवणा नंतर घेतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ताड",
                "माड",
                "खजूर",
                "अशोक"
            ],
            "theme": "सरळ रेषेत उंच वाढणारी झाडे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "आवळा",
                "अश्वगंधा",
                "मध",
                "साजूक तूप"
            ],
            "theme": "च्यवनप्राश प्रमुख घटक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाटलीपुत्र",
                "बिंदुसार",
                "संघमित्रा",
                "कलिंग"
            ],
            "theme": "सम्राट अशोक संबंधी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "धम्मचक्र",
                "लुम्बिनी",
                "शुद्धोधन",
                "दुःख"
            ],
            "theme": "सिद्धार्थ गौतम बुद्ध",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "चेतक",
                "हल्दीघाटी",
                "चित्तौडगड",
                "उदयसिंह"
            ],
            "theme": "महाराणा प्रताप",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हंस",
                "दूत",
                "गादी",
                "कारण"
            ],
            "theme": "ज्यांच्या मागे 'राज...' लागते",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 0
        },
        {
            "words": [
                "मुरली",
                "चक्र",
                "गंगा",
                "गिरी"
            ],
            "theme": "ज्यांच्या पुढे '...धर' लागते",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 1
        },
        {
            "words": [
                "चुना",
                "शेंडी",
                "थापा",
                "लोणी"
            ],
            "theme": "...लावणे' म्हणजे फसवणे/खोटे बोलणे",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुतळा",
                "स्मृती पुरस्कार",
                "टपाल तिकीट",
                "सार्वजनिक सुट्टी"
            ],
            "theme": "महान व्यक्तींची स्मृती जागृत ठेवायचे मार्ग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शिक्का",
                "स्पंज",
                "नोटा",
                "पेन"
            ],
            "theme": "बँक कैशियर कडे असणाऱ्या गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "शाई",
                "बॉल",
                "फाऊंटन",
                "जेल"
            ],
            "theme": "पेन चे प्रकार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सकाळी",
                "दुपारी",
                "संध्याकाळी",
                "रात्री"
            ],
            "theme": "वेळेचे वर्णन",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "किराणा",
                "भाजी",
                "फळं",
                "दूध"
            ],
            "theme": "घरच्या खरेदीच्या गोष्टी",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कमळ",
                "गुलाब",
                "जाई",
                "मोगरा"
            ],
            "theme": "फुलं",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मोर",
                "घार",
                "तळे",
                "घोडे"
            ],
            "theme": "...गाव",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 0
        },
        {
            "words": [
                "नाग",
                "कोल्हा",
                "बाळा",
                "राजा"
            ],
            "theme": "...पूर",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 1
        },
        {
            "words": [
                "सिंह",
                "देव",
                "जय",
                "प्रबळ"
            ],
            "theme": "...गड",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गुजरात",
                "लोहपुरुष",
                "गृहमंत्री",
                "एकतेचा पुतळा"
            ],
            "theme": "वल्लभभाई पटेल",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "प्रियदर्शिनी",
                "आणीबाणी",
                "ब्लू स्टार",
                "पोखरण"
            ],
            "theme": "इंदिरा गांधी",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बालदिन",
                "मोतीलाल",
                "डिस्कवरी ऑफ इंडिया",
                "चाचा"
            ],
            "theme": "जवाहरलाल नेहरू",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हजार",
                "रोकड",
                "एटीएम",
                2016
            ],
            "theme": "नोटबंदी",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भोपाळ",
                1984,
                "वायू",
                "युनियन कार्बाइड"
            ],
            "theme": "भोपाळ वायू दुर्घटना",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ताज",
                "कसाब",
                2008,
                "अतिरेकी"
            ],
            "theme": "मुंबई २६/११ हल्ला",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "देऊळ",
                "विहीर",
                "मसाला",
                "हायवे"
            ],
            "theme": "उमेश आणि गिरीश कुलकर्णी चित्रपट",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गिरणी",
                "बांधकाम",
                "बेकरी",
                "ज्वालामुखी"
            ],
            "theme": "येथे तुमच्या अंगावर पांढरा थर जमू शकतो",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "नदी",
                "ओढा",
                "कॅनाल",
                "पाट"
            ],
            "theme": "वाहते पाणी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फेसाळते",
                "गढूळ",
                "उथळ",
                "खळाळते"
            ],
            "theme": "पाणी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "खडतर",
                "सुखमय",
                "धकाधकीचे",
                "परिपूर्ण"
            ],
            "theme": "जीवन",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "कच्चा",
                "खडबडीत",
                "वळणावळणाचा",
                "डांबरी"
            ],
            "theme": "रस्ता",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आरती",
                "प्रसाद",
                "शंख",
                "तुळस"
            ],
            "theme": "हिंदू",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "अजान",
                "किब्ला",
                "वजू",
                "सजदा"
            ],
            "theme": "इस्लाम",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कडा",
                "किरपान",
                "कीर्तन",
                "गुरुद्वारा"
            ],
            "theme": "शीख",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मत्स्य",
                "वामन",
                "गरुड",
                "स्कंद"
            ],
            "theme": "पुराण",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "ईश",
                "कठ",
                "मैत्री",
                "छांदोग्य"
            ],
            "theme": "उपनिषद",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "ऋग्",
                "साम",
                "यजु:",
                "अथर्व"
            ],
            "theme": "वेद",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "व्रात्य",
                "द्वाड",
                "खट्याळ",
                "उनाड"
            ],
            "theme": "खोडकर नटखट या अर्थी",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "खळखळाट",
                "उथळ",
                "पाणी",
                "म्हण"
            ],
            "theme": "एक मराठी म्हण",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "उदक",
                "तोय",
                "सलील",
                "अंबु"
            ],
            "theme": "पाणी/जल ला समानार्थी शब्द",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पंखा",
                "कुलर",
                "एसी",
                "झुरळपंखा"
            ],
            "theme": "थंडी करणारी साधने",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "ऊन",
                "छाया",
                "सावली",
                "तडका"
            ],
            "theme": "प्रकाशाचे प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "धावणे",
                "थांबणे",
                "चालणे",
                "बसणे"
            ],
            "theme": "हालचाली",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खांदा",
                "तिरडी",
                "मडके",
                "चिता"
            ],
            "theme": "मृत्यूपश्चात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "माठ",
                "सुरई",
                "कुंडी",
                "पणती"
            ],
            "theme": "मातीच्या वस्तू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "गुडघा",
                "कंबर",
                "कोपर",
                "मनगट"
            ],
            "theme": "शरीरातील सांधे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हूल",
                "जरीला",
                "झूल",
                "कोसला"
            ],
            "theme": "ज्ञानपीठकार भालचंद्र नेमाडे लिखित",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 0
        },
        {
            "words": [
                "झोंबी",
                "गोतावळा",
                "नांगरणी",
                "नटरंग"
            ],
            "theme": "आनंद यादव लिखित",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 1
        },
        {
            "words": [
                "सत्तांतर",
                "उंबरठा",
                "बनगरवाडी",
                "करुणाष्टक"
            ],
            "theme": "व्यंकटेश माडगूळकर लिखित",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेंढा",
                "मासा",
                "खेकडा",
                "बैल"
            ],
            "theme": "राशी ची चिन्हे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "कासव",
                "मगर",
                "पाणघोडा",
                "बेडूक"
            ],
            "theme": "उभयचर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मोर",
                "उंदीर",
                "रेडा",
                "गरुड"
            ],
            "theme": "विविध देवांची वाहने असलेले प्राणी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नारळी",
                "त्रिपुरी",
                "गुरु",
                "कोजागिरी"
            ],
            "theme": "पौर्णिमा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मंगळ",
                "शनी",
                "बुध",
                "पृथ्वी"
            ],
            "theme": "ग्रह",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "तारा",
                "शुक्र",
                "वारा",
                "मंद"
            ],
            "theme": "प्रसिद्ध भावगीत",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कापूस",
                "खोबरे",
                "बर्फ",
                "रस्सा"
            ],
            "theme": "पांढरा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "सूत",
                "वात",
                "मलमपट्टी",
                "गादी"
            ],
            "theme": "कापसाचे उपयोग",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "फरसाण",
                "कांदा",
                "तर्री",
                "मटकी"
            ],
            "theme": "मिसळीचे घटक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काश्मीरी",
                "लवंगी",
                "भूत जोलोकिया",
                "ब्याडगी"
            ],
            "theme": "मिरच्यांचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्मी",
                "सुतळी",
                "पानपट्टी",
                "आपटबार"
            ],
            "theme": "आवाजी फटाक्यांचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "भुई",
                "सुदर्शन",
                "काल",
                "राशी"
            ],
            "theme": "...चक्र",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्लेटीपस",
                "कांगारू",
                "कोआला",
                "वोम्बॅट"
            ],
            "theme": "फक्त ऑस्ट्रेलिया खंडात आढळणारे सस्तन प्रजातीतील प्राणी",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ट्रायसेरेटॉप्स",
                "व्हेलोसी रॅप्टर",
                "स्टिगॅसॉरस",
                "टिरॅनॉसॉरस"
            ],
            "theme": "डायनासॉर प्रजातीतील प्राणी",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चित्ता",
                "जिराफ",
                "पेंगवीन",
                "ध्रुवीय अस्वल"
            ],
            "theme": "भारतात न आढळणारे प्राणी (प्राणिसंग्रहालये वगळता)",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रक्त",
                " जास्वंद",
                " माणिक",
                " सफरचंद"
            ],
            "theme": "लाल रंगाच्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भांगडा",
                " सलवारखमीज",
                " गहू",
                " हॉकी"
            ],
            "theme": " पंजाबशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "ढाल",
                "करंडक",
                "पदक",
                "चक्र"
            ],
            "theme": "पारितोषिके",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेण",
                "आइस्क्रीम",
                "मीठ",
                "हृदय"
            ],
            "theme": "विरघळणार्या / पाघळणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "समुद्र",
                "पोफळी",
                "मोदक",
                "आंबा"
            ],
            "theme": "कोकणातील गोष्टी ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "कविता",
                " हुजूरपागा",
                "आनंदाचे झाड",
                "ऋतू हिरवा"
            ],
            "theme": "कवयित्री शांता शेळके यांच्याशी संबंधित",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हात",
                "चौकट",
                "हुकूम",
                "विदुषक"
            ],
            "theme": "पत्ते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गाऊन",
                "तराजू",
                "सर्वोच्च",
                "कायदा"
            ],
            "theme": "न्यायालय",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सागरा धरणी",
                "संधी",
                "जागा",
                "नोकरी"
            ],
            "theme": "ही “मिळते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुतार",
                "लोहपुरुष",
                "साधू बेट",
                "एकता"
            ],
            "theme": "सरदार पटेल पुतळा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "लाकूड",
                "रंधा",
                "कपाट",
                "करवत"
            ],
            "theme": "सुतारकाम",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "ऐरण",
                "भट्टी",
                "भाता",
                "घण"
            ],
            "theme": "लोहारकाम",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कथा",
                "काम",
                "योग",
                "कळ"
            ],
            "theme": "--सूत्र",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "भाग्य",
                "विधिलिखित",
                "प्रारब्ध",
                "दैव"
            ],
            "theme": "नशीब",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "क्रोध",
                "मद",
                "मत्सर",
                "लोभ"
            ],
            "theme": "षडरिपू पैकी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "राक्षस",
                "मलयकेतू",
                "विक्रमादित्य",
                "चाणक्य"
            ],
            "theme": "मुद्राराक्षस (किंवा चाणक्य कथेमधील) पात्र",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "जय",
                "बलदेव सिंग",
                "राधा",
                "कालिया"
            ],
            "theme": "शोले चित्रपटातील पात्र",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "जटायू",
                "अंगद",
                "शत्रुघ्न",
                "इंद्रजीत"
            ],
            "theme": "रामायणातील व्यक्ती/पात्र",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंदाज",
                "गाठ",
                "दोरी",
                "भिंत"
            ],
            "theme": "... बांधतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "सूड",
                "विश्रांती",
                "औषध",
                "जीव"
            ],
            "theme": "... घेतात",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "शेपटी",
                "कन्नी",
                "मांजा",
                "चरखी"
            ],
            "theme": "पतंग संबंधी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तुझा",
                "रंग",
                "प्रेमा",
                "कसा"
            ],
            "theme": "मराठी नाटक - १",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "दुर्वांची",
                "जुडी",
                "ही",
                "वाहतो"
            ],
            "theme": "मराठी नाटक - २",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "चालू",
                "आहे",
                "कोर्ट",
                "शांतता"
            ],
            "theme": "मराठी नाटक - ३",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पेट्रोल",
                "डिझेल",
                "इथेनॉल",
                "वीज"
            ],
            "theme": "मोटार गाड्यांचे इंधन",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "फॅराडे",
                "जनित्र",
                "धक्का",
                "सर्किट"
            ],
            "theme": "वीज/विद्युत संबंधी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "कोळसा",
                "अणू",
                "सौर",
                "पवन"
            ],
            "theme": "वीज निर्मितीचे प्रकार/इंधन",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गुलाम अली",
                "मेहेंदी हसन",
                "अली सेठी",
                "नूरजहाँ"
            ],
            "theme": "पाकिस्तानी गायक गायिका",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बेनझीर",
                "झिया",
                "इम्रान",
                "नवाज"
            ],
            "theme": "पाकिस्तानी राजकीय नेते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "झहीर",
                "अक्रम",
                "दलपत",
                "रमीज"
            ],
            "theme": "पाकिस्तानी क्रिकेटपटू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कोडगा",
                "मग्रूर",
                "उद्धट",
                "निर्लज्ज"
            ],
            "theme": "लोकांची कदर न करणारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मूर्ख",
                "अडाणी",
                "अक्कलशून्य",
                "निर्बुद्ध"
            ],
            "theme": "बुद्धी/विचाराचा अभाव असणारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "धूर्त",
                "कपटी",
                "लबाड",
                "बेईमान"
            ],
            "theme": "नीतिमत्तेचा अभाव असणारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खरेदी",
                "विक्री",
                "नफा",
                "तोटा"
            ],
            "theme": "धंद्याची आर्थिक गणित",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "उत्पादन",
                "पुरवठा",
                "मागणी",
                "गोदाम"
            ],
            "theme": "धंद्यात मालासंबंधी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "भागीदार",
                "दलाल",
                "ग्राहक",
                "नोकरवर्ग"
            ],
            "theme": "धंद्यातील महत्वाच्या व्यक्ती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कोआन",
                "इसापनीती",
                "जातक",
                "पंचतंत्र"
            ],
            "theme": "कथा प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "श्लोक",
                "दोहा",
                "अभंग",
                "रुबाई"
            ],
            "theme": "काव्य प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "फार्स",
                "तमाशा",
                "एकांकिका",
                "दशावतार"
            ],
            "theme": "नाट्य प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "डंख",
                "लचका",
                "चावा",
                "दंश"
            ],
            "theme": "प्राण्यांचा तोंडावाटे हल्ला",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "शंकर",
                "कात",
                "फणा",
                "पंचमी"
            ],
            "theme": "नागाशी संबंधित",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "आषाढी एकादशी",
                "शिवरात्र",
                "श्रावणी सोमवार",
                "दत्त जयंती"
            ],
            "theme": "काही उपवास करण्याचे दिवस",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रोमियो",
                "ऑथेल्लो",
                "शायलॉक",
                "मॅकबेथ"
            ],
            "theme": "शेक्सपिअर च्या नाटकांतली पात्र",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ऑगस्टस",
                "नीरो",
                "मार्कस ऑरेलियस",
                "क्लॉडियस"
            ],
            "theme": "रोमन सम्राट",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "युक्लीड",
                "आर्यभट्ट",
                "पायथॅगोरस",
                "आर्किमिडीज"
            ],
            "theme": "प्राचीन गणितज्ञ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भुजंगप्रयात",
                "शार्दूलविक्रीडित",
                "आर्या",
                "मंदाक्रांता"
            ],
            "theme": "कवितेतील वृत्ते",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रांगदा",
                "शकुंतला",
                "सत्यवती",
                "बृहन्नला"
            ],
            "theme": "महाभारतातील स्त्रिया",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "मनोरमा",
                "शशिकला",
                "कुमकुम",
                "नादिरा"
            ],
            "theme": "हिंदी चित्रपटातील जुन्या स्त्री चरित्र अभिनेत्री",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अण्णासाहेब किर्लोस्कर",
                "मधुसूदन कालेलकर",
                "वसंत कानेटकर",
                "विद्याधर गोखले"
            ],
            "theme": "प्रसिद्ध मराठी नाटककार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "पु. ल. देशपांडे",
                "वि. वा. शिरवाडकर",
                "आचार्य अत्रे",
                "गंगाधर गाडगीळ"
            ],
            "theme": "नाटक व साहित्य दोन्ही क्षेत्रांतले लेखक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "राम गबाले",
                "राजा परांजपे",
                "राजा नेने",
                "शांताराम"
            ],
            "theme": "मराठी चित्रपट दिग्दर्शक",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सूत्र",
                "धागा",
                "रेषा",
                "बंध"
            ],
            "theme": "जोडणी दर्शवणाऱ्या संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "व्यास",
                "त्रिज्या",
                "परिघ",
                "क्षेत्रफळ"
            ],
            "theme": "भूमितीतील घटक",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "ऋषी",
                "ग्रंथ",
                "कथा",
                "परंपरा"
            ],
            "theme": "भारतीय ज्ञानपरंपरेचे घटक",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आसन",
                "पादुका",
                "चक्र",
                "शंख"
            ],
            "theme": "पूजाविधीतील प्रतीक",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "अधिकार",
                "कर्तव्य",
                "मर्यादा",
                "शिस्त"
            ],
            "theme": "सत्तेशी संबंधित संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "राजा",
                "ऋषी",
                "सेनानी",
                "दूत"
            ],
            "theme": "प्राचीन समाजातील भूमिका",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मार्ग",
                "चक्र",
                "सोपान",
                "प्रवाह"
            ],
            "theme": "प्रक्रिया दर्शवणारे शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "धर्म",
                "नीती",
                "संयम",
                "कर्तव्य"
            ],
            "theme": "नैतिक संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "वन",
                "आश्रम",
                "सभा",
                "रणभूमी"
            ],
            "theme": "महाभारतातील संदर्भस्थळे",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भाव",
                "रस",
                "छटा",
                "लय"
            ],
            "theme": "साहित्यिक अनुभूती",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "गंध",
                "स्पर्श",
                "स्वाद",
                "श्रवण"
            ],
            "theme": "इंद्रियज्ञान",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "अनुभव",
                "जाणीव",
                "स्मृती",
                "संवेदना"
            ],
            "theme": "मानसिक प्रक्रिया",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छत्र",
                "ध्वज",
                "सिंहासन",
                "मुकुट"
            ],
            "theme": "राजसत्ता दर्शवणारी चिन्हे",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "तप",
                "व्रत",
                "संन्यास",
                "संयम"
            ],
            "theme": "आत्मशुद्धीच्या पद्धती",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "चिन्ह",
                "प्रतिमा",
                "अर्थ",
                "संकेत"
            ],
            "theme": "प्रतिनिधित्व दर्शवणाऱ्या संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अमरत्व",
                "पुनर्जन्म",
                "भविष्यकथन",
                "कालप्रवास"
            ],
            "theme": "अविश्वसनीय / अतिप्राकृतिक गोष्टी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मधुमती",
                "ओम शांती ओम",
                "कर्ज",
                "मिलन"
            ],
            "theme": "पुनर्जन्मावर आधारित चित्रपट",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "तारण",
                "हप्ता",
                "व्याज",
                "गहाण"
            ],
            "theme": "कर्जा संबंधी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुभाषचंद्र बोस",
                "ए. आर. रहमान",
                "सावित्रीबाई फुले",
                "दीपिका पदुकोण"
            ],
            "theme": "जानेवारी मध्ये जन्मलेल्या व्यक्ती",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "छत्रपती शिवाजी महाराज",
                "मोरारजी देसाई",
                "जगजीत सिंह",
                "जयललिता"
            ],
            "theme": "फेब्रुवारी मध्ये जन्मलेल्या व्यक्ती",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "मेरी कोम",
                "आमिर खान",
                "झाकीर हुसेन",
                "शशी थरूर"
            ],
            "theme": "मार्च मध्ये जन्मलेल्या व्यक्ती",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धमक",
                "शार",
                "गार",
                "भडक"
            ],
            "theme": "रंगाचा उठाव दर्शवणारे शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "झिंगाट",
                "कोंबडी",
                "विश्वविनायक",
                "धडक"
            ],
            "theme": "अजय अतुल यांच्या कलाकृती",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "अनुदान",
                "सांत्वन",
                "कुमक",
                "पुनर्वसन"
            ],
            "theme": "आपत्तीचे निराकरण",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मासळी",
                "गटार",
                "ओले मोजे",
                "शौचालय"
            ],
            "theme": "दुर्गंध",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रपटगृह",
                "तळघर",
                "गुहा",
                "रात्र"
            ],
            "theme": "अंधार/अंधाऱ्या जागा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वाचनालय",
                "ध्यानकक्ष",
                "परीक्षाकेंद्र",
                "स्मशान"
            ],
            "theme": "शांत जागा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिमिर",
                "दुरित",
                "व्यंकटी",
                "मैत्र"
            ],
            "theme": "पसायदानातील शब्द (ज्ञानेश्वर)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "वैखरी",
                "पापबुद्धी",
                "नीववावे",
                "चत्वार"
            ],
            "theme": "मनाच्या श्लोकांतील शब्द (रामदास)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वनचरे",
                "हरिकथा",
                "एकांताचा वास",
                "आकाशमंडप"
            ],
            "theme": "वृक्षवल्ली आम्हा सोयरे (तुकोबा)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आधार",
                "स्तंभ",
                "पाया",
                "मूळ"
            ],
            "theme": "आधार किंवा बेस दर्शवणारे शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "तर्क",
                "कारण",
                "परिणाम",
                "निष्पत्ती"
            ],
            "theme": "विचारसाखळीतील घटक",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "बीज",
                "अंकुर",
                "वाढ",
                "फळ"
            ],
            "theme": "नैसर्गिक विकासक्रम",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्पंदन",
                "आवाज",
                "प्रतिध्वनी",
                "लय"
            ],
            "theme": "ध्वनीशी संबंधित संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "ताल",
                "मात्रा",
                "आवर्तन",
                "गती"
            ],
            "theme": "संगीतात्मक रचना",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कालावधी",
                "क्षण",
                "फेरफटका",
                "अंतर"
            ],
            "theme": "वेळेशी निगडित शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संत ज्ञानेश्वर",
                100,
                "शिडी",
                "साप"
            ],
            "theme": "सापशिडी खेळ - त्याचे निर्माते वगैरे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कवड्या",
                "पट",
                "चिरा",
                "फासे"
            ],
            "theme": "सारीपाट खेळ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "शह",
                "राणी",
                64,
                "हत्ती"
            ],
            "theme": "बुद्धिबळ खेळ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आणि",
                "किंवा",
                "परंतु",
                "तथापि"
            ],
            "theme": "समुच्चयबोधक जोडशब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "म्हणून",
                "कारण",
                "तेव्हा",
                "जर"
            ],
            "theme": "कारण-परिणाम दर्शवणारे शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "खरेतर",
                "अर्थात",
                "वस्तुतः",
                "मात्र"
            ],
            "theme": "स्पष्टीकरण/मर्यादा दर्शवणारे शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठाणे",
                "कल्याण",
                "डोंबिवली",
                "अंबरनाथ"
            ],
            "theme": "मुंबई उपनगरे",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "लोकल",
                "टॅक्सी",
                "रिक्षा",
                "बस"
            ],
            "theme": "मुंबईतील वाहतूक",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "म्हातारीचा बूट",
                "राणीचा बाग",
                "गेटवे",
                "चौपाटी"
            ],
            "theme": "मुंबईतील स्थळे",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खुळखुळा",
                "बोबडे बोल",
                "लाळ",
                "शी शु"
            ],
            "theme": "नवजात शिशु",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "गणवेश",
                "मित्र-मैत्रिणी",
                "खेळ",
                "अभ्यास"
            ],
            "theme": "शाळकरी",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "गॉगल",
                "फॅशन",
                "वाहन",
                "फोन"
            ],
            "theme": "कॉलेज/टीन एजर्स",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कपडा",
                "कागद",
                "लोखंड",
                "लाकूड"
            ],
            "theme": "साहित्य प्रकार",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "कात्री",
                "सुई",
                "दोरा",
                "पट्टी"
            ],
            "theme": "शिवणकाम साधने",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "घड्याळ",
                "दिवा",
                "भिंत",
                "खाट"
            ],
            "theme": "घरातील उपयुक्त वस्तू",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाय",
                "रेडा",
                "म्हैस",
                "कालवड"
            ],
            "theme": "पशुधन",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "गवत",
                "सुपीक",
                "धूप",
                "नांगर"
            ],
            "theme": "शेतीतील संदर्भ",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "घंटा",
                "शंख",
                "ताशा",
                "तुतारी"
            ],
            "theme": "आवाज करणारी वाद्ये",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "टॉवेल",
                "साबण",
                "शॉवर",
                "पाणी"
            ],
            "theme": "अंघोळ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "तलाव",
                "सूर",
                "डुबकी",
                "बटरफ्लाय"
            ],
            "theme": "पोहोणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वाळू",
                "शिंपला",
                "खेकडा",
                "नारळ"
            ],
            "theme": "समुद्रकिनारा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जोग",
                "गिरसप्पा",
                "दूधसागर",
                "ठोसेघर"
            ],
            "theme": "प्रसिद्ध धबधबे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "वेण्णा",
                "लोणार",
                "शिवसागर",
                "विहार"
            ],
            "theme": "महाराष्ट्रातील प्रसिद्ध तलाव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "चिखलदरा",
                "तोरणमाळ",
                "माथेरान",
                "पाचगणी"
            ],
            "theme": "महाराष्ट्रातली थंड हवेची ठिकाणे (हिलस्टेशन)",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठाणे",
                "कचेरी",
                "कारखाना",
                "कार्यालय"
            ],
            "theme": "लोकांच्या कामाच्या जागा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रपटगृह",
                "मैफल",
                "उपाहारगृह",
                "क्लब"
            ],
            "theme": "लोकांच्या आनंदात वेळ घालवण्याच्या जागा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वाहतूक कोंडी",
                "भाजी मंडई",
                "किराणा दुकान",
                "दवाखाना"
            ],
            "theme": "लोकांच्या (नाईलाजाने?) नियमित वेळ घालवण्याच्या जागा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संजय गांधी",
                "माधवराव सिंधिया",
                "अजित पवार",
                "बिपीन रावत"
            ],
            "theme": "हवाई अपघातात मृत्यू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "राजीव गांधी",
                "इंदिरा गांधी",
                "महात्मा गांधी",
                "बेनझीर भुट्टो"
            ],
            "theme": "घातपात आणि राजकीय हिंसाचारात मृत्यू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "राजेश पायलट",
                "डायना",
                "गोपीनाथ मुंढे",
                "डॉ.श्रीकांत जिचकार"
            ],
            "theme": "रस्त्यावरील वाहन अपघातात मृत्यू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उर्मिला",
                "श्रुतकिर्ती",
                "सीता",
                "मांडवी"
            ],
            "theme": "रघुकुलवधू",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "शूर्पणखा",
                "सुलोचना",
                "मंदोदरी",
                "कैकसी"
            ],
            "theme": "रावण कुटुंबीय",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "तारा",
                "रुमा",
                "अंजना",
                "भागाबाई"
            ],
            "theme": "वानर स्त्रिया",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जलसा",
                "मन्नत",
                "मातोश्री",
                "अँटीला"
            ],
            "theme": "मुंबईतील मान्यवरांची निवासस्थाने",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "हक़",
                "अझर",
                "जन्नत",
                "जहर"
            ],
            "theme": "इम्रान हाश्मी अभिनीत चित्रपट",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हैद्राबाद",
                "कर्णधार",
                "पदार्पणात ३ शतके",
                "मॅच फिक्सिंग"
            ],
            "theme": "क्रिकेटपटू मोहम्मद अझरुद्दीनशी संबंधित",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकृती",
                "घडण",
                "रचना",
                "संघटन"
            ],
            "theme": "आकारनिर्मितीशी संबंधित शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "संविधान",
                "नियम",
                "कलम",
                "अमलबजावणी"
            ],
            "theme": "व्यवस्थेची चौकट",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "कणा",
                "स्नायू",
                "अवयव",
                "संस्था"
            ],
            "theme": "जैविक संरचना",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सोने",
                "जमीन",
                "बिट कॉईन",
                "समभाग"
            ],
            "theme": "गुंतवणुकीचे प्रकार ",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "तोळा",
                "पॉलिश",
                "घट",
                "घडणावळ"
            ],
            "theme": "सोनाराचा शब्दसंग्रह",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "निर्देशांक",
                "बुल आणि बेअर",
                "अस्थिरता",
                "लाभांश"
            ],
            "theme": "गुंतवणूकदारांचा शब्दसंग्रह",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंगण",
                "परसदार",
                "बाग",
                "गच्ची"
            ],
            "theme": "घराच्या बाहेरील जागा",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "पडवी",
                "ओसरी",
                "व्हरांडा",
                "प्रवेशद्वार"
            ],
            "theme": "घराच्या प्रवेश भागाशी संबंधित जागा",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "दिवाणखाना",
                "शयनकक्ष",
                "पाहुण्यांची खोली",
                "स्वयंपाकघर"
            ],
            "theme": "राहण्याच्या/वापराच्या मुख्य खोल्या",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तरंग",
                "तवंग",
                "लाट",
                "जलपर्णी"
            ],
            "theme": "पाण्याच्या पृष्ठभागावर येणारे",
            "sharedBy": "हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "फोडणी",
                "वंगण",
                "बुद्धी",
                "चंपी"
            ],
            "theme": "तेल/तैल",
            "sharedBy": "हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जिरे",
                "मोहोरी",
                "तेल",
                "मिरची"
            ],
            "theme": "फोडणी मधील पदार्थ",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ओळख",
                "प्रतिष्ठा",
                "प्रतिमा",
                "सन्मान"
            ],
            "theme": "सामाजिक मान्यता",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "नाव",
                "उपाधी",
                "हुद्दा",
                "पदवी"
            ],
            "theme": "ओळख दर्शवणारी साधने",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "चिन्ह",
                "मुद्रा",
                "ठसा",
                "खूण"
            ],
            "theme": "ओळख पटवणारे घटक",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वाहन",
                "मार्ग",
                "दिशा",
                "गंतव्य"
            ],
            "theme": "प्रवासाशी संबंधित शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "साधन",
                "पद्धत",
                "यंत्रणा",
                "उपाय"
            ],
            "theme": "कार्यसाधने",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "सेतू",
                "दुवा",
                "जोड",
                "संपर्क"
            ],
            "theme": "जोडणी दर्शवणाऱ्या संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उद्गम",
                "स्रोत",
                "उगम",
                "मूळस्थान"
            ],
            "theme": "सुरुवात दर्शवणारे शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "नदी",
                "ओढा",
                "प्रवाह",
                "खाडी"
            ],
            "theme": "जलप्रणाली",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "विचार",
                "कल्पना",
                "स्फुरण",
                "प्रेरणा"
            ],
            "theme": "मानसिक उगम",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सीमा",
                "कक्षा",
                "परिघ",
                "मर्यादा"
            ],
            "theme": "आवाक्य दर्शवणारे शब्द",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "अधिकारक्षेत्र",
                "प्रांत",
                "हद्द",
                "परिसर"
            ],
            "theme": "प्रशासनिक मर्यादा",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "दृष्टीक्षेप",
                "आकलन",
                "समज",
                "जाणीव"
            ],
            "theme": "मानसिक सीमा",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भार",
                "दाब",
                "ताण",
                "घनता"
            ],
            "theme": "भौतिक संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "जबाबदारी",
                "दायित्व",
                "ओझे",
                "कर्तव्य"
            ],
            "theme": "मानसिक/सामाजिक भार",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "गंभीरता",
                "तीव्रता",
                "प्रखरता",
                "घनपणा"
            ],
            "theme": "तीव्रतेची छटा",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चेष्टा",
                "मस्करी",
                "टिंगल",
                "फिरकी"
            ],
            "theme": "हलक्या फुलक्या चिडवाचिडवीचे प्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "मुद्रा",
                "पदन्यास",
                "नेत्राभिनय",
                "गिरकी"
            ],
            "theme": "नृत्याशी संबंधित",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "अलारिप्पु",
                "जतीस्वरम्",
                "वर्णम्",
                "तिल्लाना"
            ],
            "theme": "भरतनाट्यम नृत्याचे ४ भाग",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकाशगंगा",
                "धूमकेतू",
                "कृष्णविवर",
                "कक्षा"
            ],
            "theme": "खगोलशास्त्रीय संज्ञा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "कुंडली",
                "राहू",
                "केतू",
                "ग्रहदशा"
            ],
            "theme": "ज्योतिष शास्त्रीय संज्ञा",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वेधशाळा",
                "अंतराळ यान",
                "दुर्बीण",
                "कृत्रिम उपग्रह"
            ],
            "theme": "मानवाचा अंतराळ वेध",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वामा",
                "भार्या",
                "पत्नी",
                "अर्धांगिनी"
            ],
            "theme": "पत्नी/बायको समानार्थी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्मी",
                "सरस्वती",
                "पार्वती",
                "दुर्गा"
            ],
            "theme": "हिंदू देवींची नावे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "आर्या",
                "मंदाक्रान्ता",
                "शार्दूलविक्रीडित",
                "वसंततिलका"
            ],
            "theme": "काव्यातील वृत्तप्रकार",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्वच्छ",
                "सात्विक",
                "निर्मळ",
                "पवित्र"
            ],
            "theme": "समान गुण दर्शवणारे शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "खरपूस",
                "साजूक",
                "खमंग",
                "ताजे"
            ],
            "theme": "अन्नपदार्थांची विशेषणे",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "काठोकाठ",
                "तृप्त",
                "संपृक्त",
                "पूर्ण"
            ],
            "theme": "संतुष्टता/पूर्णता दर्शवणारे शब्द",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संप",
                "घेराव",
                "उठाव",
                "बंद"
            ],
            "theme": "सामूहिक विरोध",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "उपोषण",
                "राजीनामा",
                "आत्मक्लेश",
                "आत्महत्या"
            ],
            "theme": "व्यक्तीने केलेले टोकाचे/प्रतीकात्मक निषेध",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "वाद",
                "भांडण",
                "कलह",
                "खटका"
            ],
            "theme": "दोन लोकांमधील दुरावा / तणाव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दृश्य",
                "प्रतिमा",
                "छटा",
                "आभास"
            ],
            "theme": "दृष्टीअनुभव",
            "sharedBy": "Chat GPT",
            "difficulty": 0
        },
        {
            "words": [
                "भास",
                "भ्रम",
                "छल",
                "माया"
            ],
            "theme": "खोटे आकलन",
            "sharedBy": "Chat GPT",
            "difficulty": 1
        },
        {
            "words": [
                "सत्य",
                "वास्तव",
                "अर्थ",
                "तथ्य"
            ],
            "theme": "खरेपणा दर्शवणाऱ्या संकल्पना",
            "sharedBy": "Chat GPT",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उद्रेक",
                "भरमार",
                "सुळसुळाट",
                "फ़ैलाव"
            ],
            "theme": "मोठ्या प्रमाणावर अनियंत्रित वाढ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "शिखर",
                "कडा",
                "टोक",
                "सुळका"
            ],
            "theme": "टोकदार उंच उभा दगड",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "समृद्धी",
                "विपुलता",
                "सुकाळ",
                "सुबत्ता"
            ],
            "theme": "भरपूर उपलब्धता",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उकळणे",
                " पेय",
                " दार्जिलिंग",
                " पाने "
            ],
            "theme": " चहा",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "टेकडी",
                " मंदिर",
                " पायऱ्या",
                " पुणे"
            ],
            "theme": "पुणे स्थित  पर्वती टेकडी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "भरती",
                " लाटा",
                " गाज",
                " पुळण "
            ],
            "theme": " समुद्र",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मृगजळ",
                " उंट",
                " निवडुंग",
                " उष्ण "
            ],
            "theme": " वाळवंट ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "कमला",
                " शांतता",
                " सखाराम",
                " कोतवाल"
            ],
            "theme": "विजय तेंडुलकर यांच्या नाटकांच्या  नावातील शब्द",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "भांगडा",
                " गरबा",
                " बिहू",
                " घूमर "
            ],
            "theme": " विविध नृत्य प्रकार",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इंदिरा संत",
                " शांता शेळके",
                " कुसुमाग्रज",
                " केशवसुत"
            ],
            "theme": " प्रसिद्ध मराठी कवी/कवयित्री",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "वि. स. खांडेकर",
                " शिवाजी सावंत",
                " रणजीत देसाई",
                " ना. सी. फडके"
            ],
            "theme": " प्रसिद्ध मराठी कादंबरीकार",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "अण्णासाहेब किर्लोस्कर",
                " मधुसूदन कालेलकर",
                " वसंत कानेटकर",
                " विद्याधर गोखले"
            ],
            "theme": " प्रसिद्ध मराठी नाटककार",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इथिओपिया",
                "बरंच काही",
                "चिकोरी",
                "अरॅबिका"
            ],
            "theme": "कॉफी - त्याचे जन्मस्थान, शास्त्रीय नाव, मिश्रण, चित्रपट इत्यादी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "इराणी",
                " बासुंदी",
                "तंदुरी",
                " गवती"
            ],
            "theme": " चहाचे प्रकार ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "चहा",
                "कागद",
                "दारू",
                "नूडल्स/शेवया"
            ],
            "theme": "चीनचे प्राचीन शोध",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कादंबरी",
                " नाटक",
                " कविता",
                " चरित्र"
            ],
            "theme": "वाङ्मयीन प्रकार  ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बुद्धिबळ",
                " संगीत",
                " ओरिगामी",
                " चित्रकला "
            ],
            "theme": " छंद",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "⁠बाग",
                " पुणे",
                " गणपती",
                " तळे"
            ],
            "theme": "पुणे स्थित सारसबाग संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सर्कस",
                " फौजी",
                " उम्मीद",
                " दूसरा केवल"
            ],
            "theme": "शाहरुख खान यांच्या दूरदर्शनवरील मालिका ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पैंजण",
                " ढोलकी",
                " बैठक",
                " नटरंग "
            ],
            "theme": " लावणीशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "आकाश",
                " खंड्या",
                " गोकर्ण",
                " नीलम"
            ],
            "theme": "निळ्या गोष्टी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मैदान ",
                " हार ",
                "जीत",
                " पंच "
            ],
            "theme": " मैदानी खेळ ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 0
        },
        {
            "words": [
                "उकळणे",
                "टॅनीन",
                " दार्जिलिंग",
                " पाने "
            ],
            "theme": " चहा",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "भरती",
                " लाटा",
                " गाज",
                " पुळण "
            ],
            "theme": " समुद्र",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाठ",
                " राखी",
                " तंबू ",
                " फास"
            ],
            "theme": "दोरी/दोरखंड इत्यादींशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लोकल",
                " डबेवाले",
                " व्यापार",
                " बंदर"
            ],
            "theme": "मुंबई",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मशाल",
                "इंजिन",
                "कमळ",
                "घड्याळ"
            ],
            "theme": "महाराष्ट्रातील पक्षांची निवडणूक चिन्हे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कांगारू",
                " कोआला",
                " उलुरु ",
                " ब्रॅडमन "
            ],
            "theme": " ऑस्ट्रेलिया",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "ज्योत",
                " वाढदिवस",
                " दिवाळी",
                " मेण"
            ],
            "theme": " मेणबत्तीशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "नंदी",
                "रेडा",
                "उंदीर",
                "गरुड"
            ],
            "theme": "काही देवांची वाहने ",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मुघल",
                " गड ",
                " मराठा",
                " राज्याभिषेक "
            ],
            "theme": " ​​शिवाजी महाराज ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "गाजर",
                " आले",
                " हळद",
                " वसाबी "
            ],
            "theme": " जमिनीखालच्या खाण्यायोग्य वनस्पती ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "कोन",
                " स्कूप",
                " दूध",
                " व्हॅनिला "
            ],
            "theme": " आईस्क्रीम ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काळजी",
                "विश्रांती",
                "झेप",
                "श्वास"
            ],
            "theme": "ज्या गोष्टी घेता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रं",
                "झोप",
                "खोडी",
                "पाणी"
            ],
            "theme": "ज्या गोष्टी काढता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "शोध",
                "विरजण",
                "झाड",
                "आग"
            ],
            "theme": "ज्या गोष्टी लावता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कॅडेट्स",
                " शिस्त",
                " परेड",
                " शौर्य"
            ],
            "theme": " भारतीय संरक्षण प्रबोधिनी (NDA) ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "रक्त",
                " जास्वंद",
                " माणिक",
                " सफरचंद"
            ],
            "theme": "लाल रंगाच्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भांगडा",
                " सलवारखमीज",
                " गहू",
                " हॉकी"
            ],
            "theme": " पंजाबशी संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढाल",
                "करंडक",
                "पदक",
                "चक्र"
            ],
            "theme": "पारितोषिके",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मेण",
                "आइस्क्रीम",
                "मीठ",
                "हृदय"
            ],
            "theme": "विरघळणार्या / पाघळणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "समुद्र",
                "पोफळी",
                "मोदक",
                "आंबा"
            ],
            "theme": "कोकणातील गोष्टी ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कविता",
                " हुजूरपागा",
                "आनंदाचे झाड",
                "ऋतू हिरवा"
            ],
            "theme": "कवयित्री शांता शेळके यांच्याशी संबंधित",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "हात",
                "चौकट",
                "हुकूम",
                "विदुषक"
            ],
            "theme": "पत्ते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "गाऊन",
                "तराजू",
                "सर्वोच्च",
                "कायदा"
            ],
            "theme": "न्यायालय",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सागरा धरणी",
                "संधी",
                "जागा",
                "नोकरी"
            ],
            "theme": "ही “मिळते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "गुंड्या",
                "मोरू",
                "मैना",
                "काऊ"
            ],
            "theme": "चिमणरावांचे चऱ्हाट (पुस्तक व मालिका) मधील पात्रे ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "नदी",
                "वीज",
                "वारा",
                "रस्ता"
            ],
            "theme": "वाहणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाणी",
                "काच",
                "हवा",
                "पोकळी"
            ],
            "theme": "पारदर्शक गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "विविध",
                "नाना",
                "अनेक",
                "निरनिराळे"
            ],
            "theme": "बरेच, खूप या अर्थी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आवाज",
                " जत्रा",
                " अक्षर",
                "किस्त्रीम"
            ],
            "theme": "काही प्रसिद्ध दिवाळी अंक ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भर",
                "ओढ",
                "ठेव",
                "बस"
            ],
            "theme": "नामरुपे आणि क्रियेची आज्ञार्थ रुपे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                42.195,
                " अथेन्स",
                "केनिया",
                "कीपटूम"
            ],
            "theme": " मॅरेथॉनशी संबंधित ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "दोर",
                " सुळका",
                "चढण",
                "खिळे"
            ],
            "theme": "गिर्यारोहणाशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिकीट",
                "आरक्षण",
                "स्थानक",
                "गंतव्य"
            ],
            "theme": "रेल्वे प्रवास ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 0
        },
        {
            "words": [
                "अमूल",
                "गवळी",
                "म्हैस",
                "गाय"
            ],
            "theme": "दूध देणारे :)",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "तलफ",
                "मंदी",
                "जाग",
                "शिंक"
            ],
            "theme": "ही “येते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कात",
                "शिडी",
                "खवले",
                "काटेरी जीभ"
            ],
            "theme": "'साप' या विषयाचा शब्दबंध",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चुना",
                "सुपारी",
                "बडीशेप",
                "गुलकंद"
            ],
            "theme": "विडा/पान बनवण्यासाठी पदार्थ ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "वासुकी",
                "तक्षक",
                "कालिया",
                "कर्कोटक"
            ],
            "theme": "पुराणातील काही नागांची नावे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बहर",
                "पालवी",
                "मोड",
                "कळी"
            ],
            "theme": "वनस्पतीं वर येणार्‍या नव्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "छापा",
                "टाकसाळ",
                "चिल्लर",
                "पावली"
            ],
            "theme": "चलनी नाणी या विषयावरील शब्दबंध ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "बाई",
                "श्याम",
                "कवडी",
                "दाम"
            ],
            "theme": "\"विकत घेतला श्याम\" गाण्यातले शब्द",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुदर्शन",
                "परमवीर",
                "अशोक",
                "मूलाधार"
            ],
            "theme": "चक्र",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गारुडी",
                "फणा",
                "पंचमी",
                "पुंगी"
            ],
            "theme": "'नाग' या विषयाचा शब्दबंध ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "झोप",
                "ठेच",
                "बस",
                "वाट"
            ],
            "theme": "ही “लागते” :-)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आग",
                "माल",
                "बैल",
                "घोडा"
            ],
            "theme": "गाडी प्रत्यय लावून अर्थपूर्ण ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "उचलणे",
                "जीभ",
                "लावणे",
                "टाळ्याला"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "काटा",
                " टिकटिक",
                "वेळ",
                "ठोके"
            ],
            "theme": " घड्याळ ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बहार",
                "नंद",
                "शिव",
                "चार"
            ],
            "theme": "'सदा' हा उपसर्ग लावून अर्थपूर्ण शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "मूळ",
                "स्वाती",
                "हस्त",
                "चित्रा"
            ],
            "theme": "नक्षत्रं",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "शह",
                "राणी",
                "घोडा",
                "मात"
            ],
            "theme": "बुद्धिबळाच्या पटावर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ग्रह",
                "तारे",
                "कृष्णविवर",
                "धूमकेतू"
            ],
            "theme": "खगोलशास्त्रीय",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "म्हैस",
                "गटणे",
                "पौष्टिक",
                "वरात"
            ],
            "theme": "पु लं च्या लिखाणातून ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "चक्राकार",
                "खमंग",
                "भाजणी",
                "कुरकुरीत"
            ],
            "theme": "चकली",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मानस",
                "दाल",
                "पिचोला",
                "वेण्णा"
            ],
            "theme": "तलाव",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "उत्प्रेक्षा",
                "यमक",
                "रूपक",
                "उपमा"
            ],
            "theme": "मराठी भाषालंकार",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "दैव",
                "देते",
                "कर्म",
                "नेते"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विद्या",
                "भूमी",
                "कृती",
                "श्रद्धा"
            ],
            "theme": "हिंदी चित्रपटांमधील मधील काही अभिनेत्री ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "आलीया",
                "भोगासी",
                "असावे",
                "सादर "
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विद्युत",
                "संथ",
                "वर्तुळाकार",
                "ब्राऊनिअन"
            ],
            "theme": "गती/हालचाली चे प्रकार",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फेस",
                "तुषार",
                "खळखळाट",
                "तरंग"
            ],
            "theme": "समुद्राच्या लाटां बाबत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कल्पवृक्ष",
                "पांचजन्य",
                "कामधेनू",
                "हलाहल"
            ],
            "theme": "समुद्र मंथनातून मिळालेल्या काही गोष्टी ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आग",
                "रामेश्वर",
                "बंब ",
                "सोमेश्वर"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बोट",
                "माड",
                "लाटा",
                "शिंपला"
            ],
            "theme": "समुद्र किनाऱ्यावर वर दिसणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अडीच",
                "चौसष्ट",
                "कॅसलिंग",
                "एन पासंट"
            ],
            "theme": "बुद्धिबळाच्या पटावर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दोन",
                "तीन",
                "पाच",
                "सात"
            ],
            "theme": "पहिल्या ४ मूळ संख्या",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कागद ",
                " छपाई",
                "संपादकीय",
                "पत्रकार "
            ],
            "theme": " वर्तमान पत्र ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "देव",
                "सराफ",
                "फुले",
                "लागू"
            ],
            "theme": "जुन्या मराठी चित्रपटातल्या अभिनेत्यांची आडनावे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पेला",
                "खिडकी",
                "भिंग",
                "दौत"
            ],
            "theme": "काचेच्या वस्तु",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंथरुण",
                "पाहणे",
                "पाय",
                "पसरणे"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "झरा",
                "झाडे",
                "पक्षी",
                "पाऊस"
            ],
            "theme": "निसर्ग ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 1
        },
        {
            "words": [
                "तिरंगा",
                "फडकवणे",
                "स्तंभ",
                "मानवंदना"
            ],
            "theme": "झेंड्या बाबत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भोवरा",
                "आकाशगंगा",
                "पंखा",
                "वावटळ"
            ],
            "theme": "फिरणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "भूलभुलैया",
                "माया",
                "चकवा",
                "शोभादर्शक"
            ],
            "theme": "ज्यानी फसवणूक होते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भक्ती",
                "प्रवचन",
                "नामजप",
                "पारायण"
            ],
            "theme": " अध्यात्म ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मूर्ती",
                "कळस",
                "गाभारा",
                "प्रसाद"
            ],
            "theme": "देऊळ ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "उथळ",
                "पाणी",
                "खळखळाट",
                "फार "
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वरूण",
                "धो धो",
                "मेघ",
                "वीज"
            ],
            "theme": "पाऊस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाऊस",
                "वीज",
                "उल्का",
                "गारा"
            ],
            "theme": "आकाशातून पडणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "क्वार्टझ",
                "टायटन",
                "पट्टा",
                "वेळ"
            ],
            "theme": "वॉच",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "किरण",
                "सुहास",
                "चारु",
                "शीतल"
            ],
            "theme": "मराठी “यूनिसेक्स्” नावं",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नास्तिक",
                "सरफरोशी",
                "बॉम्ब",
                "फाशी"
            ],
            "theme": "भगतसिंग यांच्या जीवनाशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गांधी",
                " राजवाडा",
                "संग्रहालय",
                "स्थानबद्ध"
            ],
            "theme": "आगा खान पॅलेस",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "उंदीर",
                "वाघ",
                "रेडा",
                "गरुड"
            ],
            "theme": "देवतांची वाहने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तांबड",
                "झुंजुमुंजु",
                "किलबिल",
                "भूपाळी"
            ],
            "theme": "पहाट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "देव",
                "यम",
                "मेघ",
                "राम"
            ],
            "theme": "ज्यांना \"दूत\" जोडलेले शब्द आहेत (मेघदूत, ...)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अशोक स्तंभ",
                "तवा",
                "ऐरण",
                "घण"
            ],
            "theme": "लोह",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वीट",
                "मडकं",
                "देशी दारू",
                "कोळसा"
            ],
            "theme": "भट्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पद",
                "गट",
                "तट",
                "फूट"
            ],
            "theme": "राजकारणातल्या उचित अनुचित गोष्टी ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 1
        },
        {
            "words": [
                "आग",
                "पुणे",
                " काका",
                "बाजीराव"
            ],
            "theme": "पुणे स्थित शनिवार वाडा वास्तू संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कागद",
                "रंग",
                "पाणी",
                "ब्रश"
            ],
            "theme": "चित्रकला (पेंटिंग)",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 0
        },
        {
            "words": [
                "दिल्ली",
                "गोंधळ",
                "गल्ली",
                "मुजरा"
            ],
            "theme": "राजकारण आणि त्या आधारित चित्रपटाचे नाव ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 1
        },
        {
            "words": [
                "सकाळ",
                "हिंदू",
                "एक्सप्रेस",
                "सामना"
            ],
            "theme": "वृत्तपत्रे ज्यांच्या नावाचा दुसरा अर्थही होतो",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "परदेश",
                "घर",
                "आनंद",
                "माहेर"
            ],
            "theme": "ज्याच्यात राहता येतं अश्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दही",
                "ताडी",
                "पाव",
                "इडली"
            ],
            "theme": "आंबवलेले पदार्थ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "नंदा",
                "नाथा",
                "लखू",
                "गजा"
            ],
            "theme": "व्यक्ती आणि वल्ली' मधील काही व्यक्तिरेखा ",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वानर",
                "अस्वल",
                "गिधाड",
                "मृग"
            ],
            "theme": "रामायणात उल्लेख असलेले  प्राणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "झेब्रा",
                "जिराफ",
                "चित्ता",
                "तरस"
            ],
            "theme": "आफ्रिकेत आढळणारे प्राणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मगर",
                "कासव",
                "पाणघोडा",
                "बेडूक"
            ],
            "theme": "उभयचर प्राणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लिफाफा",
                " आंतरदेशीय",
                " खुशाली ",
                "मुद्रांक"
            ],
            "theme": "पत्रव्यवहार संबंधी ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "पाट",
                "सतरंजी",
                "खुर्ची",
                "मोडा"
            ],
            "theme": " यावर बसतात  ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "काख",
                "कळसा",
                "गाव",
                "वळसा "
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंक",
                "फराळ",
                "उटणं",
                "लक्ष्मी"
            ],
            "theme": "दिवाळी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "नाच",
                "येणे",
                "अंगण",
                "वाकडे"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "केदार",
                "आसावरी",
                "सारंग",
                "कल्याण"
            ],
            "theme": "काही राग",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वारा",
                "तापमान",
                " अतिवृष्टी",
                "चक्रीवादळ"
            ],
            "theme": "हवामानशास्त्र वेधशाळा आदींशी  संबंधित ",
            "sharedBy": "ऋतुजा ",
            "difficulty": 0
        },
        {
            "words": [
                "समुद्र",
                "जाळे",
                "होडी",
                "मासळी"
            ],
            "theme": "कोळ्याच्या जीवनाशी संबंधित ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 1
        },
        {
            "words": [
                "चतुर्दशी",
                "बिज",
                "बारस",
                "पूजन"
            ],
            "theme": "दिवाळीच्या दिवसांचे दुसरे शब्द प्रत्यय",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आधी",
                "पोट",
                "मग",
                "विठ्ठल"
            ],
            "theme": "एका मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "इकडे",
                "आड",
                "तिकडे",
                "विहीर"
            ],
            "theme": "मराठी म्हणीतील शब्द ",
            "sharedBy": "एक शुभचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सूर्यफूल",
                "जवस",
                "ऑलिव्ह",
                "शेंगदाणा"
            ],
            "theme": "तेल बिया ",
            "sharedBy": "मीनल अभ्यंकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पक्ष",
                " मत",
                " चिन्ह",
                "सभा"
            ],
            "theme": "निवडणूक ",
            "sharedBy": "सुभाष भावे",
            "difficulty": 0
        },
        {
            "words": [
                "⁠व्यक्ती",
                " बटाटा",
                " तुजपाशी",
                "सुंदर"
            ],
            "theme": " पु. ल. देशपांडे यांच्या पुस्तकांच्या नावातील शब्द",
            "sharedBy": "ऋतुजा ",
            "difficulty": 1
        },
        {
            "words": [
                "चाखणे",
                "चावणे",
                "गिळणे",
                "खाणे"
            ],
            "theme": "खाण्याशी संबंधित क्रिया",
            "sharedBy": "AI प्रणाली",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मूर्ती",
                "मिरवणूक",
                "भाद्रपद",
                "आरती"
            ],
            "theme": "गणेशोत्सव",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "ग्वाल्हेर",
                "जयपूर",
                "मेवाती",
                "भेंडी बाजार"
            ],
            "theme": "हिंदुस्थानी शास्त्रीय संगीतातली घराणी",
            "sharedBy": "HVN Unplugged",
            "difficulty": 1
        },
        {
            "words": [
                "नांगरणी",
                "रब्बी",
                "खरीप",
                "पेरणी"
            ],
            "theme": "कृषीशी निगडित संज्ञा",
            "sharedBy": "AI प्रणाली",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दव",
                "सुपारी",
                "भोजन",
                "चुना"
            ],
            "theme": "पानावर सापडणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "लता",
                "ममता",
                "गांधी",
                "गुलजार"
            ],
            "theme": "नेहेमी पांढरी वस्त्रे परिधान करणारे लोक ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वामकुक्षी",
                "पेन्शन",
                "नातवंडं",
                "निवृत्ती"
            ],
            "theme": "ज्येष्ठ नागरिक ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रियो",
                "ॲमेझॉन",
                "पोर्तुगिज",
                "फुटबॉल"
            ],
            "theme": "ब्राझील",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पिझ्झा",
                "गॅलेलियो",
                "फेरारी",
                "व्हेनीस"
            ],
            "theme": "ईटली",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सुशी",
                "फ्युजी",
                "टोयोटा",
                "बुलेट ट्रेन"
            ],
            "theme": "जपान",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काडेपेटी",
                "भिंग",
                "गारगोट्या",
                "लायटर"
            ],
            "theme": "ज्या गोष्टींनी आग पेटवता येते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "घोंगडं",
                "पाणी",
                "माती",
                "अग्नीरोधक"
            ],
            "theme": "ज्या गोष्टींनी आग विजवता येते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "स्वयंपाक",
                "समई",
                "भट्टी",
                "शेकोटी"
            ],
            "theme": "अग्नीचे ऊपयोग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उद्घाटनाची रिबिन",
                "पगार",
                "भाताचं पिक",
                "केस"
            ],
            "theme": "ज्या गोष्टी कापल्या जातात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चाकू",
                "विळी",
                "करवत",
                "खुर्पं"
            ],
            "theme": "ज्या गोष्टी कापतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "शल्यविशारद",
                "शिंपी",
                "पाकीटमार",
                "स्वयंपाकी"
            ],
            "theme": "ज्यांच्या व्यवसायांत कापावे लागते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तोरण",
                "राखी",
                "मुंडावळ्या",
                "नाडी"
            ],
            "theme": "गाठ घालून बांधण्याच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "हार",
                "टायर",
                "मेदूवडा",
                "बांगडी"
            ],
            "theme": "लूप / नेढे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "चष्मा",
                "टक्कल",
                "हातमाग",
                "पांढरे धोतर"
            ],
            "theme": "महात्मा गांधी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ध्रुव",
                "गंगोत्री",
                "दक्षिण",
                "पेंगविन"
            ],
            "theme": "अंटार्क्टिका",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "व्याध",
                "अभिजित",
                "सूर्य",
                "अरुंधती"
            ],
            "theme": "तारे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सिंह",
                "मासे",
                "तराजू",
                "जोडपे"
            ],
            "theme": "राशी चिन्हे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पार्टी",
                "आतिषबाजी",
                "लाईटींग",
                "सोहळा"
            ],
            "theme": "सेलिब्रेशन, समारंभ, साजरा करणे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "स्पेशल",
                "प्रजासत्ताक दिन",
                "पुढले वर्ष",
                "मॅराथॉन"
            ],
            "theme": "२६ (सव्वीस)  - चित्रपट, वर्ष, मैल वगैरे ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ॲटलास",
                "क्रेन",
                "मल्लेश्वरी",
                "जॅक"
            ],
            "theme": "जड गोष्टी उचलणारे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नवीन",
                "मलम",
                "सरस",
                "सामोसा"
            ],
            "theme": "Palindromes (विलोमपदॆ)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "बारामती",
                "सुलक्षणी",
                "पराकोटी",
                "कासावीस"
            ],
            "theme": "\"संख्याशाली\" शब्द (शब्दांत एक संख्या लपलेली )",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "टाचणी",
                "नांगर",
                "सरळ नाक",
                "खिळा"
            ],
            "theme": "टोकदार गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिमिर",
                "मॆत्र",
                "सोयरे",
                "चेतना"
            ],
            "theme": "अजरामर \"पसायदाना\"तले शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "हिम",
                "कार्य",
                "विद्या",
                "रुग्ण"
            ],
            "theme": "यांची घरे (आलये) आहेत",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "रात्र",
                "राजा",
                "राग",
                "राहू"
            ],
            "theme": "रा' ने सुरू होणारे शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नवजीवन",
                "सकस",
                "कडक",
                "समास"
            ],
            "theme": "Palindromes, of course! (विलोमपदॆ)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "राम",
                "पॆसा",
                "तथ्य",
                "हेतू"
            ],
            "theme": "\"अर्था\"चे अनेक पर्यायी शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "बांधवगड",
                "कॉर्बेट",
                "पेरियार",
                "काझिरंगा"
            ],
            "theme": "नॅशनल पार्क",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कांचीपुरम",
                "रामेश्वर",
                "मीनाक्षी",
                "कावेरी"
            ],
            "theme": "तामिळनाडू",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "सुरत",
                "आनंद",
                "दांडी",
                "मोरबी"
            ],
            "theme": "गुजरात मधली गावे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "संक्षिप्त",
                "आकुंचन",
                "शुष्क",
                "केंद्रित"
            ],
            "theme": "कमी होणे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शांती श्लोक",
                "डेझर्ट खाणे",
                "रात्रीची झोप",
                "विसर्जन"
            ],
            "theme": "एखाद्या गोष्टीच्या शेवटी करायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मूळ",
                "हलवा",
                "ससा",
                "लाल"
            ],
            "theme": "गाजर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ईश्वर",
                "आत्मा",
                "वीर",
                "अणू"
            ],
            "theme": "ज्यांच्या आधी \"परम\" जोडलेले शब्द आहेत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंडं",
                "नारळ",
                "फुगा",
                "अमेरिकन फुटबॉल"
            ],
            "theme": "अंडाकृती गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दोरखंड",
                "जॅकेट",
                "काटेरी बूट",
                "धाडसीपणा"
            ],
            "theme": "ऐस माऊंटेनीयरींग ला लागणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भुयार",
                "विहीर",
                "तळघर",
                "खाण"
            ],
            "theme": "जमिनीत खोदून केलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वाईन",
                "जंतुनाशक",
                "व्यसन",
                "ज्वलनशील "
            ],
            "theme": "अल्कोहोल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ढोल",
                "वीज",
                "सायरन",
                "फटाका"
            ],
            "theme": "मोठा आवाज करणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "काथ्या",
                "खराटा",
                "करवंटी",
                "कॉयर"
            ],
            "theme": "नारळाच्या झाडापासून बनवलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लखोबा",
                "राधेश्शाम",
                "दिवाकर",
                "अशोक"
            ],
            "theme": "लोखंडे, महाराज, दातार, परांजपे -- छे, छे, तो मी नव्हेच!",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्रस्थ",
                "स्वप्न",
                "क्रुद्ध",
                "व्रात्य"
            ],
            "theme": "दोन जोडाक्षरांचे शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "ओतप्रोत",
                "उदंड",
                "ओसंडून",
                "तुडुंब"
            ],
            "theme": "अती, खूप जास्त   ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "डॉन",
                "राहीन",
                "सीन",
                "थेम्स"
            ],
            "theme": "युरोपियन नद्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मैफल",
                "मेंदी",
                "स्वप्नं",
                "संध्याकाळचं आकाश"
            ],
            "theme": "ज्या गोष्टी रंगतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ततकार",
                "तोडा",
                "मुद्रा",
                "चक्कर"
            ],
            "theme": "कथ्थक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धर्म",
                "ग्लानी",
                "भारत",
                "यदा"
            ],
            "theme": "यदा यदा ही धर्मस्य...",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "साधु",
                "विनाश",
                "संभव",
                "युग"
            ],
            "theme": "परितत्राणाय साधूनां .... ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "देवदत्त",
                "अनंतविजय",
                "सुघोष",
                "मणिपुष्पक"
            ],
            "theme": "पांडवांच्या शंखांची नावे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घोडा",
                "हॅट",
                "पिस्तूल ",
                "बूट"
            ],
            "theme": "काऊबॉय संबंधी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ठाकुर",
                "बसंती",
                "विरु",
                "जय"
            ],
            "theme": "शोले सिनेमातील पात्रे ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दोस्ती",
                "मेहबुबा",
                "होली",
                "हसिना"
            ],
            "theme": "शोले सिनेमातल्या गाण्यांमधले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "करोड ",
                "राष्ट्र ",
                "गण",
                "सेना "
            ],
            "theme": "ज्यांना \"पती\" जोडता येतं ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शांती ",
                "शिव ",
                "वानर",
                "वायू "
            ],
            "theme": "ज्यांना \"सेना\" जोडता येतं ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "हिरा ",
                "धूमकेतू ",
                "हॅट ट्रीक",
                "प्लॅटिनम "
            ],
            "theme": "दुर्मिळ गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दही ",
                "पाणी ",
                "ओम ",
                "कोल्हा "
            ],
            "theme": "ज्यांना \"पुरी\" जोडून शब्द आहेत ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चहा ",
                "सिल्क ",
                "कुंगफू",
                "कागद "
            ],
            "theme": "चीन मध्ये उत्पत्ती झालेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "किमची",
                "गंगनम",
                "तायक्वांदो",
                "ह्युनडाई"
            ],
            "theme": "साऊथ कोरिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बॅडमिंटन",
                "टेनिस",
                "पिंगपाँग",
                "स्क्वॉश"
            ],
            "theme": "रॅकेट वापरून खेळायचे खेळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हॉकी",
                "फुटबॉल",
                "हँडबॉल",
                "बास्केटबॉल"
            ],
            "theme": "बॉल आणि नेट स्पोर्ट्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "कुस्ती",
                "रग्बी",
                "मुष्टियुद्ध",
                "ज्युडो"
            ],
            "theme": "माफक हिंसा असणारे खेळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तलाठी",
                "तहसीलदार",
                "प्रांत",
                "जिल्हाधिकारी"
            ],
            "theme": "महसूल विभागातील अधिकारी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "आमदार",
                "खासदार",
                "नगरसेवक",
                "मंत्री"
            ],
            "theme": "लोकप्रतिनिधी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वाहतूक",
                "सायबर",
                "रेल्वे",
                "सीआयडी"
            ],
            "theme": "पोलिस",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्रोम",
                "ओपेरा",
                "व्हिवाल्डी (vivaldi)",
                "सफारी"
            ],
            "theme": "ब्राउजर",
            "sharedBy": "चैतन्य",
            "difficulty": 0
        },
        {
            "words": [
                "चेलों (cello)",
                "व्हायोलिन ( violin )",
                "सतार",
                "वीणा"
            ],
            "theme": "तंतुवाद्य",
            "sharedBy": "चैतन्य",
            "difficulty": 1
        },
        {
            "words": [
                "झेब्रा",
                "वाघ",
                "बारकोडिंग",
                "कैदी"
            ],
            "theme": "पट्टे असलेले (striped)",
            "sharedBy": "चैतन्य",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुर्गा",
                "शांता",
                "इंदिरा",
                "गौरी"
            ],
            "theme": "मराठी साहित्यिका",
            "sharedBy": "शुभा",
            "difficulty": 0
        },
        {
            "words": [
                "इरावती",
                "कावेरी",
                "गोदावरी",
                "नर्मदा"
            ],
            "theme": "नद्या",
            "sharedBy": "शुभा",
            "difficulty": 1
        },
        {
            "words": [
                "लक्ष्मी",
                "सरस्वती",
                "पार्वती",
                "राधा"
            ],
            "theme": "देवता",
            "sharedBy": "शुभा",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छाती ",
                "खिळा ",
                "तंबू",
                "थाप"
            ],
            "theme": "ज्या गोष्टी ठोकता येतात ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कठडा ",
                "जर ",
                "कुंपण ",
                "समास/मार्जिन"
            ],
            "theme": "एखाद्या गोष्टीच्या बाजूने असलेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वय",
                "नखं",
                "लोकसंख्या",
                "केस "
            ],
            "theme": "कायम वाढणाऱ्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बटाटा ",
                "टोमॅटो ",
                "पेरू ",
                "काजू "
            ],
            "theme": "दक्षिण अमेरिकेत उत्पत्ती झालेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गोपूर",
                "मंडप",
                "गाभारा",
                "मूर्ती"
            ],
            "theme": "मंदिराचे भाग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मुकुट",
                "टोपली",
                "ओझं",
                "टोपी"
            ],
            "theme": "डोक्यावर ठेवता येणाऱ्या गोष्टी  ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चिंब",
                "श्रावण ",
                "धारा",
                "छत्री"
            ],
            "theme": "पाऊस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बिंब",
                "होळी",
                "ससा",
                "रोमँटिक"
            ],
            "theme": "पोर्णिमेचा चंद्र",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "टिंब",
                "पूर्णविराम",
                "कुंकू ",
                "तीळ"
            ],
            "theme": "ठिपका",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जुगार",
                "तंबाखू",
                "रील",
                "खरेदी"
            ],
            "theme": "व्यसने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शेयर्स",
                "कर्ज",
                "गहाण ठेव",
                "वेठबिगारी"
            ],
            "theme": "भांडवल उभं करण्याची साधने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "विपणन",
                "विक्री",
                "आयटी",
                "वित्त"
            ],
            "theme": "कंपनीतील विभाग (डिपार्टमेंटस्)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काटकोन",
                "वर्ग",
                "ग्रीस",
                "सिद्धांत "
            ],
            "theme": "पायथॅगोरस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "क्वांटम",
                "मांजर",
                "वेव्ह",
                "संभाव्यता"
            ],
            "theme": "श्रोडिंगर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ऑडिओ उपकरणे",
                "आईन्स्टाईन कंडेंन्सेट ",
                "पद्म विभूषण",
                "बोझॉन"
            ],
            "theme": "बोस",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "राहुल",
                "राजीव",
                "फिरोझ",
                "संजय"
            ],
            "theme": "गांधी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शक्ती",
                "महेंद्र ",
                "अनिल",
                "संजीव "
            ],
            "theme": "कपूर",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "जहांगीर",
                "रतन",
                "नवल",
                "दोराब"
            ],
            "theme": "टाटा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "करनम",
                "लोवलीना",
                "साक्षी",
                "मीराबाई"
            ],
            "theme": "भारतीय ऑलिंपिक पदक विजेत्या स्त्रिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अल्का",
                "उषा",
                "श्रेया",
                "अनुराधा"
            ],
            "theme": "हिंदी गायिका ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "लक्ष्मी",
                "अहिल्या",
                "तारा",
                "दुर्गावती"
            ],
            "theme": "शूर ऐतिहासिक राण्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सत्यभामा",
                "भद्रा",
                "रुक्मिणी ",
                "कालिंदी"
            ],
            "theme": "कृष्णाच्या पत्नी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "सुप्रिया",
                "ललिता",
                "ममता",
                "सुषमा"
            ],
            "theme": "स्त्री राजकारणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आशा",
                "शर्मिला",
                "माला",
                "साधना"
            ],
            "theme": "1960s मधल्या हिन्दी अभिनेत्री ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जना",
                "सखु",
                "मुक्ता",
                "मीरा"
            ],
            "theme": "स्त्री संत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रेखा",
                "सुष्मिता",
                "अमिशा",
                "कंगना"
            ],
            "theme": "अविवाहीत हिंदी अभिनेत्री ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "रंजना",
                "सीमा ",
                "चित्रा",
                "आशा "
            ],
            "theme": "जुन्या काळातल्या मराठी अभिनेत्री",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सरस",
                "कारीका",
                "मलम",
                "नयन"
            ],
            "theme": "Palindromes (विलोमपदॆ)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "टॉनिक ",
                "अंडं",
                "दुध ",
                "डिंकाचे लाडू"
            ],
            "theme": "पौष्टिक पदार्थ ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "साबण ",
                "बियर ",
                "समुद्राची लाट ",
                "सोडा "
            ],
            "theme": "फेस येणार्‍या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुर्बीण ",
                "बासरी ",
                "पुंगळी ",
                "पेने पास्ता"
            ],
            "theme": "पोकळ दंडगोलाकार वस्तु ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दृष्टी",
                "श्रवण",
                "स्पर्श",
                "चव"
            ],
            "theme": "ज्ञानेंद्रिये",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "देखावा",
                "संगीत ",
                "रेशीम ",
                "मसाला"
            ],
            "theme": "पंचेंद्रियांना सुखकारक गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दहा",
                "क्ष किरणे",
                "चूक",
                "गुणाकार"
            ],
            "theme": "X",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पतंग ",
                "विमान ",
                "डॉल्फिन ",
                "हनुमान"
            ],
            "theme": "शेपटी असलेल्या गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "फुलबाजी",
                "जातं",
                "सुकाणू ",
                "आरती"
            ],
            "theme": "हाताने गोल फिरवलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तोठरा",
                "गायन",
                "थायरॉईड",
                "मंगळसूत्र "
            ],
            "theme": "गळ्या संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "टिचकी",
                "अंगठी",
                "नखं",
                "सतार वादन"
            ],
            "theme": "बोटां संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मधुचंद्र ",
                "निरोप",
                "स्वागत समारंभ",
                "हुश्श्य"
            ],
            "theme": "लग्न कार्या नंतर करायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गोकर्ण",
                "उडुपी",
                "जोग",
                "मंगलोर "
            ],
            "theme": "कोस्टल कर्नाटक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "चामुंडी",
                "पाक",
                "पॅलेस",
                "चंदन"
            ],
            "theme": "मैसूर संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दूध",
                "कामधेनू",
                "गवत",
                "रवंथ"
            ],
            "theme": "गाई संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हवेली",
                "भोर",
                "मावळ",
                "खेड"
            ],
            "theme": "पणे जिल्ह्यातील तालुके",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "वाडा",
                "अर्धा दिवस",
                "सॅटर्न",
                "ओंकारेश्वर मंदिर "
            ],
            "theme": "शनिवार संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "लाल",
                "ताज",
                "हवा",
                "मोती"
            ],
            "theme": "‐ महाल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्वार",
                "पेरू",
                "इंडिया",
                "चर्च"
            ],
            "theme": "- गेट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पंचवटी",
                "वेताळ",
                "तळजाई",
                "हनुमान"
            ],
            "theme": "पुण्यातल्या टेकड्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भस्म",
                "भोळा",
                "तप",
                "गंगा"
            ],
            "theme": "शंकरा संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सतगुरु",
                "जमशेटजी",
                "सांता क्लाॅज",
                "मोदी"
            ],
            "theme": "पांढरी दाढी वाले",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रामदेव ",
                "साई",
                "अली",
                "आई"
            ],
            "theme": "- बाबा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पेस्तन काका",
                "भाभा",
                "वाडिया",
                "सॅम बहाद्दुर"
            ],
            "theme": "पारसी लोकं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "येसूबाई",
                "छावा",
                "तुळापूर",
                "शिवाजी"
            ],
            "theme": "संभाजी संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "हुबळीकर",
                "शेळके",
                "कार्टं",
                "बाई"
            ],
            "theme": "शांता संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "महेश",
                "काजळ",
                "पैसे",
                "कारनामे"
            ],
            "theme": "काळे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंचल",
                "शीतल ",
                "निर्मल",
                "कोमल"
            ],
            "theme": "\"सत्यम शिवम् सुंदरम\" मधिल गाण्याचे बोल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "खैबर",
                "पावन",
                "सिंबायोसिस ",
                "शेलार"
            ],
            "theme": "खिंड",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "योग",
                "चित्त",
                "वृत्ती",
                "निरोध"
            ],
            "theme": "पतंजली योगसूत्रातील दुसर्‍या वाक्यातील शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विधी",
                "रुद्र",
                "बच्चन",
                "पंचामृत"
            ],
            "theme": "अभिषेक ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अक्रोड",
                "रुद्राक्षं",
                "सफरचंद",
                "जरदाळू "
            ],
            "theme": "हिमालयात उगवणारी फळे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पोहे",
                "कढिपत्ता",
                "फोडणी",
                "दाणे"
            ],
            "theme": "चिवड्याचे घटक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कालि",
                "राम",
                "यशु",
                "तुलसी"
            ],
            "theme": " - दास नावाच्या प्रसिद्ध व्यक्ती",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गरम तेल",
                "कृष्ण ",
                "आगाशे",
                "गांधी"
            ],
            "theme": "मोहन",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "ताडदेव",
                "शीव",
                "फोर्ट",
                "प्रभादेवी"
            ],
            "theme": "मुंबईचे भाग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मत",
                "सत्ता",
                "शाही",
                "मान्य"
            ],
            "theme": "लोक - ...",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पदर",
                "शबनम",
                "डोली",
                "झोळी"
            ],
            "theme": "खांद्यावर घ्ययच्या / टांगायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "फटका",
                "बांबू",
                "पाण्यात",
                "वाया"
            ],
            "theme": "पैसे गमावणे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चिवडा",
                "लाडू",
                "चकली",
                "करंजी"
            ],
            "theme": "दिवाळीचे पदार्थ ",
            "sharedBy": "शुभचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तिळगुळ",
                "पतंग",
                "काळे कपडे",
                "मकर"
            ],
            "theme": "संक्रांत ",
            "sharedBy": "स्नेहा",
            "difficulty": 1
        },
        {
            "words": [
                "पानं",
                " छपाई ",
                " मूल्य",
                " मुखपृष्ठ"
            ],
            "theme": "पुस्तक",
            "sharedBy": "शिरीष केळकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुलकेशी",
                " हर्षवर्धन",
                " समुद्रगुप्त",
                " ललितादित्य"
            ],
            "theme": "पहिले सहस्रक",
            "sharedBy": "विकास पाटणकर",
            "difficulty": 0
        },
        {
            "words": [
                "समीकरण",
                " कर्ण",
                " कंस",
                " सूत्र"
            ],
            "theme": "गणित!",
            "sharedBy": "नुपुरा डोरले",
            "difficulty": 1
        },
        {
            "words": [
                "जम",
                "घसा",
                "तबलजी",
                "धक्का"
            ],
            "theme": "बसणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लोह",
                "सिंह ",
                "राज",
                "बांधव"
            ],
            "theme": "- गड",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "यष्टी",
                "झेल",
                "कप्तान",
                "पंच"
            ],
            "theme": "क्रिकेट मधील संज्ञा",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 1
        },
        {
            "words": [
                "शमी",
                "सुंदर",
                "विराट",
                "यशस्वी"
            ],
            "theme": "क्रिकेटपटूंची नावे ",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चिंचोका",
                "चॉकलेट ",
                "शिसवी लाकूड",
                "खजूर "
            ],
            "theme": "चॉकलेटी रंगाच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "जहाज ",
                " लाकूड ",
                " तेल ",
                " कापूस"
            ],
            "theme": "पाण्यावर तरंगणाऱ्या गोष्टी",
            "sharedBy": "कौशिक कुलकर्णी ",
            "difficulty": 1
        },
        {
            "words": [
                "बेल",
                "तुळस",
                "आघाडा",
                "दुर्वा"
            ],
            "theme": "देवाला वाहायची पाने",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नारळ",
                "विहीर ",
                "डोळे",
                "निवडुंग"
            ],
            "theme": "ज्यात पाणी असते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "धंदा",
                "हवा",
                "तेल",
                "औषध "
            ],
            "theme": "या शब्दांना \"पाणी\" जोडतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "जळगांवकर",
                "भाता",
                "सूर",
                "रीड"
            ],
            "theme": "हार्मोनियम",
            "sharedBy": "शिरीष केळकर ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रेडा",
                "गुराखी",
                "पु. ल.",
                "दुध "
            ],
            "theme": "म्हैस संबंधित ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ओंजळ ",
                "नव्याण्णव ",
                "ऑक्सिजन (O2) ",
                "टाळी"
            ],
            "theme": "दोन समान गोष्टीतून जोडून केलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "उडी",
                "सागर",
                "कमला",
                " जन्मठेप"
            ],
            "theme": "सावरकर",
            "sharedBy": "नुपुरा डोरले",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हळद",
                "टॅल्कम",
                "त्रिफळा",
                "गुलाल"
            ],
            "theme": "पूड, चूर्ण ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "नाका",
                "नस",
                "तट",
                "जमाव"
            ],
            "theme": "--- बंदी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "समुद्र ",
                " हवा ",
                " रस्ते ",
                " रूळ"
            ],
            "theme": "वाहतूकीचे मार्ग ",
            "sharedBy": "कौशिक कुलकर्णी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हस्त",
                "स्वाती",
                "मृग",
                "रेवती"
            ],
            "theme": "नक्षत्र",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 0
        },
        {
            "words": [
                "कंठ",
                "कटी",
                "नेत्र",
                "कर्ण"
            ],
            "theme": "अवयव",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 1
        },
        {
            "words": [
                "द्रोण",
                "कृप",
                "धर्म",
                "गंगा"
            ],
            "theme": "महाभारत व्यक्तिरेखा",
            "sharedBy": "रविकिरण देशपांडे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेळा",
                "विवाह",
                "रास",
                "कर्ण"
            ],
            "theme": "कुंभ---",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बाजू",
                "पंधरवडा",
                "संघटना",
                "पंख"
            ],
            "theme": "पक्ष चे विविध अर्थ",
            "sharedBy": "समीर जोशी ",
            "difficulty": 1
        },
        {
            "words": [
                "लस",
                "सुई",
                "कान",
                "काटा"
            ],
            "theme": "टोचायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "यष्टी",
                "झेल",
                "कप्तान",
                "पंच"
            ],
            "theme": "क्रिकेट मधील संज्ञा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "आरती",
                " आश्रम",
                "परिक्रमा",
                " कन्यापूजन"
            ],
            "theme": "नर्मदा  परिक्रमा",
            "sharedBy": "अनघा अनिल जोशी",
            "difficulty": 1
        },
        {
            "words": [
                "पोलीस ",
                "जेम्स बॉण्ड",
                "मूळ बिंदू (origin)",
                "शतक"
            ],
            "theme": "शून्य शून्य (दोन शून्यांचा समावेश)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "केदार",
                " मधुवंती",
                " मालकंस",
                "भूप"
            ],
            "theme": "हिंदुस्थानी संगीत राग",
            "sharedBy": "नुपुरा डोरले",
            "difficulty": 0
        },
        {
            "words": [
                "कट",
                "पॅक उप",
                "टेक",
                "रोल"
            ],
            "theme": "फिल्म शूटिंग करताना वापरात येणारे शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वर",
                "पाक",
                "भू",
                "चलित"
            ],
            "theme": "स्वयं __",
            "sharedBy": "समीर जोशी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तर्री",
                "पेज",
                "शोर्बा",
                "सॅम्पल "
            ],
            "theme": "पातळ खाद्य पदार्थ ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कान",
                "नाग",
                "जय",
                "खड्ग"
            ],
            "theme": " -- पूर नावाची भारतातील प्रसिद्ध गावे ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "रवा ",
                " साखर ",
                " तूप ",
                " काजू"
            ],
            "theme": "शिऱ्याचे घटक",
            "sharedBy": "कौशिक कुलकर्णी",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इन्दु",
                "मृगांक",
                " सुधांशु",
                " सोम"
            ],
            "theme": "चंद्राची काही नावे ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 0
        },
        {
            "words": [
                "रस",
                "गोडी",
                "रुची",
                "कल"
            ],
            "theme": "स्वारस्य या अर्थी",
            "sharedBy": "समीर जोशी ",
            "difficulty": 1
        },
        {
            "words": [
                "भरती",
                "ओहोटी",
                "ग्रहण",
                "अपोलो"
            ],
            "theme": "चंद्र कारणीभूत असणाऱ्या काही गोष्टी  ",
            "sharedBy": "HVN Unplugged",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्राण",
                "जीवन ",
                "प्रेम ",
                "शक्ती"
            ],
            "theme": "जुन्या हिंदी चित्रपटांमधील खलनायक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "जंगल",
                "लूट",
                "पंडित",
                "गुरु"
            ],
            "theme": "भारतीय उत्पत्तीचे इंग्रजीत वापरले जाणारे शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "हिरकणी",
                " टकमक",
                " छत्रपती",
                " राजधानी"
            ],
            "theme": "किल्ले रायगड",
            "sharedBy": "विवेक वासुदेव चितळे ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाचू",
                "पुष्कराज",
                "माणिक",
                "नीलम"
            ],
            "theme": "मौल्यवान रत्ने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पाखरू",
                " बाजी",
                " झाडे",
                " वडी"
            ],
            "theme": "फूल उपसर्ग लागून अर्थपूर्ण शब्द",
            "sharedBy": "आहना आगाशे",
            "difficulty": 1
        },
        {
            "words": [
                "लता",
                "सुमन",
                "किशोरी",
                "आशा"
            ],
            "theme": "प्रसिद्ध गायिका",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंतुले",
                " पवार",
                " राणे",
                " नाईक"
            ],
            "theme": "महाराष्ट्राचे माजी मुख्यमंत्री",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "ठोसर",
                " रेळेकर",
                " आंबिले",
                " कुलकर्णी"
            ],
            "theme": "महाराष्ट्रातील प्रसिद्ध संतांची आडनावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "राम",
                "सिद्ध",
                "हाय",
                "मिस"
            ],
            "theme": "--- टेक",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पिंड",
                "भोज्जा",
                "आभ्रे",
                "कपडे"
            ],
            "theme": "शिवण्याच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "माल",
                "भाऊ",
                "वीज ",
                "आश्चर्य "
            ],
            "theme": "‐‐- चा धक्का",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "घोडा",
                "लोट",
                "चक्की",
                "चट"
            ],
            "theme": "पाण ---",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धोबी",
                "खंबाटकी ",
                "मणिकर्णिका ",
                "अंबा"
            ],
            "theme": "--- घाट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "पाचगणी",
                " सप्तशृंगी",
                " हजारीबाग",
                " सोलापूर"
            ],
            "theme": "नावात अंक असलेली शहरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "गंज",
                "पूर",
                "बाद",
                "वाडी"
            ],
            "theme": "गावांच्या नावांचे शेवट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दमयंती ",
                "शकुंतला ",
                "मेनका,",
                "चित्रलेखा"
            ],
            "theme": "राजा रवी वर्मा यांच्या चित्रातील स्त्रिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "अंबिका",
                "गंगा",
                "सत्यवती",
                "माद्री"
            ],
            "theme": "महाभारत पूर्वार्धातील स्त्रिया ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "द्रौपदी",
                " उलुपी",
                " चित्रांगदा",
                " सुभद्रा"
            ],
            "theme": "महाभारतातील अर्जुन पत्नी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मीठ",
                "सुरमई ",
                "मोती",
                "पोवळं"
            ],
            "theme": "समुद्रात अढळणार्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कोशी",
                "अलकनंदा ",
                "पद्मा",
                "गोमाती"
            ],
            "theme": "गंगेला डाव्याबाजूने मिळणार्या नद्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मयुराक्षी",
                "सोने",
                "काली ",
                "दामोदर"
            ],
            "theme": "गंगेला उजव्याबाजूने मिळणार्या नद्या",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सोनल",
                "रोहिणी",
                "मल्लिका",
                "शोभना"
            ],
            "theme": "प्रसिद्ध शास्त्रीय नृत्यांगना",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "दौंड",
                " पुरंदर",
                " हवेली",
                " इंदापूर"
            ],
            "theme": "पुणे जिल्ह्यातील तालुके",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "फडणवीस",
                " बावनकुळे",
                " सातपुते",
                " आठवले"
            ],
            "theme": "नावात अंक असलेली आडनावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढोबळी मिरची",
                "द्राक्षं",
                "सफरचंद ",
                "टोमॅटो "
            ],
            "theme": "दोन, तीन वा अधिक वेगवेगळ्या रंगात येणाऱ्या भाज्या/फळं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कांदा ",
                "बटाटा ",
                "पालक ",
                "मिरची "
            ],
            "theme": "ज्याची भजी केली जातात ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आवकाडो",
                "ऑलिव्ह",
                "ब्रोकोली",
                "चेरी"
            ],
            "theme": "आजकाल मंडईत सर्रास मिळणारी परदेशी भाज्या/फळं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कर्क",
                "ह्रदय ",
                "क्षय",
                "कृष्ठ"
            ],
            "theme": "--- रोग",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गळ",
                "पतंग",
                "सुई",
                "भवरा"
            ],
            "theme": "ज्यानां लांब दोरा लावतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "व्यायाम",
                "ताप",
                "कॉफी ",
                "भीती"
            ],
            "theme": "हृदयची गती वाढवणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भितीदायक स्वप्न",
                "कडाडणारी वीज",
                "सळसळणारा साप",
                "किंकाळी"
            ],
            "theme": "दचकवणार्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "नेत्याचं भाषण ",
                "सिनेमातील हीरोगीरी",
                "सैनिकांची वीरता",
                "दुसर्‍याचे यश"
            ],
            "theme": "प्रोत्साहित करणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "कार्टून",
                "निवडक पु. ल.",
                "गुदगुल्या",
                "नायट्रस ऑक्साईड (N2O)"
            ],
            "theme": "हसवणार्या गोष्टी (N2O - Laughing Gas)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाऊन",
                "हस्तांदोलन ",
                "पदवी",
                "चौकोनी टोपी"
            ],
            "theme": "दीक्षांत समारंभ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "भव्य इमारती",
                "प्राध्यापक",
                "ग्रंथालय ",
                "उच्च शिक्षण "
            ],
            "theme": "विद्यापीठ ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "परीक्षा",
                "अर्ज",
                "शुल्क",
                "बारावी पास "
            ],
            "theme": "विद्यापीठात प्रवेश मिळवण्यासाठी लागणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चेन्नई",
                " धाराशिव",
                "प्रयागराज",
                " अहिल्यानगर"
            ],
            "theme": "नामांतरीत शहरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सहन",
                " स्मरण",
                " स्त्री",
                " महा"
            ],
            "theme": " ___ शक्ती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "विंध्य",
                " गंगा",
                " मराठा",
                " गण"
            ],
            "theme": "राष्ट्रगीतातील शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुट्टी",
                " ऊन",
                " हापूस",
                " पंखा"
            ],
            "theme": "उन्हाळा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मोहरी",
                " जवस",
                " सोयाबीन",
                " एरंड"
            ],
            "theme": "तेलबिया",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चित्र",
                " हाहा",
                " कला",
                " चर्म"
            ],
            "theme": "____ कार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ताक",
                "बेसन",
                "कढीपत्ता",
                "आलं"
            ],
            "theme": "कढीतले पदार्थ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "फ्लावर",
                "बटाटा",
                "ढोबळी मिरची ",
                "मटार"
            ],
            "theme": "पावभाजीतील पदार्थ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "मेथी",
                "पालक",
                "आळू",
                "चाकवत"
            ],
            "theme": "ज्यांची पातळ भाजी बनवतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रंग",
                " सूर",
                " ऋषी",
                " सिंधू"
            ],
            "theme": "सप्त ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "वड",
                " माले",
                " जळ",
                " माझ"
            ],
            "theme": "___ गाव",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "पाल",
                " देव",
                " घर",
                " लाड"
            ],
            "theme": "_____घर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खास",
                "जरूर ",
                "तुफान ",
                "कैद"
            ],
            "theme": "अरबी भाषेतून मराठीत आलेले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ऑफिस ",
                "फोन",
                "बिस्किट ",
                "फोटो"
            ],
            "theme": "इंग्रजी भाषेतून मराठीत आलेले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अक्का",
                "चप्पल ",
                "बांगडी",
                "किल्ली"
            ],
            "theme": "कानडी भाषेतून मराठीत आलेले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तीर",
                " पात्र",
                " वाळू",
                " घाट"
            ],
            "theme": "नदी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "वतन",
                " ठाणे",
                " दम",
                " दुकान"
            ],
            "theme": "____दार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अशोकस्तंभ",
                " गीर",
                " सिंबा",
                " छावा"
            ],
            "theme": "सिंह",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सिंघम",
                " खाकी",
                " चौकी",
                " गस्त"
            ],
            "theme": "पोलिस",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गांधी",
                " रॉय",
                " बोस",
                " शाहरुख"
            ],
            "theme": "राहुल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मीना",
                " तेजस",
                " बाळ",
                " श्रीकांत"
            ],
            "theme": "ठाकरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आदित्य",
                " मुकेश",
                " राहुल",
                " रतन"
            ],
            "theme": "उद्योग समूह प्रमुख",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "राज",
                " समाज",
                " अर्थ",
                " विना"
            ],
            "theme": "__ कारण",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मीना",
                " तेजस",
                " बाळ",
                " श्रीकांत"
            ],
            "theme": "ठाकरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लीला",
                " गरबा",
                " ढीग",
                " मेष"
            ],
            "theme": "रास",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पूजा",
                "ऋषी",
                " दार",
                " दास"
            ],
            "theme": "देव ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रेखा",
                " उर्मिला",
                " सौमित्र",
                " शेष"
            ],
            "theme": "लक्ष्मण",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हात गाडी",
                "टोपली",
                "ठेला",
                "पथारी"
            ],
            "theme": "भाजी विक्रेत्यांची साधने",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रुखवत ",
                "डाव",
                "हिशेब ",
                "पंगत"
            ],
            "theme": "मांडता येणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "पद्म",
                " वज्र",
                " हल",
                " शीर्ष"
            ],
            "theme": "___आसन",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गदा",
                " त्रिशूल",
                " खड्ग",
                " परशू"
            ],
            "theme": "अस्त्रे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "अंकुश",
                " पाश",
                " मोदक",
                " आशीर्वाद"
            ],
            "theme": "गणपती चे चार हात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "खजूर",
                "उजाड ",
                "वाळू",
                "निवडुंग"
            ],
            "theme": "वाळवंटाची वैशिष्ट्य ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुबई ",
                "पॅरिस ",
                "टोकिओ ",
                "क्वालालंपूर"
            ],
            "theme": "प्रसिद्ध टॉवर असलेली शहरे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "भिंत",
                "प्रगती",
                "साम्यवाद",
                " अलीबाबा"
            ],
            "theme": "चीन",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "लामा",
                " मेटा",
                " जेमिनी",
                "जीपीटी"
            ],
            "theme": "एआय मॉडेल्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नामंजूर",
                " मोर्चा",
                " दिवस",
                " आयुष्य"
            ],
            "theme": "संदीप खरे गाणी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "लाल",
                " मृत",
                " अरब",
                " बंगाल"
            ],
            "theme": "समुद्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दिल",
                " कस",
                " वजन",
                " भर"
            ],
            "theme": "___ दार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्फूर्ती",
                " वेदना",
                " दिलासा",
                " आल्हाद"
            ],
            "theme": "____दायक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "राज",
                " सिंह",
                " देव",
                " हरिश्चंद्र"
            ],
            "theme": "___ गड",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वाघ",
                " उंदीर",
                " मोर",
                " ऐरावत"
            ],
            "theme": "देवांची वाहने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंद्र",
                " गंगा",
                " साप",
                " नंदी"
            ],
            "theme": "शंकराशी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेटी",
                " मेंढी",
                " भुई",
                " कडे"
            ],
            "theme": "__ कोट",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "ढील",
                " शेपूट",
                "बेंजामिन फ्रँकलिन ",
                "मांजा"
            ],
            "theme": "पतंग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंगठी",
                " बांगडी",
                " हातमोजा",
                " घड्याळ"
            ],
            "theme": "हातात घालायच्या वस्तू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हातमोजे",
                "चाकू",
                "प्रखर दिवे",
                "मास्क"
            ],
            "theme": "सर्जन",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "लाल",
                "मोहर",
                "पेटी",
                "सिल बंद"
            ],
            "theme": "लाख",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नेम",
                "सहा",
                "गब्बर ",
                "कट्टा"
            ],
            "theme": "पिस्तूल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ऊब",
                "दुध",
                "झोप",
                "प्रेम"
            ],
            "theme": "तान्ह्या बळाला गरजेच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अग्नी",
                "पातेलं",
                "साखर",
                "हळद"
            ],
            "theme": "स्वयंपाकघरात अढळणार्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाग",
                "ऋषि",
                "रंग",
                "वसंत"
            ],
            "theme": "---पंचमी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कट",
                "जवळ",
                "रण",
                "चीड"
            ],
            "theme": "मागोमाग दोनदा वापरता येणारे शब्द",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "शॉवर",
                "हत्ती",
                "कारंजे ",
                "अग्निशमन दल"
            ],
            "theme": "पाण्याचा फवारा मारणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सोडा",
                "टूथपेस्ट ",
                "समुद्राची लाट",
                "डिटर्जंट"
            ],
            "theme": "फेस येणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "मूर्ती",
                "समई ",
                "घंटा",
                "बिगुल"
            ],
            "theme": "पितळ्याच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वाटा",
                "आंब्याच्या फोडी",
                "खडी",
                "चिंध्या"
            ],
            "theme": "एखाद्या गोष्टीचे तुकडे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "माहीम ",
                "दुधी",
                "मुग",
                "बदामी"
            ],
            "theme": "हलवा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "राजस्थान ",
                "इराण ",
                "ईजिप्त ",
                "ॲरिझोना"
            ],
            "theme": "वाळवंटी प्रदेश ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "प्रेम ",
                "विहीर ",
                "विचार",
                "संकट"
            ],
            "theme": "ज्यात पडता येतं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाणी",
                "उपास",
                "गाठ",
                "बाण"
            ],
            "theme": "ज्या गोष्टी सोडता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "फांदी",
                "झेंडा",
                "केस",
                "ढग"
            ],
            "theme": "वार्‍याने हलणाऱ्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "धूर",
                "प्लास्टिक ",
                "आवाज",
                "औद्योगिक रसायने"
            ],
            "theme": "प्रदुषण कारक गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "औषध ",
                "विश्रांती",
                "मोसंबी ",
                "धीर"
            ],
            "theme": "आजारी व्यक्तिला द्यायच्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "ओला कचरा",
                "पेट्री डिश",
                "ईडलीचे पीठ",
                "पचनसंस्था"
            ],
            "theme": "ज्यात बॅक्टेरिया अढळतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "बुबुळ",
                "उत्तप्पा",
                "सी डी ",
                "फ्रिस्बी"
            ],
            "theme": "गोलाकार गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कॅमेरा",
                "फोन ",
                "जी.पी.एस",
                "स्क्रिन"
            ],
            "theme": "स्मार्ट फोन ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बुद्धी ",
                "दुर्",
                "निर्",
                "भुज"
            ],
            "theme": "---बळ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "धन",
                "आरोग्य ",
                "दीप ",
                "शत्रु"
            ],
            "theme": "शुभंकरोतीतले शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वात",
                "गादी",
                "मलमपट्टी",
                "चरखा"
            ],
            "theme": "कापसाशी संबंधित गोष्टी ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "शरद",
                "अवरोह ",
                "संध्याकाळ",
                "घसरगुंडी"
            ],
            "theme": "ज्यात उतरत्या गोष्टी अढळतात (तापमान, सूर्य, सुर, इत्यादी)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वर्षा",
                "मल्हार",
                "गणेश चतुर्थी",
                "धारा"
            ],
            "theme": "पावसाळ्या संबंधित (ऋतु, राग, सण, इत्यादी)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बुजगावणं",
                "पीक",
                "पाटाचं पाणी",
                "ट्रॅक्टर"
            ],
            "theme": "शेत",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "हिमालय",
                "तप",
                "विरक्ती",
                "लांब दाढी"
            ],
            "theme": "साधू",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "भाव",
                "भक्ती",
                "राष्ट्र",
                "अंगाई"
            ],
            "theme": "ज्यांना \"गीत\" जोडता येतं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाणे",
                "दिवे",
                "कात्रज",
                "खंडाळा"
            ],
            "theme": "घाट",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "माती",
                "स्पंज",
                "पाझर खड्डे",
                "कापुस"
            ],
            "theme": "ज्याच्यात पाणी मुरते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "नवीन",
                "मलम",
                "सरस",
                "सामोसा"
            ],
            "theme": "Palindromes (विलोमपदॆ)",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शारदा",
                "आरंभ",
                "चत्वार",
                "आनंत"
            ],
            "theme": "पहिल्या \"मनाचे श्लोका\"तील शब्द",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "सिम",
                "रेशन",
                "आधार",
                "आय"
            ],
            "theme": "कार्ड",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "नदीचा प्रवाह",
                "घाट",
                "साप",
                "एस"
            ],
            "theme": "नागमोडी गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बंब",
                "भस्म",
                "तेल",
                "लाकूड"
            ],
            "theme": "यांचा आगीशी खेळ!",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्मण",
                "फडणीस",
                "मिरांडा",
                "ठाकरे"
            ],
            "theme": "व्यंगचित्रकार",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "स्वप्नं",
                "कल्पना",
                "भूत",
                "सँताक्लॉज"
            ],
            "theme": "वास्तवात नसलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अणू",
                "फेस",
                "आकाशगंगा",
                "बबल रॅप"
            ],
            "theme": "ज्यात बहुतांशी पोकळी असते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कांत",
                "संत",
                "गोळे",
                "सुर्वे"
            ],
            "theme": "काही मराठी साहित्यिकांची आडनावे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 1
        },
        {
            "words": [
                "ज्योतिर्लिंग",
                "रास",
                "महिना",
                "..खडी"
            ],
            "theme": "बाराच्या संखेने असलेल्या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झोप",
                "खाद्य",
                "संगीत",
                "मद्य"
            ],
            "theme": "श्रमपरिहाराची साधने",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "मेधा",
                "स्मृति",
                "आठवण",
                "स्मरण"
            ],
            "theme": "मेंदूच्या क्षमता ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "दशा",
                "व्यथा",
                "परिस्थिती",
                "अवस्था"
            ],
            "theme": "स्थिती चे सामानार्थी शब्द ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मोहरी",
                "तेल",
                "हिंग",
                "हळद"
            ],
            "theme": "फोडणी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "उपनिषद",
                "नचिकेत",
                "यम",
                "मोक्ष"
            ],
            "theme": "कठोपनिषद्",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "अभ्यास",
                "रियाज",
                "सराव",
                "मेहनत"
            ],
            "theme": "शिक्षण ",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सूर्य",
                "लेझर",
                "दीपस्तंभ",
                "ट्यूबलाईट"
            ],
            "theme": "प्रखर गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "निर्या",
                "जर",
                "घडी",
                "कांचीपुरम"
            ],
            "theme": "साडी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "सोनं",
                "मणि",
                "गोल",
                "बोट"
            ],
            "theme": "अंगठी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढीग",
                "कविता",
                "मनोरा",
                "लगोरी"
            ],
            "theme": "ज्या गोष्टी रचता येतात",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "बाळ",
                "प्रेक्षक",
                "चांभार",
                "पर्यटक"
            ],
            "theme": "ज्यांना कुतूहल असते",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "घनिष्ठ",
                "संगत",
                "यार",
                "गट्टी"
            ],
            "theme": "मैत्री",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वानर",
                "वेताळ",
                "वाघुळ",
                "टारझन"
            ],
            "theme": "झाडाला लोंबकळणाऱे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गोबी",
                "थार",
                "कलहरी",
                "मोहावी"
            ],
            "theme": "वाळवंटं",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "आरोह",
                "गिर्यारोहक",
                "मद्य",
                "ताप"
            ],
            "theme": "चढणार्‍या गोष्टी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अभिजित",
                "अमर्त्य",
                "रवींद्र",
                "कॆलाश"
            ],
            "theme": "भारतीय नोबेल विजेत्यांची पहिली नावे",
            "sharedBy": "केदार म्हसवडे",
            "difficulty": 0
        },
        {
            "words": [
                "गांधी",
                "फुले",
                "विदुर",
                "बसवेश्वर"
            ],
            "theme": "\"महात्मा\" पदवी असलेले",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "बिड",
                "बिम",
                "बित",
                "बिर"
            ],
            "theme": "अर्थहीन पहिले, पण अर्थपूर्ण दुसरे शब्द (हाड-, काम-, हात-, घर-)",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मध्यस्त",
                "पूल",
                "लग्न",
                "फोन कॉल"
            ],
            "theme": "दोन घटकांना जोडणारे",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "रक्त",
                "कुंकू",
                "जास्वंद",
                "थांबा"
            ],
            "theme": "लाल",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "वेफर्स ",
                "दाबेली ",
                "उकडलेला",
                "कंद"
            ],
            "theme": "बटाटा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भजी",
                "अक्कलेचा",
                "चिरलेला",
                "पात"
            ],
            "theme": "कांदा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "कायदा",
                "ताल",
                "लग्गी",
                "सम"
            ],
            "theme": "तबला",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 1
        },
        {
            "words": [
                "चौखूर धाव",
                "हयः",
                "तबेला",
                "झुपकेदार"
            ],
            "theme": "घोडा",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बांबू",
                "कृष्ण",
                "छिद्रं",
                "फुंकर"
            ],
            "theme": "बासरी",
            "sharedBy": "संदीप सोवनी ",
            "difficulty": 0
        },
        {
            "words": [
                "गुप्त",
                "निशा",
                "जल",
                "अगो"
            ],
            "theme": "___ चर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मच्छर",
                "नाम",
                "नटसम्राट",
                "छप्पन"
            ],
            "theme": "नाना पाटेकर यांच्याशी संबंधित (चित्रपट/संस्था)",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अठ्ठावीस",
                "तुळस",
                "राही",
                "गरूड"
            ],
            "theme": "विठ्ठल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्रेम",
                "तुळशी",
                "मुखत्यार",
                "मृत्यू"
            ],
            "theme": "___पत्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रंग",
                "कृष्ण",
                "वल्ली",
                "निवास"
            ],
            "theme": "नावे श्री___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मामा",
                "हळद",
                "माळ",
                "अग्नी"
            ],
            "theme": "लग्नाशी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मधु",
                "भाल",
                "हरीश",
                "अर्ध"
            ],
            "theme": "___ चंद्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "प्रदूषण",
                "थंडी",
                "चांदणी चौक",
                "विराट"
            ],
            "theme": "दिल्ली",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सचिन",
                "प्रणव",
                "भूपेन",
                "लता"
            ],
            "theme": "भारतरत्न",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "प्रथम",
                "अव्वल",
                "सुवर्ण",
                "अजिंक्य"
            ],
            "theme": "विजेता",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "ताम्र",
                "बुद्धिबळ",
                "कथा",
                "वर्धन"
            ],
            "theme": "पट",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जस्त",
                "पोलाद",
                "कांस्य",
                "पितळ"
            ],
            "theme": "मिश्रधातू",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गावसकर",
                "प्रभू",
                "पाल",
                "दत्त"
            ],
            "theme": "सुनील _____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "भैरव",
                "सारंग",
                "दुर्गा",
                "मल्हार"
            ],
            "theme": "शास्त्रीय संगीताचे राग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गुरू",
                "संदीप",
                "वैभव",
                "किशोर"
            ],
            "theme": "मराठी कवी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "संकोच",
                "संशय",
                "विकार",
                "विवाद"
            ],
            "theme": "नि: प्रत्यय लागू शकणारे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रक्त",
                "हत्यार",
                "तपास",
                "बेड्या"
            ],
            "theme": "गुन्ह्याची उकल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कान",
                "नाक",
                "डोळे",
                "जीभ"
            ],
            "theme": "ज्ञानेंद्रिये",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "बहार",
                "नंद",
                "चार",
                "हरित"
            ],
            "theme": "सदा ____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "सूर",
                "व्यक्त",
                "समर्थ",
                "सत्य"
            ],
            "theme": "आधी अ लावल्यास विरुद्धार्थी शब्द बनतो",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वार्ता",
                "प्रेम",
                "नुर्वी",
                "मंगलमूर्ती"
            ],
            "theme": "गणपती आरती मधील शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "मेकअप",
                "दुर्बीण",
                "कार",
                "सौरचूल"
            ],
            "theme": "आरसा चे उपयोग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "लाईट",
                "संगीत",
                "तालीम",
                "मंच"
            ],
            "theme": "नाटक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दोरी",
                "गॉगल",
                "बूट",
                "कंपास"
            ],
            "theme": "गिर्यारोहणाची साधने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेशी",
                "तुरुंग",
                "मोबाईल",
                "बॅटरी"
            ],
            "theme": "सेल या शब्दाचे अर्थ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "काश्मीर",
                "आयफोन",
                "न्यूटन",
                "ज्यूस"
            ],
            "theme": "सफरचंद",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गोवा",
                "सिक्कीम",
                "सिल्वासा",
                "पाँडिचेरी"
            ],
            "theme": "१९५० नंतर भारतात समाविष्ट झालेले प्रदेश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "खडा",
                "गोडा",
                "काळा",
                "गरम"
            ],
            "theme": "मसाला",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अंत्य",
                "तीर्थ",
                "शोभा",
                "विदेश"
            ],
            "theme": "यात्रा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जन्म",
                "मृत्यू",
                "पदवी",
                "जात"
            ],
            "theme": "प्रमाणपत्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "लोकमान्य",
                "तर्कतीर्थ",
                "महात्मा",
                "स्वातंत्र्यवीर"
            ],
            "theme": "पदव्या",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चाचा",
                "बापू",
                "सरदार",
                "मौलाना"
            ],
            "theme": "टोपण नावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गांधी",
                "नेहरू",
                "पटेल",
                "आंबेडकर"
            ],
            "theme": "आडनावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "ब्रेक",
                "सालसा",
                "टँगो",
                "कथ्थक"
            ],
            "theme": "नृत्य",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "चाक",
                "गिअर",
                "ब्रेक",
                "टायर"
            ],
            "theme": "कार",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जॅझ",
                "सिटी",
                "एलिव्हेट",
                "अमेझ"
            ],
            "theme": "होंडा कार मॉडेल्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "चंद्र",
                "नाग",
                "जय",
                "मिर्झा"
            ],
            "theme": "___ पूर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "नंदी",
                "मठ्ठ",
                "जिवा",
                "पोळा"
            ],
            "theme": "बैल",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कंठ",
                "गाय",
                "मणी",
                "गिरी"
            ],
            "theme": "नील___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "एक",
                "केदार",
                "नाग",
                "आदित्य"
            ],
            "theme": "___नाथ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मीठ",
                "चहा",
                "कार",
                "घड्याळ"
            ],
            "theme": "टाटा उत्पादने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बारा",
                "बिगुल",
                "सूप",
                "बँड"
            ],
            "theme": "___ वाजणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शिक्षा",
                "यातायात",
                "चेष्टा",
                "साक्षात्कार"
            ],
            "theme": "मराठी आणि हिंदी मध्ये वेगळ्या अर्थाने वापरले जाणारे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "गाठी",
                "काठी",
                "साडी",
                "तांब्या"
            ],
            "theme": "गुढी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धर्म",
                "नर",
                "देव",
                "जीत"
            ],
            "theme": "__इंद्र",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सम",
                "ताल",
                "राग",
                "छंद"
            ],
            "theme": "गाणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "विषम",
                "मूळ",
                "घन",
                "समीकरण"
            ],
            "theme": "गणितातील संज्ञा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सूर",
                "थाप",
                "हाक",
                "चक्कर"
            ],
            "theme": "____ मारणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "विराट",
                "सुनील",
                "जसप्रीत",
                "सचिन"
            ],
            "theme": "IPL मध्ये फक्त एकच टीम कडून खेळलेले प्लेअर्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "रोहित",
                "धोनी",
                "श्रेयस",
                "हार्दिक"
            ],
            "theme": "IPL जिंकलेले कॅप्टन",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छोटा",
                "आंबेडकर",
                "पांडव",
                "गदा"
            ],
            "theme": "भीम",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हजारे",
                "पाटील",
                "साठे",
                "पंक्चर"
            ],
            "theme": "अण्णा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "केसरी",
                "माती",
                "डाव",
                "गादी"
            ],
            "theme": "कुस्ती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शकील",
                "भीम",
                "राजन",
                "चेतन"
            ],
            "theme": "छोटा___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "राजीव",
                "अनिल",
                "अर्जुन",
                "रणबीर"
            ],
            "theme": "__ कपूर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "धर्म",
                "क्रांती",
                "परम",
                "शूर"
            ],
            "theme": "____ वीर",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लब्ध",
                "रती",
                "करण",
                "वर"
            ],
            "theme": "उप ___",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हात",
                "चेहरा",
                "पोपट",
                "पत्रिका"
            ],
            "theme": "ज्योतिषी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "मेंदी",
                "मांडव",
                "भटजी",
                "वाजंत्री"
            ],
            "theme": "लग्न",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "केशव",
                "माधव",
                "राजेंद्र",
                "सुदर्शन"
            ],
            "theme": "सरसंघचालक",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "द्रौपदी",
                "प्रतिभा",
                "झाकीर",
                "प्रणव"
            ],
            "theme": "राष्ट्रपती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "तेजस्वी",
                "तेजप्रताप",
                "मिसा",
                "रोहिणी"
            ],
            "theme": "लालूप्रसाद यादव यांची मुले",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घोडा",
                "राजा",
                "वजीर",
                "हत्ती"
            ],
            "theme": "बुद्धिबळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "पेशवा",
                "अमात्य",
                "सेनापती",
                "न्यायाधीश"
            ],
            "theme": "अष्टप्रधान मंडळातील पदे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "उंट",
                "नांगर",
                "समुद्र",
                "विक्रांत"
            ],
            "theme": "जहाज",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फवारणी",
                "पेरणी",
                "कापणी",
                "सिंचन"
            ],
            "theme": "शेती संबंधी ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "माप",
                "धागा",
                "कात्री",
                "टीप"
            ],
            "theme": "शिंपी (टेलर) शी संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दोर",
                "भू",
                "आम्र",
                "उप"
            ],
            "theme": "__खंड",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाझा",
                "पाणी",
                "मलम",
                "किनार"
            ],
            "theme": "__पट्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "गंध",
                "माहिती",
                "बातमी",
                "पत्ता"
            ],
            "theme": "एखाद्या गोष्टीबद्दल माहिती असणे किंबहुना नसणे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "पोत",
                "रंग",
                "किंमत",
                "वार"
            ],
            "theme": "साडी घेताना पहायच्या गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आठवडा",
                "निर्भेळ",
                "अचाट",
                "पुरिया"
            ],
            "theme": "शब्दात एक चटपटीत खाद्य पदार्थ लपलेला शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "अबोली",
                "राणी",
                "पिस्ता",
                "मोरपंखी"
            ],
            "theme": "काही विशिष्ठ रंग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "बृहन्नला",
                "पार्थ",
                "अर्जुन",
                "गुडाकेश"
            ],
            "theme": "अर्जुनाची वेगवेगळी नावे किंवा रूपे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अफगाणिस्तान",
                "पाकिस्तान",
                "बांगलादेश",
                "नेपाळ"
            ],
            "theme": "भारताचे शेजारी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "कझाकिस्तान",
                "किर्गिस्तान",
                "ताजिकिस्तान",
                "उझबेकिस्तान"
            ],
            "theme": "पूर्वीच्या सोविएत रशियातून निर्मित देश ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "अग्र",
                "ज्येष्ठ",
                "मुख्य",
                "प्रधान"
            ],
            "theme": "पहिला किंवा महत्त्वाचा या अर्थी ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अष्ट",
                "पंत",
                "ग. प्र.",
                "पुरुष"
            ],
            "theme": "___ प्रधान जोडून अर्थपूर्ण शब्द / व्यक्ती ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "शाळा",
                "देव",
                "खेळाडू",
                "केस"
            ],
            "theme": "ज्यांचे एकवचन आणि बहुवचन सारखे आहे असे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वेध",
                "स्पर्श",
                "मध्य",
                "मोक्ष"
            ],
            "theme": "ग्रहणाच्या स्थिती",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बाकर",
                "पाट",
                "अळू",
                "कोथिंबीर"
            ],
            "theme": "___वडी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "कलिंगड",
                "पेरू",
                "पोपट",
                "ट्रॅफिक सिग्नल"
            ],
            "theme": "लाल आणि हिरव्या रंगाच्या गोष्टी ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "माठ",
                "टोमॅटो",
                "मिर्ची",
                "द्राक्षे"
            ],
            "theme": "या गोष्टी लाल किंवा हिरव्या असतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घुबड",
                "अमावस्या",
                "तेरा",
                "कोल्हेकुई"
            ],
            "theme": "अशुभ मानल्या जाणाऱ्या अंधश्रद्धा",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "बी",
                "अंकूर",
                "रोप",
                "कलम"
            ],
            "theme": "झाडा संबंधी ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "अंडे",
                "अळी",
                "कोष",
                "पाखरू"
            ],
            "theme": "फुलपाखरु/पतंग यांचे जीवनचक्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जलाशय",
                "वाफ",
                "ढग",
                "पाऊस"
            ],
            "theme": "पाण्याचे निसर्गचक्र ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "रेवा",
                "दर्शन",
                "चालणे",
                "अमरकंटक"
            ],
            "theme": "नर्मदा परिक्रमा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आषाढ",
                "पाऊस",
                "विठोबा",
                "उपवास"
            ],
            "theme": "आषाढी एकादशी",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रेवा",
                "सरस्वती",
                "अलकनंदा",
                "गायत्री"
            ],
            "theme": "भारतातील नद्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वाळू",
                "खारट",
                "मासे",
                "क्षितीज"
            ],
            "theme": "समुद्र",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "जमीन",
                "बी",
                "पाणी",
                "खत"
            ],
            "theme": "धान्य/शेती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कापूस",
                "चरखा",
                "सूत",
                "धागा"
            ],
            "theme": "आत्मनिर्भर वस्त्र निर्मिती",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 0
        },
        {
            "words": [
                "वाळू",
                "खारट",
                "पाणी",
                "मासे"
            ],
            "theme": "समुद्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तार",
                "प्रवाह",
                "धक्का",
                "कडकडाट"
            ],
            "theme": "वीज ",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बुटके",
                "सिंधू",
                "रंग",
                "सूर"
            ],
            "theme": "हे सात असतात",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "भागीरथी",
                "गंगा",
                "हुगळी",
                "पद्मा"
            ],
            "theme": "गंगा नदीची विविध नावे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "हार",
                "गुप्त",
                "कार",
                "पट"
            ],
            "theme": "चित्र_____",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्रोम",
                " ओपेरा",
                "व्हिवाल्डी (vivaldi)",
                "सफारी"
            ],
            "theme": "वेब ब्राउजर (आंतरजाल न्याहाळक)",
            "sharedBy": "चैतन्य",
            "difficulty": 0
        },
        {
            "words": [
                "चेलों (cello)",
                " व्हायोलिन ( violin )",
                " सतार",
                " वीणा"
            ],
            "theme": "तंतुवाद्य",
            "sharedBy": "चैतन्य",
            "difficulty": 1
        },
        {
            "words": [
                "झेब्रा",
                "वाघ",
                "बारकोड",
                "कैदी"
            ],
            "theme": "पट्टे असलेले (striped)",
            "sharedBy": "चैतन्य",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुबई",
                "तेहरान",
                "दोहा",
                "रियाध"
            ],
            "theme": "आखाती देशांच्या राजधान्या",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सिंगापूर",
                "व्हॅटिकन",
                "सॅन मरिनो",
                "मोनॅको"
            ],
            "theme": "लहान क्षेत्रफळाचे देश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "लंडन",
                "माद्रिद",
                "रोम",
                "अथेन्स"
            ],
            "theme": "युरोपियन शहरे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कानपूर",
                "लखनौ",
                "प्रयागराज",
                "वाराणसी"
            ],
            "theme": "उत्तरप्रदेश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "इंदूर",
                "जबलपूर",
                "ग्वाल्हेर",
                "उज्जैन"
            ],
            "theme": "मध्यप्रदेश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "दिल्ली",
                "लडाख",
                "चंदीगड",
                "पाँडिचेरी"
            ],
            "theme": "केंद्रशासित प्रदेश",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नेताजी",
                "तानाजी",
                "हंबीरराव",
                "बाजी"
            ],
            "theme": "शिवरायांचे मावळे",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "महात्मा",
                "लोकमान्य",
                "स्वातंत्र्यवीर",
                "सेनापती"
            ],
            "theme": "स्वातंत्र्य सैनिकांच्या पदव्या",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "नाना",
                "महादजी",
                "सखारामबापू",
                "हरिपंत"
            ],
            "theme": "बारभाई",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बॅडमिंटन",
                "टेनिस",
                "पिंगपाँग",
                "स्क्वॉश"
            ],
            "theme": "रॅकेट वापरून खेळायचे खेळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "हॉकी",
                "फुटबॉल",
                "हँडबॉल",
                "बास्केटबॉल"
            ],
            "theme": "बॉल आणि नेट स्पोर्ट्स",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "कुस्ती",
                "रग्बी",
                "मुष्टियुद्ध",
                "ज्युडो"
            ],
            "theme": "माफक हिंसा असणारे खेळ",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तलाठी",
                "तहसीलदार",
                "प्रांत",
                "जिल्हाधिकारी"
            ],
            "theme": "महसूल विभागातील अधिकारी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "आमदार",
                "खासदार",
                "नगरसेवक",
                "मंत्री"
            ],
            "theme": "लोकप्रतिनिधी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "वाहतूक",
                "सायबर",
                "रेल्वे",
                "सीआयडी"
            ],
            "theme": "पोलिस",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुर्गा",
                "शांता",
                "इंदिरा",
                "गौरी"
            ],
            "theme": "मराठी साहित्यिका",
            "sharedBy": "शुभा",
            "difficulty": 0
        },
        {
            "words": [
                "इरावती",
                "कावेरी",
                "गोदावरी",
                "नर्मदा"
            ],
            "theme": "नद्या",
            "sharedBy": "शुभा",
            "difficulty": 1
        },
        {
            "words": [
                "भरणी",
                "कृतिका",
                "आश्लेषा",
                "आर्द्रा"
            ],
            "theme": "अवकाश नक्षत्रे",
            "sharedBy": "हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धोम",
                "कोयना",
                "कण्हेर",
                "राधानगरी"
            ],
            "theme": "कृष्णा खोऱ्यातील धरणे",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 0
        },
        {
            "words": [
                "उजनी",
                "भाटघर",
                "वरसगाव",
                "चासकमान"
            ],
            "theme": "भीमा उपखोऱ्यातील धरणे",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 1
        },
        {
            "words": [
                "गंगापूर",
                "दारणा",
                "जायकवाडी",
                "माजलगाव"
            ],
            "theme": "गोदावरी खोऱ्यातील धरणे",
            "sharedBy": "आदित्य नंदकुमार पोंक्षे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सत्र",
                "कनिष्ठ",
                "उच्च",
                "सर्वोच्च"
            ],
            "theme": "न्यायालये",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "सर्व",
                "अखिल",
                "यच्चयावत",
                "समग्र"
            ],
            "theme": "संपूर्ण",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "खंड",
                "घटक",
                "विभाग",
                "अंश"
            ],
            "theme": "हिस्सा/भाग",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भडक",
                "शार",
                "कभिन्न",
                "गार"
            ],
            "theme": "रंगाच्या नावापुढे येणारे शब्द",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "तडक",
                "एकदम",
                "अवचित",
                "अचानक"
            ],
            "theme": "घाईघाईने",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "कडक",
                "तप्त",
                "गरम",
                "लाही"
            ],
            "theme": "उष्ण",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तामिळनाडू",
                "मल्ल्या",
                "जीत",
                "कारगिल"
            ],
            "theme": "विजय",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "तोफ",
                "बर्फ",
                "फेक",
                "आळशी"
            ],
            "theme": "गोळा संबंधित",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "शब्द",
                "मर्म",
                "नि",
                "भाव"
            ],
            "theme": "___बंध",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वड",
                "पिंपळ",
                "औदुंबर",
                "कडुनिंब"
            ],
            "theme": "देशी झाडे",
            "sharedBy": "मेधा वैद्य पुणे",
            "difficulty": 0
        },
        {
            "words": [
                "आंबा",
                "जांभूळ",
                "चिंच",
                "फणस"
            ],
            "theme": "देशी फळझाडे",
            "sharedBy": "मेधा वैद्य पुणे",
            "difficulty": 1
        },
        {
            "words": [
                "गुलमोहर",
                "घाणेरी",
                "निलगिरी",
                "गिरिपुष्प"
            ],
            "theme": "परदेशी झाडे",
            "sharedBy": "मेधा वैद्य पुणे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वीज",
                "रिक्षा",
                "पाणी",
                "कविता/गीत "
            ],
            "theme": "या गोष्टींना मीटर असते",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 0
        },
        {
            "words": [
                "बस",
                "निवडणूक",
                "सिनेमा",
                "प्राणिसंग्रहालय"
            ],
            "theme": "इथे तिकीट लागते",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 1
        },
        {
            "words": [
                "केळे",
                "बलक",
                "आंबा",
                "स्कूलबस"
            ],
            "theme": "पिवळ्या गोष्टी",
            "sharedBy": "रविकिरण देशपांडे",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पावकी",
                "निमकी",
                "पाऊणकी",
                "दिडकी"
            ],
            "theme": "शाळेतील पाठांतर (फार पूर्वी)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शालिवाहन",
                "विक्रम",
                "हिजरी",
                "ग्रेगोरियन"
            ],
            "theme": "कालमापन",
            "sharedBy": "शब्दबंध टीम",
            "difficulty": 1
        },
        {
            "words": [
                "प्रतिबंध",
                "चिकित्सा",
                "औषध",
                "आराम"
            ],
            "theme": "उपचार पद्धती आणि रोगमुक्ती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पृथ्वी",
                "गुरू",
                "शनी",
                "बुध"
            ],
            "theme": "सौरमाला",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रिचर्ड",
                "रोहिणी",
                "ऑस्कर",
                "बेन"
            ],
            "theme": "गांधी सिनेमाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "क्रिश",
                "पुष्पा",
                "डॉन",
                "झिम्मा"
            ],
            "theme": "सिक्वेल निघालेले सिनेमा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संपदा",
                "दक्षता",
                "किर्लोस्कर",
                "स्त्री"
            ],
            "theme": "नवी जुनी प्रसिद्ध मासिके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मलखांब",
                "हॉकी",
                "क्रिकेट",
                "विटी-दांडू"
            ],
            "theme": "लाकूड वापरण्यात येणारे खेळ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "फुटबॉल",
                "रग्बी",
                "कबड्डी",
                "बास्केटबॉल"
            ],
            "theme": "मैदानी खेळ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उदक",
                "जल",
                "तोय",
                "नीर"
            ],
            "theme": "पाण्याशी समानार्थी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पाणि",
                "कर",
                "भुजा",
                "बाहू"
            ],
            "theme": "हात समानार्थी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कोलंबिया",
                "अर्जेंटिना",
                "व्हेनेझुएला",
                "पेरू"
            ],
            "theme": "दक्षिण अमेरिकेतील मुख्य देश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अमिताभ बच्चन",
                "इशांत शर्मा",
                "शेख अब्दुल्ला",
                "धर्मेंद्र प्रताप सिंग"
            ],
            "theme": "खूप उंच लोक (६ ते ८ फूट)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अनुपम खेर",
                "सय्यद किरमाणी",
                "राकेश रोशन",
                "विशाल दादलानी"
            ],
            "theme": "डोक्यावरील केस नसलेले प्रसिद्ध लोक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "व्योमकेश बक्षी",
                "कटप्पा",
                "फेलुदा",
                "छोटा भीम"
            ],
            "theme": "काल्पनिक व्यक्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाट्य",
                "शैली",
                "प्रकरण",
                "कथा"
            ],
            "theme": "पुस्तक/लेखन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मुद्रण",
                "छपाई",
                "आवृत्ती",
                "प्रकाशक"
            ],
            "theme": "प्रकाशन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "फूल",
                "पान",
                "देठ",
                "पराग"
            ],
            "theme": "फुलाचे भाग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मान",
                "पद",
                "दर्जा",
                "स्थान"
            ],
            "theme": "सामाजिक/व्यावसायिक स्थान (Status)",
            "sharedBy": "AI",
            "difficulty": 0
        },
        {
            "words": [
                "आसन",
                "बैठक",
                "खुर्ची",
                "सिंहासन"
            ],
            "theme": "बसण्याची जागा",
            "sharedBy": "AI",
            "difficulty": 1
        },
        {
            "words": [
                "पदवी",
                "किताब",
                "बहुमान",
                "पुरस्कार"
            ],
            "theme": "उपाधी/सन्मान",
            "sharedBy": "AI",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चाल",
                "लय",
                "ठेका",
                "ताल"
            ],
            "theme": "संगीतातील गती/रचना",
            "sharedBy": "AI",
            "difficulty": 0
        },
        {
            "words": [
                "वेग",
                "गती",
                "झपाटा",
                "त्वरा"
            ],
            "theme": "हालचालीचा वेग",
            "sharedBy": "AI",
            "difficulty": 1
        },
        {
            "words": [
                "ओघ",
                "प्रवाह",
                "धार",
                "लाट"
            ],
            "theme": "पाण्याची हालचाल",
            "sharedBy": "AI",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मथळा",
                "वार्ता",
                "संपादकीय",
                "अग्रलेख"
            ],
            "theme": "वृत्तपत्र",
            "sharedBy": "AI",
            "difficulty": 0
        },
        {
            "words": [
                "सदर",
                "अंक",
                "मुखपृष्ठ",
                "कथा"
            ],
            "theme": "मासिक/नियतकालिक",
            "sharedBy": "AI",
            "difficulty": 1
        },
        {
            "words": [
                "कथानक",
                "प्रकरण",
                "नायक",
                "शेवट"
            ],
            "theme": "कादंबरी",
            "sharedBy": "AI",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आंबा",
                "केळी",
                "पपई",
                "चिकू"
            ],
            "theme": "उष्णकटिबंधीय फळे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रनवे34",
                "बेल बॉटम",
                "विजेता",
                "एअरलिफ्ट"
            ],
            "theme": "विमानाशी संबंधित हिंदी सिनेमे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "प्रथम",
                "आधी",
                "सुरुवात",
                "आरंभ"
            ],
            "theme": "पहिला या अर्थाचे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "यशस्वी",
                "पृथ्वी",
                "रोहित",
                "सुनील"
            ],
            "theme": "कसोटीतील सलामीचे फलंदाज",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सदाशिव",
                "पांडू",
                "गंगाराम",
                "चंदू"
            ],
            "theme": "दादा कोंडके यांचे नायक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जोडवी",
                "बिछवा",
                "मासोळी",
                "करंगुळ्या"
            ],
            "theme": "स्त्रीच्या पायाच्या बोटातील दागिने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हँड",
                "बेस",
                "व्हॉली",
                "बास्केट"
            ],
            "theme": "_बॉल खेळ..",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तबला",
                "डमरू",
                "संबळ",
                "टाळ"
            ],
            "theme": "ताल वाद्य",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पोपट",
                "मोर",
                "उंदीर",
                "हंस"
            ],
            "theme": "हिंदू देवतांची वाहने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेघा",
                "पूर्वा",
                "हस्त",
                "चित्रा"
            ],
            "theme": "पावसाळी नक्षत्रे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वाघ",
                "चित्ता",
                "बिबट्या",
                "सिंह"
            ],
            "theme": "मांजर समूहातील प्रजाती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "स्मृतिचित्रे",
                "शंवाकिय",
                "स्मरणगाथा",
                "कृष्णकाठ"
            ],
            "theme": "काही आत्मचरित्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "शरद",
                "हेमंत",
                "वर्षा",
                "वसंत"
            ],
            "theme": "मराठी ऋतू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "आभाळमाया",
                "असंभव",
                "वादळवाट",
                "राधा ही बावरी"
            ],
            "theme": "झी वाहिनी वरच्या काही मालिका",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सर्कस",
                "हमलोग",
                "मिस्टर योगी",
                "स्वाभिमान"
            ],
            "theme": "दूरदर्शन वरील काही जुन्या मालिका",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वैशाख",
                "आश्विन",
                "जेष्ठ",
                "कार्तिक"
            ],
            "theme": "मराठी महिने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कनिष्ठ",
                "दुय्यम",
                "हलका",
                "निकृष्ट"
            ],
            "theme": "कमी प्रतीचा या अर्थाचे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बासरी",
                "मोरपीस",
                "त्रिभंग मुद्रा",
                "सुदर्शन चक्र"
            ],
            "theme": "श्रीकृष्णाचे दर्शन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आग",
                "आह",
                "अंदाज",
                "आवारा"
            ],
            "theme": "राज कपूर चित्रपट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बॉबी",
                "सरगम",
                "हिना",
                "दामिनी"
            ],
            "theme": "ऋषी कपूर चित्रपट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दगड",
                "वीट",
                "काँक्रिट",
                "लाकूड"
            ],
            "theme": "घराच्या भिंती बनवण्याची विविध साहित्य ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जळ",
                "स्थळ",
                "काष्ठ",
                "पाषाण"
            ],
            "theme": "सर्व संभव जागा ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "साम",
                "दाम",
                "दंड",
                "भेद"
            ],
            "theme": "लोकांकडून काम करवून घेण्याच्या युक्ती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आहार",
                "निद्रा",
                "भय",
                "मैथुन"
            ],
            "theme": "मनुष्य आणि प्राणिमात्रांमधील मूळ प्रवृत्ती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंदिगढ",
                "दिल्ली",
                "पाँडिचेरी",
                "दमण"
            ],
            "theme": "केंद्रशासित प्रदेश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मुंबई",
                "पाटणा",
                "जयपूर",
                "भोपाळ"
            ],
            "theme": "राजधान्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "लखनौ",
                "प्रयागराज",
                "कानपुर",
                "अयोध्या"
            ],
            "theme": "उत्तर प्रदेशातील शहरे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुनील",
                "संदीप",
                "रवी",
                "दिलीप"
            ],
            "theme": "८०-९० मधील मुंबई क्रिकेटपटू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भानू",
                "आदित्य",
                "मरीची",
                "भास्कर"
            ],
            "theme": "सूर्याची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सखा",
                "मित्र",
                "सवंगडी",
                "सोबती"
            ],
            "theme": "मैत्र या अर्थी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सकाळ",
                "प्रभात",
                "प्रातः",
                "झुंजूमुंजू"
            ],
            "theme": "दिवसाची सुरुवात या अर्थी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दूधवाला",
                "गजर",
                "वर्तमानपत्र",
                "चहा"
            ],
            "theme": "दिवसाच्या सुरुवातीला होणाऱ्या गोष्टी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चूल",
                "फूल",
                "नमस्कार",
                "कुमार यादव"
            ],
            "theme": "सूर्य-- ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सलाते",
                "नेईशी",
                "चाचीचे",
                "तईआ"
            ],
            "theme": "विभक्ती प्रत्यय एकवचनी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सलानाते",
                "नीहीशी",
                "चेच्याची",
                "नो"
            ],
            "theme": "विभक्ती प्रत्यय अनेक वचनी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चूभूदेघे",
                "भापो",
                "ताक",
                "सनविवि"
            ],
            "theme": "मराठीतील संक्षिप्तरूपे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कै",
                "श्री",
                "सौ",
                "कु"
            ],
            "theme": "नावापुढील एकाक्षरी लघु रूपे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ढ",
                "तू",
                "व",
                "ऊ"
            ],
            "theme": "एकाक्षरी शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जा",
                "घे",
                "ये",
                "दे"
            ],
            "theme": "एकाक्षरी आज्ञारुपी क्रियापदे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "श्रीकांत",
                "साईना",
                "सिंधू",
                "लक्ष्य"
            ],
            "theme": "भारतीय बॅडमिंटनपटू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "श्रेयस",
                "ऋषभ",
                "संजू",
                "ऋतुराज"
            ],
            "theme": "तरुण क्रिकेटपटू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "स्वप्नील",
                "मनू",
                "अभिनव",
                "राज्यवर्धन"
            ],
            "theme": "पदक विजेते भारतीय नेमबाज ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दोन",
                "सतरा",
                "एकोणतीस",
                "त्र्याहत्तर"
            ],
            "theme": "मूळ संख्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "एक",
                "आठ",
                "सत्तावीस",
                "चौसष्ठ"
            ],
            "theme": "घन संख्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नऊ",
                "पंचवीस",
                "छत्तीस",
                "एक्क्यांशी"
            ],
            "theme": "वर्ग संख्या ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काच",
                "पाणी",
                "हवा",
                "तेल"
            ],
            "theme": "पारदर्शक पदार्थ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कोळसा",
                "केस",
                "कावळा",
                "डांबर"
            ],
            "theme": "काळ्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "√-१",
                "टाइम मशीन",
                "भूत",
                "शाश्वत गती यंत्र"
            ],
            "theme": "काल्पनिक गोष्टी (Imaginary) ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सतार",
                "मेंडोलिन",
                "सरोद",
                "इसराज"
            ],
            "theme": "तंतुवाद्ये ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तबला",
                "ढोलकी",
                "मृदुन्ग",
                "मादल"
            ],
            "theme": "ताल वाद्ये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बासरी",
                "क्लॅरॉनेट",
                "सनई",
                "हार्मोनियम"
            ],
            "theme": "वायू वाद्ये  ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नेहेरु",
                "गुजराल",
                "वाजपेयी",
                "मोदी"
            ],
            "theme": "पंतप्रधान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मुर्मू",
                "पाटील",
                "कलाम",
                "मुखर्जी"
            ],
            "theme": "राष्ट्रपती ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अंतुले",
                "नाईक",
                "कन्नमवार",
                "पवार"
            ],
            "theme": "महाराष्ट्र मुख्यमंत्री",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "होंडा",
                "टोयोटा",
                "मित्सुबिशी",
                "तोशिबा"
            ],
            "theme": "जपानी कंपन्या ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गूगल",
                "टेस्ला",
                "फोर्ड",
                "अमेझॉन"
            ],
            "theme": "अमेरिकन कंपन्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शेल",
                "व्होडाफोन",
                "बार्कले",
                "युनिलिव्हर"
            ],
            "theme": "ब्रिटिश कंपन्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आदिनाथ",
                "महावीर",
                "संभव",
                "सुपार्श्व"
            ],
            "theme": "जैन तीर्थांकर ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नानक",
                "तेगबहादूर",
                "गोविंद",
                "हरगोविंद"
            ],
            "theme": "शीख गुरु",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गोरख",
                "मच्छिन्द्र",
                "कानिफ",
                "ओंकार"
            ],
            "theme": "नाथ संप्रदायातील संत",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नकुल",
                "अर्जुन",
                "युधिष्ठीर",
                "भीम"
            ],
            "theme": "पांडव ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "राम",
                "लक्ष्मण",
                "भरत",
                "शत्रुघ्न"
            ],
            "theme": "दशरथ पुत्र   ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विकर्ण",
                "दुःशासन",
                "युयुत्सु",
                "दुर्योधन"
            ],
            "theme": "कौरव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पारिजात",
                "कामधेनू",
                "हलाहल",
                "अमृत"
            ],
            "theme": "समुद्रमंथनातील रत्ने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जास्वंद",
                "गुलाब",
                "कमळ",
                "चाफा"
            ],
            "theme": "झाडांवरील फुले",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जाई",
                "जुई",
                "मोगरा",
                "बोगनवेल"
            ],
            "theme": "वेलींवरील फुले",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्राण",
                "रणजीत",
                "अमजद",
                "प्रेम"
            ],
            "theme": "हिंदी चित्रपट खलनायक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पेंटल",
                "असरानी",
                "मेहमूद",
                "जगदीप"
            ],
            "theme": "हिंदी चित्रपट हास्य अभिनेता   ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "डेव्हिड",
                "अनुपम",
                "अशोक",
                "बलराज"
            ],
            "theme": "हिंदी चित्रपट चरित्र अभिनेता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पूर्वरंग",
                "अपूर्वाई",
                "व्यक्ती आणि वल्ली",
                "खोगीरभरती"
            ],
            "theme": "पुलं वाङ्मय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "विशाखा",
                "मारवा",
                "रसयात्रा",
                "नटसम्राट"
            ],
            "theme": "कुसुमाग्रज वाङ्मय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रक्तचंदन",
                "काजळमाया",
                "हिरवे रावे",
                "पिंगळा वेळ"
            ],
            "theme": "जी. ए. कुलकर्णी वाङ्मय ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बिंदू",
                "हेलन",
                "जयश्री टी",
                "कम्मो"
            ],
            "theme": "हिंदी चित्रपट नृत्यांगना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सुरैय्या",
                "सुलक्षणा",
                "सलमा",
                "परिणीती"
            ],
            "theme": "हिंदी चित्रपट अभिनेत्री गायिका",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शशिकला",
                "मनोरमा",
                "ललिता",
                "नादिरा"
            ],
            "theme": "हिंदी चित्रपट खलनायिका ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुरणपोळी",
                "पायस",
                "पंचामृत",
                "उकडीचे मोदक"
            ],
            "theme": "सणासुदीचे पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "हिंग",
                "दालचिनी",
                "लवंग",
                "तमालपत्र "
            ],
            "theme": "मसाले",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तुळस",
                "दुर्वा",
                "आघाडा ",
                "बेल"
            ],
            "theme": "पवित्र वनस्पती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गणपती",
                "नवरात्र",
                "दिवाळी",
                "होळी"
            ],
            "theme": "भारतीय सण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गाय",
                "बैल",
                "म्हैस",
                "शेळी"
            ],
            "theme": "पाळीव प्राणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कोल्हापूर",
                "नाशिक",
                "पुणे",
                "औरंगाबाद"
            ],
            "theme": "महाराष्ट्रातील शहरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाऊस",
                "वीज",
                "ढग",
                "गारपीट"
            ],
            "theme": "हवामानाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "छडी",
                "वर्ग",
                "शिक्षक",
                "घंटा"
            ],
            "theme": "शालेय जीवन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शिवाजी महाराज",
                "तानाजी",
                "बाजी प्रभू",
                "जिजामाता"
            ],
            "theme": "मराठा इतिहासातील व्यक्तिरेखा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छत्री",
                "रेनकोट",
                "बूट",
                "टोपी"
            ],
            "theme": "पावसात लागणाऱ्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पुस्तक",
                "वाचनालय",
                "वाचक",
                "पान"
            ],
            "theme": "वाचन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गजर",
                "काटा",
                "वाळू",
                "बारा"
            ],
            "theme": "घड्याळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इरसाल",
                "तासगाव",
                "औक्षण",
                "अदमास"
            ],
            "theme": "ज्या शब्दात कालवाचक शब्द दडला आले असे शब्द ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "इगतपुरी",
                "सुप्रभात",
                "आवरण",
                "कुडाळ"
            ],
            "theme": "ज्या शब्दात खायचे पदार्थ दडले आहेत असे शब्द ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कायम",
                "नादब्रह्म",
                "कृष्णधवल",
                "महेश्वरी"
            ],
            "theme": "देवाचे नाव लपलेले शब्द ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "इडली",
                "रझिया",
                "चालना",
                "पजामा"
            ],
            "theme": "मधले अक्षर बदललेली देशांची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "प्लाझ्मा",
                "स्मार्ट",
                "एल ई डी",
                "एच डी"
            ],
            "theme": "टीव्ही चे प्रकार ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "थांब",
                "पाच",
                "आशीर्वाद",
                "टाटा"
            ],
            "theme": "हाताचा पंजा दाखवणे याचे संभाव्य अर्थ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मीन",
                "कालवण",
                "काटा",
                "गळ"
            ],
            "theme": "माश्याशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अहम",
                "मदन",
                "नगर",
                "अगर"
            ],
            "theme": "अहमदनगर शब्दातील अक्षरे वापरून तयार होणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गल",
                "सर",
                "अल",
                "खल"
            ],
            "theme": "____बत ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भोभो",
                "म्याव",
                "डराव",
                "मेंमें"
            ],
            "theme": "प्राण्यांचे ओरडण्याचे आवाज",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भुंकणे",
                "आरवणे",
                "कूजन",
                "हंबरणे"
            ],
            "theme": "प्राणीपक्ष्यांच्या ओरडण्याला दिलेले नाव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चिवचिव",
                "कावकाव",
                "कुहूकुहू",
                "गुटर्गु"
            ],
            "theme": "पक्ष्यांचे ओरडण्याचे आवाज",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फौजदारी",
                "दिवाणी",
                "कौटुंबिक",
                "औद्योगिक"
            ],
            "theme": "न्यायालयातील खटल्याचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सर्वोच्च",
                "उच्च",
                "जिल्हा",
                "तलाठी/ग्राम"
            ],
            "theme": "न्यायालयाच्या श्रेणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "लिपिक",
                "साक्षीदार",
                "वकील",
                "न्यायाधीश"
            ],
            "theme": "न्यायालयातील व्यक्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाणीफवारा",
                "अशृधूर",
                "लाठीमार",
                "हवेत गोळीबार"
            ],
            "theme": "जमाव पांगवण्याच्या पद्धती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "काठी",
                "लाठी",
                "सोटा",
                "छडी"
            ],
            "theme": "लाकडी दांडू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दगडफेक",
                "नासधूस",
                "जाळणे",
                "दहशत"
            ],
            "theme": "दंगल",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धूर",
                "झुरका",
                "तंबाखू",
                "माचिस"
            ],
            "theme": "सिगारेट व्यसन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "स्क्रीन",
                "रील",
                "स्क्रोल",
                "जागरण"
            ],
            "theme": "मोबाईल व्यसन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पेग",
                "धुंद",
                "हँगओव्हर",
                "पुनर्वसन"
            ],
            "theme": "दारूचे व्यसन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चल",
                "स्मरण",
                "व्यंग",
                "छाया"
            ],
            "theme": "____चित्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बल",
                "धन",
                "गाडी",
                "नशीब"
            ],
            "theme": "___वान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भोज्जा",
                "शर्ट",
                "कावळा",
                "तोंड"
            ],
            "theme": "या गोष्टी शिवतात ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुबक ठेंगणी",
                "मधू मलुष्टे",
                "पुढारी",
                "मास्तर"
            ],
            "theme": "पुलंच्या म्हैस कथेतील पात्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ठाकूर",
                "इमाम साहेब",
                "कालिया",
                "जय"
            ],
            "theme": "शोले चित्रपटातील पात्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बसेसर राम",
                "लल्लू",
                "दादी",
                "भागवंतीं"
            ],
            "theme": "हम लोग मालिकेतही पात्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "य",
                "लय",
                "खूप",
                "अती"
            ],
            "theme": "भरपूर ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भारी",
                "छान",
                "मस्त",
                "वाह"
            ],
            "theme": "कौतुकाचे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रूप",
                "गम",
                "पूर",
                "अट"
            ],
            "theme": "शेवटी क लावल्यास नवीन अर्थाचा शब्द बनतो",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कुस्ती",
                "चेस",
                "पंजा लढवणे",
                "बॉक्सिंग"
            ],
            "theme": "२ जणांमध्ये खेळले जाणारे खेळ ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भाला",
                "गोळा",
                "थाळी",
                "हातोडा"
            ],
            "theme": "या गोष्टी फेकण्याच्या स्पर्धा होतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तोफ",
                "बासरी",
                "सिगारेट",
                "मुसळ"
            ],
            "theme": "दंडगोलाकार वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साक्ष",
                "पुरावा",
                "अटक",
                "कोठडी"
            ],
            "theme": "पोलीस आणि न्यायालय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चोरी",
                "खून",
                "दरोडा",
                "घरफोडी"
            ],
            "theme": "गंभीर गुन्हे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हवालदार",
                "फौजदार",
                "अधीक्षक",
                "महानिरीक्षक"
            ],
            "theme": "पोलिसांची श्रेणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कझाकस्तान",
                "टर्की",
                "रशिया",
                "इजिप्त"
            ],
            "theme": "दोन खंडांमध्ये असलेले देश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "स्पेन",
                "अर्जेंटिना",
                "मेक्सिको",
                "पनामा"
            ],
            "theme": "स्पॅनिश भाषिक देश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मादागास्कर",
                "श्रीलंका",
                "जपान",
                "मालदीव"
            ],
            "theme": "बेट असलेले देश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सिमेंट",
                "डांबर",
                "दुभाजक",
                "गतिरोधक"
            ],
            "theme": "रस्ता ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नकाशा",
                "शोध",
                "छायाचित्रे",
                "दिनदर्शिका"
            ],
            "theme": "गूगल प्रणाली (ॲप्स)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दिनांक",
                "सही",
                "रक्कम",
                "नाव"
            ],
            "theme": "धनादेशावरील माहिती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धनगर",
                "मेंढपाळ",
                "गुराखी",
                "गोप"
            ],
            "theme": "पशु पालन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दूध",
                "लोकर",
                "अंडी",
                "हस्तिदंत"
            ],
            "theme": "प्राण्यांपासून मिळणारे पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गोठा",
                "खुराडे",
                "कोंडवाडा",
                "तबेला"
            ],
            "theme": "प्राण्यांना ठेवण्याच्या जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चालुक्य",
                "राष्ट्रकुट",
                "सातवाहन",
                "यादव"
            ],
            "theme": "महाराष्ट्रातील राजवंश ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मगध",
                "अंग",
                "कोसला",
                "अवंती"
            ],
            "theme": "प्राचीन महाजनपदे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चोल",
                "पंड्या",
                "पल्लव",
                "होयसळ"
            ],
            "theme": "दक्षिण भारतातील राजवंश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पोस्को",
                "टाडा",
                "मोका",
                "आरटीआय"
            ],
            "theme": "काही कायद्यांची लघु रुपे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "आयएएफ",
                "बीआरएफ",
                "सीआरपीएफ",
                "रॉ"
            ],
            "theme": "सुरक्षा दलांच्या नावाची लघुरूपे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "डीएसपी",
                "डीआयजी",
                "पीएसआय",
                "एचसी"
            ],
            "theme": "पोलिस दलातील पदांची लघुरूपे ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दुर्वा",
                "मोदक",
                "आरती",
                "ढोल"
            ],
            "theme": "गणपतीशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "साबुदाणा",
                "वरई",
                "रताळे",
                "काकडी"
            ],
            "theme": "उपवास संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पन्हे",
                "लोणचे",
                "आमरस",
                "आम्रखंड"
            ],
            "theme": "आंबा संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कापूस",
                "रॉकेल",
                "लाकडाचा भुसा",
                "फटाके"
            ],
            "theme": "ज्वालाग्राही पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "साखर",
                "मीठ",
                "व्हिनेगर",
                "कार्बन डाय ऑक्साईड"
            ],
            "theme": "पाण्यात विरघळणारी द्रव्ये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "लवंगी",
                "सुतळी",
                "चमनचिडी",
                "आपटबार"
            ],
            "theme": "फटाक्यांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेघ",
                "गडगडाट",
                "वीज",
                "मुसळधार"
            ],
            "theme": "पाऊस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मीनल",
                "मकरंद",
                "नरसिंह",
                "सुकन्या"
            ],
            "theme": "राशींची नावे लपलेली नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वसंत",
                "हेमंत",
                "शरद",
                "शिशिर"
            ],
            "theme": "ऋतू ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आग",
                "रामेश्वर",
                "बंब",
                "सोमेश्वर"
            ],
            "theme": "एक म्हण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रात्र",
                "थोडी",
                "सोंगं",
                "फार"
            ],
            "theme": "अजून एक म्हण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आंधळा",
                "डोळा",
                "देव",
                "दोन"
            ],
            "theme": "ही पण एक म्हण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्रिकेट कसोटी",
                "विंबल्डन",
                "शोकसभा",
                "होली"
            ],
            "theme": "यासाठी लोक पांढरे कपडे घालतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रांगोळी",
                "फटाके",
                "आकाशकंदील",
                "दिवे"
            ],
            "theme": "दिवाळीशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भात",
                "आमटी ",
                "पोळी",
                "भाजी"
            ],
            "theme": "दैनंदिन आहार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आंबा",
                "सफरचंद",
                "केळं",
                "डाळिंब"
            ],
            "theme": "फळे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सायकल",
                "गाडी",
                "बस",
                "ट्रक"
            ],
            "theme": "वाहनप्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मराठी",
                "हिंदी",
                "इंग्रजी",
                "संस्कृत"
            ],
            "theme": "भाषा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अक्राळविक्राळ",
                "भयानक",
                "क्रूर",
                "अवाढव्य"
            ],
            "theme": "राक्षसाची विशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "प्रतापी",
                "न्यायप्रिय",
                "प्रजावत्सल",
                "चक्रवर्ती"
            ],
            "theme": "राजाची विशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सज्जन",
                "प्रामाणिक",
                "सूज्ञ",
                "कष्टाळू"
            ],
            "theme": "सभ्य माणसाची विशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "निशा",
                "यामिनी",
                "रजनी",
                "विभावरी"
            ],
            "theme": "रात्र समानार्थी शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वर्षा",
                "वृष्टी",
                "पर्जन्य",
                "जलधारा"
            ],
            "theme": "पाऊस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वसुधा",
                "भूमी",
                "धरा",
                "अवनी"
            ],
            "theme": "पृथ्वी तत्त्व",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भिंग",
                "दुर्बीण",
                "शोभादर्शक",
                "सूक्ष्मदर्शक"
            ],
            "theme": "वेगळे दृश्य दाखवणाऱ्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दूरदर्शन",
                "आकाशवाणी",
                "वृत्तपत्रे",
                "इंटरनेट"
            ],
            "theme": "प्रसारमाध्यमे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वीट",
                "मडके",
                "पिझ्झा",
                "देशी दारू"
            ],
            "theme": "भट्टी मधे बनणाऱ्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भाव",
                "भात",
                "वेळ",
                "हवा"
            ],
            "theme": "या गोष्टी खातात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मूग",
                "राग",
                "औषधाची गोळी",
                "पाणी"
            ],
            "theme": "या गोष्टी गिळतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "थाप",
                "बंदुकीची गोळी",
                "टोमणा",
                "लाथ"
            ],
            "theme": "या गोष्टी मारतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झाडू",
                "कचरापेटी",
                "पुनर्वापर (Recycle)",
                "निर्जंतुक"
            ],
            "theme": "स्वच्छता या विषयाशी संबंधित शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "साबण",
                "शॅम्पू",
                "टॉवेल",
                "बादली"
            ],
            "theme": "अंघोळ विषयी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "केस",
                "भांडी",
                "कपडे",
                "फरशी"
            ],
            "theme": "पाणी आणि साबणाचे वापर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सागर",
                "नदी",
                "तलाव",
                "विहीर"
            ],
            "theme": "पाण्याचे स्रोत",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पेन",
                "पेन्सिल",
                "खोडरबर",
                "कोनमापक"
            ],
            "theme": "शालेय साहित्य",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चहा",
                "कॉफी",
                "दूध",
                "सरबत"
            ],
            "theme": "पेय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झोप",
                "भूक",
                "श्वास",
                "तहान"
            ],
            "theme": "मूलभूत गरजा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नाटक",
                "स्फुटलेखन",
                "कविता",
                "कथा"
            ],
            "theme": "साहित्य प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कृष्णविवर",
                "ग्रह",
                "चंद्र",
                "आकाशगंगा"
            ],
            "theme": "अंतरिक्षाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लोकमत",
                "सकाळ",
                "लोकसत्ता",
                "पुढारी"
            ],
            "theme": "मराठी वर्तमानपत्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "एबीपी माझा",
                "साम",
                "स्टार प्रवाह",
                "सह्याद्री"
            ],
            "theme": "मराठी वाहिन्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भाडीपा",
                "मित्र म्हणे",
                "अमुक तमुक",
                "मधुरा रेसिपीज"
            ],
            "theme": "मराठी युट्युब चॅनेल",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मामा",
                "मामेबहीण",
                "मावसभाऊ",
                "मावशी"
            ],
            "theme": "मातुल (आईच्या बाजूचे) नातेवाईक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चुलता",
                "आत्तेभाऊ",
                "काकू",
                "आत्या"
            ],
            "theme": "वडलांच्या बाजूचे नातेवाईक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दीर",
                "नणंद",
                "सासू",
                "जाऊ"
            ],
            "theme": "पतीच्या बाजूचे नातेवाईक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वातानुकूलक",
                "आंबा",
                "सुट्ट्या",
                "घाम"
            ],
            "theme": "उन्हाळा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "धुके",
                "सण",
                "हातमोजे",
                "शेकोटी"
            ],
            "theme": "थंडी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चिखल",
                "छत्री",
                "बेडूक",
                "ढग"
            ],
            "theme": "पावसाळा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लता",
                "आशा",
                "उषा",
                "मीना"
            ],
            "theme": "मंगेशकर भगिनी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शिंपी",
                "सुतार",
                "लोहार",
                "गवंडी"
            ],
            "theme": "कारागीर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पोहणे",
                "सायकल",
                "धावणे",
                "उड्या मारणे "
            ],
            "theme": "व्यायाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकाश",
                "धरती",
                "पाणी",
                "वारा"
            ],
            "theme": "निसर्ग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "टोमॅटो",
                "कांदा",
                "वांगी",
                "कारलं"
            ],
            "theme": "भाजीपाला",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शिवणकाम",
                "भरतकाम",
                "चित्रकला",
                "ओरिगामी"
            ],
            "theme": "हस्तकला",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्वाभीमान",
                "निरामय",
                "मुळाक्षरे",
                "संतापी"
            ],
            "theme": "नद्यांची नावे लपलेले शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चंद्र",
                "मेला",
                "विराम",
                "वट"
            ],
            "theme": "अर्ध____",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हार",
                "चादर",
                "मेणबत्ती",
                "नैवेद्य"
            ],
            "theme": "विविध धर्मातील देवाला वाहायच्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाडी",
                "सत्व",
                "वधू",
                "चाचणी"
            ],
            "theme": "____परीक्षा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वमन",
                "विरेचन",
                "बस्ती",
                "नस्य"
            ],
            "theme": "आयुर्वेदिक पंचकर्म",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चूर्ण",
                "तेल",
                "गोळी",
                "मलम"
            ],
            "theme": "औषधांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंबा",
                "अदा",
                "अडवा",
                "कला"
            ],
            "theme": "शेवटी नी लावल्यास आडनाव बनते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "थांबा",
                "स्थानक",
                "वाहक",
                "चालक"
            ],
            "theme": "बस शी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ठेला",
                "देठ",
                "पिंक",
                "मसाला"
            ],
            "theme": "पानाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "श्वेत",
                "धवल",
                "शुभ्र",
                "उजळ"
            ],
            "theme": "पांढरा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जन्म",
                "भेट",
                "वसन",
                "विवाह"
            ],
            "theme": "पुनर् ____",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "उपाय",
                "गोमुख",
                "सुकर",
                "खतरनाक"
            ],
            "theme": "अवयव लपलेले शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पापण्या",
                "भुवया",
                "मिशा",
                "दाढी"
            ],
            "theme": "केस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कात्री",
                "वस्तरा",
                "कंगवा",
                "ब्लेड"
            ],
            "theme": "केश कर्तनालय साधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वेणी",
                "साधनाकट",
                "खोपा",
                "अंबाडा"
            ],
            "theme": "केशरचना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अणु",
                "शीत",
                "महा",
                "मल्ल"
            ],
            "theme": "___युद्ध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गरम",
                "पावभाजी",
                "काळा",
                "पान"
            ],
            "theme": "___मसाला",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "लघु",
                "उप",
                "अनु",
                "पूर्व"
            ],
            "theme": "_____ग्रह",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चॉप",
                "रबर",
                "टेबल",
                "स्पिन"
            ],
            "theme": "टेबल टेनिस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "स्मॅश",
                "ड्रॉप",
                "टॉस",
                "पदलालित्य(foot work)"
            ],
            "theme": "बॅडमिंटन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "स्विंग",
                "ड्राइव्ह",
                "झेल (catch)",
                "रन"
            ],
            "theme": "क्रिकेट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विमा",
                "समभाग",
                "जमीन",
                "सोने"
            ],
            "theme": "गुंतवणूक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सूर्य",
                "वारा",
                "कोळसा",
                "धरण"
            ],
            "theme": "यापासून वीज निर्मिती करतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आकाश",
                "साधू",
                "संत",
                "अन"
            ],
            "theme": "____वाणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "परीघ",
                "कोन",
                "त्रिज्या",
                "कर्ण"
            ],
            "theme": "भूमितीय संज्ञा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कृपाचार्य",
                "व्यास",
                "अश्वत्थामा",
                "बली"
            ],
            "theme": "चिरंजीव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विश्वामित्र",
                "वसिष्ठ",
                "वाल्मिकी",
                "गौतम"
            ],
            "theme": "रामायणातील साधू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कोलाहल",
                "पूजा",
                "चूक",
                "धुडगूस"
            ],
            "theme": "गोंधळ या शब्दाचे संभाव्य अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अर्घ्य",
                "कन्या",
                "अन्न",
                "रक्त"
            ],
            "theme": "____दान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दिवा",
                "फुलं",
                "घंटा",
                "पोथी"
            ],
            "theme": "देवघरातील वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चुना",
                "केशर",
                "वेलदोडा",
                "लवंग"
            ],
            "theme": "पानात वापरण्याचे पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पिलू",
                "भूप",
                "अडाणा",
                "चारुकेशी"
            ],
            "theme": "राग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शर्मिष्ठा",
                "कच",
                "देवयानी",
                "शुक्राचार्य"
            ],
            "theme": "ययाती कादंबरीतली पात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तार",
                "सांडणीस्वार",
                "कबुतर",
                "आंतरजाल"
            ],
            "theme": "संदेश पाठवण्याची माध्यमे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भूर्जपत्र",
                "कागद",
                "फलक",
                "संगणक"
            ],
            "theme": "यावर संदेश लिहितात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "टाक",
                "झरणी",
                "टंकलेखनयंत्र",
                "तर्जनी"
            ],
            "theme": "या आधारे संदेश लिहितात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बालाजी",
                "बद्रीनाथ",
                "जगन्नाथ",
                "द्वारकाधीश"
            ],
            "theme": "भगवान विष्णू ची रूपे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मल्लिकार्जुन",
                "सोमनाथ",
                "केदारनाथ",
                "महाकालेश्वर"
            ],
            "theme": "भगवान शंकराची रूपे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बल्लाळेश्वर",
                "मोरेश्वर",
                "चिंतामणी",
                "गिरिजात्मज"
            ],
            "theme": "गणपती ची रूपे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "महान",
                "संत",
                "दयाळू",
                "उदार"
            ],
            "theme": "उत्तम व्यक्ती वैशिष्टये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "धूर्त",
                "महत्त्वाकांक्षी",
                "कंजूष",
                "अधीर"
            ],
            "theme": "मध्यम व्यक्ति वैशिष्टये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "क्रूर",
                "कपटी",
                "दुष्ट",
                "नराधम"
            ],
            "theme": "नीचतम व्यक्ति वैशिष्टये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रक्तवाहिनी",
                "बलरामपत्नी",
                "नक्षत्र",
                "हट्टंगडी"
            ],
            "theme": "रोहिणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "संगमा",
                "जाखड",
                "जोशी",
                "महाजन"
            ],
            "theme": "लोकसभा अध्यक्ष",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "संत",
                "शेळके",
                "चौधरी",
                "गोळे"
            ],
            "theme": "मराठी कवयित्री",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुरण",
                "गुळ",
                "आंबा",
                "खवा"
            ],
            "theme": "____ पोळी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दारू",
                "शेअर बाजार",
                "रक्तदाब",
                "गिर्यारोहक"
            ],
            "theme": "या गोष्टी चढतात उतरतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चंद्र",
                "काजू",
                "केळी",
                "अंतर्वक्र आरसा"
            ],
            "theme": "अर्ध वक्र आकाराच्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठिय्या",
                "लाच",
                "मान",
                "लक्ष"
            ],
            "theme": "... देणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रुबाब",
                "आरसा",
                "आस्मान",
                "दिवसा तारे"
            ],
            "theme": "... दाखवणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "उपास",
                "विचार",
                "सही",
                "भांडण"
            ],
            "theme": "... करणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ऑलिम्पिक",
                "एशियन",
                "स्क्विड",
                "कॉमनवेल्थ"
            ],
            "theme": "गेम्स",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शार्क",
                "स्विमिंग",
                "वॉटर",
                "फ्युएल"
            ],
            "theme": "टँक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ब्ल्यू व्हेल",
                "पोकेमॉन",
                "पब्जी",
                "इम्पॉस्टर"
            ],
            "theme": "मोबाईल गेम्स",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बोटे",
                "ज्ञानेंद्रिय",
                "महासागर",
                "तारामासा (स्टारफिश)"
            ],
            "theme": "पाच(५)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ज्योतिर्लिंग",
                "एकताल",
                "डझन",
                "इंच"
            ],
            "theme": "बारा(१२)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "स्वर",
                "आश्चर्य",
                "आठवडा",
                "रूपक ताल"
            ],
            "theme": "सात(७)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मोजा",
                "म्यान",
                "आभरा",
                "पापण्या"
            ],
            "theme": "आवरण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कुबडी",
                "पांगुळगाडा",
                "टेकू",
                "अनाथालय/वृद्धाश्रम"
            ],
            "theme": "आधार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तलवार",
                "भाला",
                "बाण",
                "गदा"
            ],
            "theme": "शस्त्रास्त्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सिंह",
                "वाघ",
                "गेंडा",
                "हत्ती"
            ],
            "theme": "जंगली प्राणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मोबाईल",
                "लॅपटॉप",
                "टॅब्लेट",
                "टीव्ही"
            ],
            "theme": "इलेक्ट्रॉनिक साधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "फुटबॉल",
                "क्रिकेट",
                "कबड्डी",
                "हॉकी"
            ],
            "theme": "खेळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ढोल",
                "ताशा",
                "डीजे",
                "गर्दी"
            ],
            "theme": "गणपती मिरवणूक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "टाळ्या",
                "झांजा",
                "पाठांतर",
                "सामूहिक उच्चारण"
            ],
            "theme": "गणपती आरती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शाडू",
                "पेण",
                "साचा",
                "सुबक"
            ],
            "theme": "गणेश मूर्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ओ पी",
                "एस डी",
                "आर डी",
                "ए आर"
            ],
            "theme": "हिंदी संगीतकारांची अद्याक्षरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "केके",
                "मुकेश",
                "मन्नाडे",
                "के एल सैगल"
            ],
            "theme": "हिंदी गायक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आर के",
                "बी आर",
                "प्रभात",
                "बॉंबे टॉकीज"
            ],
            "theme": "जुन्या हिंदी चित्रपट निर्मिती संस्था",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चक्रीवादळ",
                "भूकंप",
                "वणवा",
                "सुनामी"
            ],
            "theme": "नैसर्गिक आपत्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वाटमारी",
                "दरोडा",
                "खून",
                "दंगल"
            ],
            "theme": "मानवनिर्मित आपत्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "टोळधाड",
                "कुत्रा चावणे",
                "प्लेगची साथ",
                "शार्क हल्ला"
            ],
            "theme": "प्राणी/सूक्ष्मजीव निर्मित आपत्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कर्तरी",
                "रसायनशास्त्र",
                "नाटक",
                "भावे"
            ],
            "theme": "प्रयोग (भाषा आणि इतर)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "श्लेष",
                "यमक",
                "सरगम",
                "मोहनमाळ"
            ],
            "theme": "अलंकार (भाषा आणि इतर)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "द्वंद्व",
                "तत्पुरुष",
                "बहुव्रीही",
                "अव्ययीभाव"
            ],
            "theme": "मराठी समास",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हिवाळा",
                "पावसाळा",
                "उन्हाळा",
                "शरद"
            ],
            "theme": "ऋतू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "हात",
                "पाय",
                "डोळे",
                "कान"
            ],
            "theme": "शरीराचे अवयव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पराठा",
                "इडली",
                "डोसा",
                "उपमा"
            ],
            "theme": "नाश्ता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नवरा",
                "आशिर्वाद",
                "अजून/जास्तीचे",
                "उंच"
            ],
            "theme": "वर या शब्दाचे अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कचरा",
                "पाणी",
                "रस्ता",
                "दिवे"
            ],
            "theme": "नगरपालिकेची कामे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कुंडी",
                "माठ",
                "पणती",
                "विटा"
            ],
            "theme": "माती पासून बनलेल्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उत्पत्ती",
                "उगम",
                "आरंभ",
                "महाविस्फोट"
            ],
            "theme": "सुरुवात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शेवट",
                "अंतिम",
                "निकाल",
                "पराकाष्ठा"
            ],
            "theme": "समाप्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पर्यवेक्षक",
                "पुरवणी",
                "मौखिक",
                "मूल्यांकन"
            ],
            "theme": "परीक्षा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बोर",
                "मोहन",
                "जप",
                "तुळशी"
            ],
            "theme": "____माळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पाऊले",
                "झोप",
                "अंतर",
                "ठोके"
            ],
            "theme": "स्मार्ट वॉच या गोष्टी मोजते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सुरावट",
                "वर्तन",
                "रीत",
                "डाव"
            ],
            "theme": "चाल या शब्दाचे विविध अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंग",
                "क्षेत्र",
                "संस्कृती",
                "सुरक्षा"
            ],
            "theme": "_____रक्षक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गाव",
                "गड",
                "माळ",
                "कष्ट"
            ],
            "theme": "_____करी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गढी",
                "हवेली",
                "वाडा",
                "कोठी"
            ],
            "theme": "जुन्या काळातील मोठी घरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मनगट",
                "गुडघा",
                "खांदा",
                "कोपर"
            ],
            "theme": "सांधे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जीभ",
                "दंड",
                "मांडी",
                "पोटरी"
            ],
            "theme": "स्नायू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "डोळा",
                "त्वचा",
                "नाक",
                "कान"
            ],
            "theme": "ज्ञानेंद्रिय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कर्ज",
                "ठेव",
                "बचत",
                "चालू"
            ],
            "theme": "बँकेतील खात्याचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वाहन",
                "वैयक्तिक",
                "घर",
                "शिक्षण"
            ],
            "theme": "कर्जाचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हप्ता",
                "दर",
                "मुदत",
                "तारण"
            ],
            "theme": "कर्जाची परिमाणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वार",
                "दिनांक",
                "मथळा",
                "बातमी"
            ],
            "theme": "वर्तमानपत्राच्या मुख्य पानावरील गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "घेवडा",
                "बाळ",
                "सरी",
                "मास"
            ],
            "theme": "श्रावण_____",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आमटी",
                "रहस्य",
                "तात्पर्य",
                "सरकव"
            ],
            "theme": "सार या शब्दाचे संभाव्य अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धावपट्टी",
                "उड्डाण",
                "डिजियात्रा",
                "चेकिन"
            ],
            "theme": "विमान प्रवास",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "स्टेशन",
                "रूळ",
                "बर्थ",
                "बोगदे"
            ],
            "theme": "रेल्वे प्रवास ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "टायर",
                "लाल परी",
                "घाट",
                "चालक"
            ],
            "theme": "रस्त्याने प्रवास ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झोप",
                "मृत्यू",
                "विचार",
                "ध्यान"
            ],
            "theme": "एकट्याच्या क्रिया/उपक्रम ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पिकनिक",
                "क्रिकेट",
                "संमेलन",
                "सभा"
            ],
            "theme": "समूहाच्या क्रिया/उपक्रम  ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बुद्धिबळ",
                "लग्न",
                "हस्तांदोलन",
                "द्वंद्वगीत"
            ],
            "theme": "दोन माणसांच्या क्रिया/उपक्रम ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घोडा",
                "गाढव",
                "उंट",
                "झेब्रा"
            ],
            "theme": "चार पायांचे प्राणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रेडिओ",
                "टेलिव्हिजन",
                "वर्तमानपत्र",
                "इंटरनेट"
            ],
            "theme": "माहितीचे स्रोत",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बालगीत",
                "गोष्टी",
                "फुगे",
                "खेळणी"
            ],
            "theme": "बालपणाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "व्याघ्रम्भर",
                "लवथवती",
                "कुरवंड्या",
                "फणिवरबंधना"
            ],
            "theme": "विविध आरत्यांमधील शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पाताळदेवताहंता",
                "काळरुद्राग्नी",
                "मंद्राद्रीसारिखा",
                "भूतप्रेतसमंधादी"
            ],
            "theme": "मारुतीस्तोत्रातील शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जानकीलक्षणोपेताम्",
                "द्रष्टुमपि शक्तास्ते",
                "चापबाण धरो",
                "विप्रप्रियम्"
            ],
            "theme": "रामरक्षेतील शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आंबा",
                "लायकी",
                "स्तर",
                "शिडी"
            ],
            "theme": "पायरी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लकाकी",
                "वेदना",
                "धमक",
                "तेज"
            ],
            "theme": "चमक या शब्दाचे विविध अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शिक्का",
                "चेहरा",
                "नाणी",
                "हावभाव"
            ],
            "theme": "मुद्रा या शब्दाचे विविध अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाळणा",
                "दूध",
                "अंगाई",
                "रांगणे"
            ],
            "theme": "बालपण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पहिलं प्रेम",
                "महाविद्यालय",
                "नोकरी",
                "स्वप्न"
            ],
            "theme": "तारुण्य",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आठवणी",
                "नातवंड",
                "निवृत्ती",
                "चष्मा"
            ],
            "theme": "वार्धक्य",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पद्मश्री",
                "ज्ञानपीठ",
                "साहित्य अकादमी",
                "पद्मभूषण"
            ],
            "theme": "भारतीय नागरी सन्मान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "परमवीर",
                "शौर्य",
                "कीर्ती",
                "वीर"
            ],
            "theme": "__चक्र - सैन्य दलातील सन्मान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नोबेल",
                "मॅगसेसे",
                "पुलित्झर",
                "ऑस्कर"
            ],
            "theme": "आंतरराष्ट्रीय पारितोषिके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "किलबिल",
                "ढोल",
                "संगीत",
                "भरणे"
            ],
            "theme": "कानाचे अनुभव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दीपणे",
                "रंग",
                "प्रतिबिंब",
                "चित्र"
            ],
            "theme": "डोळ्याचे अनुभव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "श्वास",
                "कांदे सोलणे",
                "अत्तर",
                "सर्दी"
            ],
            "theme": "नाकासंबंधी अनुभव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वार",
                "घटिका",
                "सन",
                "तिथी"
            ],
            "theme": "दिन/समय दर्शक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कार",
                "वंत",
                "कृती",
                "कंद"
            ],
            "theme": "कला---",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दार",
                "चोरवाट",
                "भुयार",
                "खिडकी"
            ],
            "theme": "प्रवेश मार्ग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पंचम",
                "षड्ज",
                "गंधार",
                "धैवत"
            ],
            "theme": "संगीत स्वर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ललित",
                "भिन्न षड्ज",
                "छायानट",
                "पिलू"
            ],
            "theme": "संगीत राग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "एक",
                "खेमटा",
                "झप",
                "भजनी"
            ],
            "theme": "संगीत ताल",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अश्रूंची झाली",
                "प्रेमाच्या गावा",
                "रायगडाला जेंव्हा",
                "प्रेमा तुझा"
            ],
            "theme": "वसंत कानेटकर नाटके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दुरितांचे तिमिर",
                "देव दीनाघरी",
                "वाहतो ही",
                "सीमेवरून परत"
            ],
            "theme": "बाळ कोल्हटकर नाटके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शांतता कोर्ट",
                "अशी पाखरे",
                "घाशीराम",
                "सखाराम"
            ],
            "theme": "विजय तेंडुलकर नाटके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अवतार",
                "दिशा",
                "बोटे",
                "दसरा"
            ],
            "theme": "दहा/दश ___",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गुण",
                "काळ",
                "दोष",
                "देव"
            ],
            "theme": "तीन/त्रि ___",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विनायक",
                "प्रहर",
                "योग",
                "पैलू"
            ],
            "theme": "आठ/अष्ट/अष्टांग ___",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विधिलिखित",
                "दैव",
                "प्राक्तन",
                "प्रारब्ध"
            ],
            "theme": "नशीब",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "परिणाम",
                "फळ",
                "निकाल",
                "निष्पत्ती"
            ],
            "theme": "अखेरीस जे मिळते/घडते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मनसुबा",
                "इच्छा",
                "इरादा",
                "उद्दिष्ट"
            ],
            "theme": "हेतू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मराठी",
                "हिंदी",
                "संस्कृत",
                "नेपाळी"
            ],
            "theme": "देवनागरी लिपी वापरणाऱ्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "देवनागरी",
                "रोमन",
                "अरबी",
                "कांजी"
            ],
            "theme": "विविध लिप्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "लॅटिन",
                "प्राकृत",
                "पाली",
                "अर्धमागधी"
            ],
            "theme": "लुप्त (आता वापरात नसलेल्या) भाषा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धडधड",
                "पत्र",
                "नजरानजर",
                "ओढ"
            ],
            "theme": "पाहिलं प्रेम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वधू",
                "मंडप",
                "सप्तपदी",
                "संसार"
            ],
            "theme": "लग्न",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विभक्त",
                "न्यायालय",
                "पालकत्व",
                "पोटगी"
            ],
            "theme": "घटस्फोट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बद्धकोष्ठ",
                "आम्लपित्त",
                "अपचन",
                "आमांश(डिसेंट्री)"
            ],
            "theme": "पोटाचे आजार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रक्तदाब",
                "मधुमेह",
                "डोकेदुखी(मायग्रेन)",
                "लठ्ठपणा"
            ],
            "theme": "जीवनशैलीचे आजार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "क्षय",
                "धनुर्वात",
                "कॉलरा",
                "कुष्ठरोग"
            ],
            "theme": "जंतुजन्य आजार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "किसणी",
                "सुरी",
                "विळी",
                "कातणं"
            ],
            "theme": "स्वयंपाक घर - कापण्याची अवजारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कुकर",
                "तवा",
                "कढई",
                "लंगरी"
            ],
            "theme": "स्वयंपाकघर - पदार्थ गरम करण्यासाठी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "डाव",
                "झारी",
                "चिमटा",
                "लाटणं"
            ],
            "theme": "स्वयंपाक घर लांबट अवजारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "टाळाटाळ",
                "दिरंगाई",
                "आळस",
                "कंटाळा"
            ],
            "theme": "चालढकल/procrastination",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्य",
                "ध्यास",
                "महत्वाकांक्षा",
                "संकल्प"
            ],
            "theme": "ध्येय/goal",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भिंग",
                "तन्मयता",
                "व्यग्रतामुक्तता",
                "निग्रह"
            ],
            "theme": "एकाग्रता/focus",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रामन",
                "मॅक्सवेल",
                "आईन्स्टाईन",
                "गॅलिलिओ"
            ],
            "theme": "प्रसिद्द भौतिक शास्त्र वैज्ञानिक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मेरी क्युरी",
                "लावासिये",
                "मेंडेलिव्ह",
                "प्रफुल्लचंद्र रे"
            ],
            "theme": "प्रसिद्द रसायनशास्त्र शास्त्र वैज्ञानिक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "युक्लिड",
                "युलर",
                "रामानुजन",
                "लाप्लास"
            ],
            "theme": "प्रसिद्ध गणितज्ञ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मंडाले",
                "एस. एन. गोएंका",
                "हेलन",
                "पांढरे हत्ती"
            ],
            "theme": "ब्रह्मदेश (म्यानमार)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मलमल",
                "रुना लैला",
                "डॉ. महम्मद युनूस",
                "ब्रह्मपुत्रेचे पूर"
            ],
            "theme": "बांगलादेश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ऋण कर्बभार(कार्बन फूटप्रिंट)",
                "राष्ट्रीय आनंद निर्देशांक(GHI)",
                "थिंफू",
                "दोचुला खिंड"
            ],
            "theme": "भूतान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिहार",
                "अंदमान",
                "ग्वाटेमाला बे",
                "मंडाले"
            ],
            "theme": "तुरुंग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अहमदाबाद",
                "कलकत्ता",
                "बंगलोर",
                "लखनौ"
            ],
            "theme": "IIM संस्था शहरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मुंबई",
                "खड्गपूर",
                "दिल्ली",
                "चेन्नई"
            ],
            "theme": "IIT संस्था शहरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घेराव",
                "मोर्चा",
                "संप",
                "निदर्शने"
            ],
            "theme": "सामूहिक निषेध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "खड्डे",
                "बेशिस्त चालक",
                "मिरवणूक",
                "सिग्नल बिघाड"
            ],
            "theme": "ट्रॅफिक जॅम ची करणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सायकल रिक्षा",
                "टांगा",
                "डोली",
                "व्हील चेअर"
            ],
            "theme": "स्वयंचलित नसलेली वाहने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लघुकोन",
                "बर्मुडा",
                "प्रेमाचा ___",
                "१८० अंश"
            ],
            "theme": "त्रिकोण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "समलंब",
                "ते __ कुटुंब",
                "पतंगाकृती",
                "सुवर्ण महामार्ग प्रकल्प"
            ],
            "theme": "चौकोन/चौकोनी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पिरॅमिड",
                "नाईल",
                "क्लिओपात्रा",
                "कैरो"
            ],
            "theme": "इजिप्त",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गण",
                "वर्ण",
                "योनी",
                "नाड"
            ],
            "theme": "पत्रिकेतील गुणमिलन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ओव्या",
                "अभंग",
                "श्लोक",
                "आर्या"
            ],
            "theme": "काव्य रचनेचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मघई",
                "बनारसी",
                "बंगला",
                "कपुरी"
            ],
            "theme": "विड्याची पाने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "बीळ",
                "वारूळ",
                "ढोली",
                "पोळं"
            ],
            "theme": "पक्षी/प्राणी/कीटक घरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गजेंद्र",
                "ऐरावत",
                "अश्वत्थामा",
                "जम्बो"
            ],
            "theme": "हत्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वासरू",
                "कोकरू",
                "बछडा",
                "रेडकू"
            ],
            "theme": "जनावरांची पिल्ले",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कळस",
                "माथा",
                "शिखर",
                "शेंडा"
            ],
            "theme": "उंची वरचा भाग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कडाप्पा",
                "ग्रॅनाईट",
                "संगमरवर",
                "कोटा"
            ],
            "theme": "थर असलेले दगड",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शब्दवेधी",
                "वाक्",
                "मदन",
                "हवा"
            ],
            "theme": "बाण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "एकेरी",
                "दुहेरी",
                "चक्राकार",
                "भुयारी"
            ],
            "theme": "वाहतुकीचे रस्ते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सहाण",
                "साळीच्या लाह्या",
                "मुंडावळी",
                "होमकुंड"
            ],
            "theme": "लग्नविधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भरतनाट्यम",
                "मोहिनीअट्टम",
                "कत्थक",
                "ओडिसी"
            ],
            "theme": "नृत्यप्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दौलत",
                "चक्र",
                "पार्टनर",
                "गारंबीचा बापू"
            ],
            "theme": "प्रसिद्ध कादंबऱ्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तर्जनी",
                "अनामिका",
                "करंगळी",
                "अंगठा"
            ],
            "theme": "बोटांची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रजनी",
                "यामिनी",
                "शर्वरी",
                "निशा"
            ],
            "theme": "रात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अश्विनी",
                "भरणी",
                "कृतिका",
                "रोहिणी"
            ],
            "theme": "नक्षत्रं",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कविता",
                "शायरी",
                "दोहे",
                "अभंग"
            ],
            "theme": "काव्य प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बायो",
                "केमिस्ट्री",
                "फिजिक्स",
                "गणित"
            ],
            "theme": "शालेय विषय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झेंडा",
                "राष्ट्रगीत",
                "संविधान",
                "स्वातंत्र्य"
            ],
            "theme": "देशप्रेम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मामा",
                "काका",
                "आजोबा",
                "चुलता"
            ],
            "theme": "नातेसंबंध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "उषःकाल",
                "सकाळ",
                "दुपार",
                "संध्याकाळ"
            ],
            "theme": "दिवसाचे भाग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काजू",
                "बदाम",
                "अक्रोड",
                "मनुका"
            ],
            "theme": "सुकामेवा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "घर",
                "बंगला",
                "अपार्टमेंट",
                "झोपडी"
            ],
            "theme": "निवास",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रस्ता",
                "पूल",
                "महामार्ग",
                "चौक"
            ],
            "theme": "वाहतूक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दिनांक",
                "महापौर",
                "केशकर्तनालय",
                "अद्ययावत"
            ],
            "theme": "स्वा. सावरकरांनी मराठी भाषेला दिलेले शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नगरपालिका",
                "ग्रामपंचायत",
                "महानगरपालिका",
                "छावणी मंडळ"
            ],
            "theme": "स्थानिक नियामक मंडळे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "लाडकी बहिण",
                "प्रधानमंत्री आवास",
                "जनधन",
                "आयुष्मान भारत"
            ],
            "theme": "सरकारी योजना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "देवनागरी",
                "चित्र",
                "ब्रेल",
                "ब्राह्मी"
            ],
            "theme": "लिपी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बोधी",
                "वट",
                "अजान",
                "देवदार"
            ],
            "theme": "दीर्घायु वृक्षांची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अभ्रक",
                "सोने",
                "गंधक",
                "कोळसा"
            ],
            "theme": "खाणीतून मिळणारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मणका",
                "खुबा",
                "मनगट",
                "माकड"
            ],
            "theme": "हाड/सांधे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "किराणा",
                "जयपूर",
                "मेवाती",
                "पतियाळा"
            ],
            "theme": "शास्त्रीय संगीत घराणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "यामिनी",
                "शर्वरी",
                "निशा",
                "रजनी"
            ],
            "theme": "रात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मरिना",
                "कलंगुट",
                "हंसा",
                "दोनापावला"
            ],
            "theme": "गोव्यातील बीच",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कुंभार्ली",
                "नाणे",
                "बोर",
                "मेळ"
            ],
            "theme": "घाट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हेक्टर",
                "बिघा",
                "गुंठा",
                "एकर"
            ],
            "theme": "जमिनीचे मोजमाप",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झारी",
                "फवारणी",
                "खुरपी",
                "कलम"
            ],
            "theme": "बागकाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "हस्तिदंत",
                "चामडे",
                "ज्यूट",
                "नारळाच्या शेंड्या"
            ],
            "theme": "शोभेच्या वस्तूंसाठी वापर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मंदार",
                "बकुळ",
                "धोतरा",
                "नर्गिस"
            ],
            "theme": "फुलांची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "निषाद",
                "मध्यम",
                "पंचम",
                "रिषभ"
            ],
            "theme": "सप्तसुरांतील चार सूर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पारद",
                "लोह",
                "ताम्र",
                "रजत"
            ],
            "theme": "धातू-संस्कृत नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रव",
                "पथ",
                "यात्रा",
                "लालित्य"
            ],
            "theme": "पद___",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "महोत्सव",
                "मंदिर",
                "पदक",
                "तुला"
            ],
            "theme": "सुवर्ण___",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "रुची",
                "रस",
                "कल",
                "गोडी"
            ],
            "theme": "एखाद्या गोष्टीची आवड",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अळी",
                "बटनहोल",
                "उलटी टीप",
                "गहू"
            ],
            "theme": "भारतकामातील टाके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्रेम",
                "मृत्यू",
                "प्रतिज्ञा",
                "मुखत्यार"
            ],
            "theme": "पत्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "टका",
                "रुबल",
                "दीराम",
                "येन"
            ],
            "theme": "परदेशी चलन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नाणी",
                "चेक",
                "कार्ड",
                "युपीआय"
            ],
            "theme": "पैशाच्या व्यवहाराची माध्यमे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाञ्चजन्य",
                "अनंतविजय",
                "देवदत्त",
                "सुघोष"
            ],
            "theme": "शंखांची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अवयव",
                "पिंड",
                "कन्या",
                "अन्न"
            ],
            "theme": "दान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रास",
                "बलुतेदार",
                "मास",
                "ज्योतिर्लिंगे"
            ],
            "theme": "या गोष्टी बारा असतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठणठणपाळ",
                "लोकहितवादी",
                "बी",
                "ज्युलियन"
            ],
            "theme": "साहित्यिकांची टोपण नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लहसुनिया",
                "नीलम",
                "पोवळे",
                "गोमेद"
            ],
            "theme": "रत्न",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हंबरणे",
                "केका",
                "आरवणे",
                "भुंकणे"
            ],
            "theme": "प्राण्यांचे आवाज",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्षण",
                "वेळ",
                "पळ",
                "युग"
            ],
            "theme": "काळ/समय सूचक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नाद",
                "ध्वनी",
                "सूर",
                "गजर"
            ],
            "theme": "आवाज संबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तेज",
                "प्रकाश",
                "झळाळी",
                "किरण"
            ],
            "theme": "प्रकाशासंबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नाळ",
                "बंध",
                "गाठ",
                "जोड"
            ],
            "theme": "जवळचा संबंध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जाळं",
                "कोळी",
                "मासा",
                "होडी"
            ],
            "theme": "मत्स्य व्यवसाय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नाखवा",
                "सारंगा",
                "डोलकर",
                "कोलीवारा"
            ],
            "theme": "कोळी गीतातील शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "एकटा",
                "वर्षाव",
                "डोंगर सपाटी",
                "पखरण"
            ],
            "theme": "सडा या शब्दाचे विविध अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जमाव",
                "संचार",
                "दारू",
                "नजर"
            ],
            "theme": "____बंदी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अंकुर",
                "सुट्टे",
                "तुटकी भांडी",
                "वळण"
            ],
            "theme": "मोड या शब्दाचे विविध अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "विहीर",
                "हातपंप",
                "नळ",
                "हंडा"
            ],
            "theme": "पिण्याच्या पाण्याची व्यवस्था",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बोगदा",
                "मूळ",
                "खनिज",
                "भूजल"
            ],
            "theme": "जमिनी खालच्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नांगर",
                "बी",
                "पीक",
                "खत"
            ],
            "theme": "शेतीशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "थंड",
                "गरम",
                "कोमट",
                "उबदार"
            ],
            "theme": "तापमान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "आंबट",
                "तिखट",
                "गोड",
                "खारट"
            ],
            "theme": "चवी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मीठ",
                "मसाला",
                "तेल",
                "साखर"
            ],
            "theme": "स्वयंपाकातील पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काच",
                "आरसा",
                "प्रकाश",
                "प्रतिबिंब"
            ],
            "theme": "परावर्तनाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वृत्तपत्र",
                "वार्ता",
                "शीर्षक",
                "संपादक"
            ],
            "theme": "बातमीशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नदी",
                "किनारा",
                "तरंग",
                "सागर"
            ],
            "theme": "पाण्याशी संबंधित पण भिन्न पातळ्यांवर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साधू",
                "संत",
                "दिवाळी",
                "दसरा"
            ],
            "theme": "येति घरा.. एक म्हण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नागपंचमी",
                "गोकुळाष्टमी",
                "रक्षाबंधन",
                "मंगळागौर"
            ],
            "theme": "श्रावणातील सण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "घोणस",
                "नाग",
                "तस्कर",
                "नानेटी"
            ],
            "theme": "सापांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "केळे",
                "टॅपिओका",
                "बटाटा",
                "रताळे"
            ],
            "theme": "यांचे चिप्स (पातळ काप) करतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कांदा",
                "घोसाळे",
                "मिरची",
                "ओव्याची पाने"
            ],
            "theme": "यांची भजी करतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दुधी",
                "गाजर",
                "मूग",
                "काटेरी"
            ],
            "theme": "... हलवा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाय",
                "सायकल",
                "रिक्षा",
                "बस"
            ],
            "theme": "प्रवासाची साधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गोमूत्र",
                "हळद",
                "कुंकू",
                "फुलं"
            ],
            "theme": "पूजेसाठी उपयोगी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "इन्स्टा",
                "व्हाट्सअप",
                "फेसबुक",
                "यूट्यूब"
            ],
            "theme": "सोशल मीडिया",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साडी",
                "धोतर",
                "शर्ट",
                "कुर्ता"
            ],
            "theme": "कपडे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जणू",
                "खरं तर",
                "बहुधा",
                "केवळ"
            ],
            "theme": "क्रियाविशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गड",
                "किल्ला",
                "तट",
                "बुरुज"
            ],
            "theme": "दुर्गशास्त्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कुरकुरीत",
                "चविष्ट",
                "गोडसर",
                "तिखट"
            ],
            "theme": "चव वर्णन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "झाड",
                "फुलं",
                "पाने",
                "फळं"
            ],
            "theme": "वनस्पती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कारखाना",
                "शेत",
                "दुकान",
                "कार्यालय"
            ],
            "theme": "कामाची ठिकाणं",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मंचाव",
                "पाखडणी",
                "गणेशाचे कान",
                "शोरबा"
            ],
            "theme": "सूप (मराठी व इंग्रजी)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "उफणणी",
                "कापणी",
                "नांगरणी",
                "मळणी"
            ],
            "theme": "शेतीतील कामे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नांगर",
                "तिफण",
                "विळा",
                "डवरा"
            ],
            "theme": "शेतीतील अवजारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठेचा",
                "चटणी",
                "छुन्दा",
                "लोणचं"
            ],
            "theme": "भोजनासोबत खाल्ले जाणारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चाटण",
                "लेह्य",
                "अवलेह",
                "रसायन"
            ],
            "theme": "आयुर्वेदिक चाटून खायची औषधे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ज्योतिष",
                "वास्तू",
                "खगोल",
                "भाषा"
            ],
            "theme": "काही प्राचीन शास्त्र पद्धती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खडतर",
                "कंटाळवाणे",
                "सुरळीत",
                "धकाधकीचे"
            ],
            "theme": "आयुष्याची विशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नागमोडी",
                "खडबडीत",
                "सरळसोट",
                "चिंचोळा"
            ],
            "theme": "रस्त्याची विशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गुगल मॅप्स",
                "नकाशा",
                "होकायंत्र",
                "ध्रुव तारा"
            ],
            "theme": "दिशा दर्शक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चतुर",
                "मधमाशी",
                "झुरळ",
                "डास"
            ],
            "theme": "उडते किडे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चलाख",
                "धूर्त",
                "वस्ताद",
                "पक्का"
            ],
            "theme": "हुशार माणूस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मंद",
                "जलद",
                "सुसाट",
                "धीमा"
            ],
            "theme": "वेग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हंगेरी",
                "जपान",
                "इटली",
                "जर्मनी"
            ],
            "theme": "महायुद्ध-२:अक्ष (axis) राष्ट्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सोव्हिएत संघ",
                "अमेरिका",
                "ब्रिटन",
                "फ्रान्स"
            ],
            "theme": "महायुद्ध-२:मित्र राष्ट्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "स्वित्झर्लंड",
                "स्वीडन",
                "पोर्तुगाल",
                "तुर्कस्तान"
            ],
            "theme": "महायुद्ध-२:तटस्थ राष्ट्रे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "व्हेनेझुएला",
                "चिली",
                "पेरू",
                "अर्जेंटिना"
            ],
            "theme": "दक्षिण अमेरिका देश",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सीताफळ",
                "लिची",
                "सफरचंद",
                "द्राक्ष"
            ],
            "theme": "फळे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मेसी",
                "टॅंगो",
                "इग्वाझू",
                "फुटबॉल"
            ],
            "theme": "अर्जेंटिना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुळसुळीत",
                "राठ",
                "दाट",
                "विरळ"
            ],
            "theme": "केस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पर्णपाती",
                "घनदाट",
                "सदाहरित",
                "खारफुटी"
            ],
            "theme": "जंगलांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गुळगुळीत",
                "खडबडीत",
                "चिकट",
                "मखमली"
            ],
            "theme": "पृष्ठभागाचे पोत/texture प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घंटा",
                "बासरी",
                "ढोल",
                "तबला"
            ],
            "theme": "वाद्ये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दात",
                "नाक",
                "डोळे",
                "कान"
            ],
            "theme": "इंद्रिये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हरभरा",
                "मूग",
                "मसूर",
                "उडीद"
            ],
            "theme": "डाळी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सायकल",
                "ट्रक",
                "बाईक",
                "स्कूटर"
            ],
            "theme": "रस्त्यावरील वाहनं",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पहाट",
                "संध्याकाळ",
                "मध्यरात्र",
                "मध्यान्ह"
            ],
            "theme": "वेळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "झाडं",
                "जनावरे",
                "माणसं",
                "पक्षी"
            ],
            "theme": "जीवसृष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अमनदीप",
                "दीप्ती",
                "स्मृती",
                "ऋचा"
            ],
            "theme": "क्रिकेट विश्वविजेत्या खेळाडू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ज्वाला",
                "सिंधू",
                "साईना",
                "अश्विनी"
            ],
            "theme": "बॅडमिंटनपटू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "साक्षी",
                "मीराबाई",
                "मनू",
                "मल्लेश्वरी"
            ],
            "theme": "ऑलिम्पिक पदक विजेत्या खेळाडू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "साद",
                "हाळी",
                "हाक",
                "आवाज"
            ],
            "theme": "मोठ्याने बोलावणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वाद",
                "कलह",
                "भांडण",
                "तंटा"
            ],
            "theme": "झगडा वैर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "त्रुटी",
                "खोट",
                "बिघाड",
                "दोष"
            ],
            "theme": "लहान मोठी कमतरता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धागा",
                "सुई",
                "कापड",
                "काजे"
            ],
            "theme": "शिवणकाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लाकूड",
                "खिळा",
                "करवत",
                "रंधा"
            ],
            "theme": "सुतारकाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भट्टी",
                "हातोडा",
                "निखारा",
                "लोखंड"
            ],
            "theme": "लोहारकाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चंद्र",
                "सूर्य",
                "नक्षत्र",
                "ग्रह"
            ],
            "theme": "आकाशीय वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "थंडी",
                "गरम",
                "ओलसर",
                "कोरडे"
            ],
            "theme": "हवामान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गोल",
                "चौरस",
                "त्रिकोण",
                "आयत"
            ],
            "theme": "आकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "त्रिज्या",
                "परीघ",
                "जिवा",
                "पाय"
            ],
            "theme": "भूमितीतील वर्तुळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शेपूट",
                "वशिंड",
                "खूर",
                "शिंग"
            ],
            "theme": "गाय/बैल",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "टाच",
                "बोटे",
                "नखे",
                "चवडा"
            ],
            "theme": "तळपाय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फुगा",
                "तुतारी",
                "मेणबत्ती",
                "शिट्टी"
            ],
            "theme": "फुंकण्याशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "केक",
                "टोपी",
                "मित्रमैत्रिणी",
                "भेटवस्तू"
            ],
            "theme": "वाढदिवस साजरा करणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गांधी",
                "पगडी",
                "बॅगी",
                "साफा"
            ],
            "theme": "टोप्यांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "क्रोध",
                "लोभ",
                "मत्सर",
                "मद"
            ],
            "theme": "मानवी षड्रिपू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भीती",
                "स्पर्धा",
                "कुतूहल",
                "आळस"
            ],
            "theme": "मानवी प्रवृत्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सेवा",
                "संयम",
                "दानशूरता",
                "विवेक"
            ],
            "theme": "मानवी सद्गुण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हरभजन",
                "दोशी",
                "कुंबळे",
                "हिरवाणी"
            ],
            "theme": "क्रिकेट - फिरकी गोलंदाज",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कपिल",
                "अक्षर",
                "शास्त्री",
                "युवराज"
            ],
            "theme": "क्रिकेट - अष्टपैलू खेळाडू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "किरमाणी",
                "किरण",
                "महेंद्र",
                "मोंगिया"
            ],
            "theme": "क्रिकेट - यष्टीरक्षक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "झाडू",
                "निर्जंतुक",
                "चकाचक",
                "सफाई"
            ],
            "theme": "स्वच्छते संबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "विषाणू",
                "संसर्ग",
                "कॉलरा",
                "जीवाणू"
            ],
            "theme": "रोग जंतू विषयी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कृमी",
                "हायड्रा",
                "प्रवाळ",
                "बुरशी"
            ],
            "theme": "बहूपेशीय सूक्ष जीव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "त्रिविक्रीम",
                "जनार्दन",
                "अच्युत",
                "नारायण"
            ],
            "theme": "श्री विष्णू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चतुरानन",
                "प्रजापती",
                "वेदज्ञ",
                "कमलासन"
            ],
            "theme": "श्री ब्रह्मदेव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "रुद्र",
                "गंगाधर",
                "विश्वनाथ",
                "पशुपती"
            ],
            "theme": "श्री शंकर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पिठलं",
                "भाकरी",
                "भाजी",
                "लोणचं"
            ],
            "theme": "ग्रामीण जेवण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कढई",
                "तवा",
                "भांडे",
                "झारा"
            ],
            "theme": "स्वयंपाक भांडी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हसणं",
                "रडणं",
                "ओरडणं",
                "कुजबुजणं"
            ],
            "theme": "प्रतिक्रिया",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्रेषित",
                "यक्षांची देणगी",
                "अंतराळातील स्फोट",
                "टाइम मशीनची किमया"
            ],
            "theme": "जयंत नारळीकर पुस्तके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चंद्राची सावली",
                "इक्माई",
                "पारंब्यांचे जग",
                "समर्थांचिया सेवका"
            ],
            "theme": "नारायण धारप पुस्तके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पिंगळा वेळ",
                "रक्तचंदन",
                "सांजशकुन",
                "काजळमाया"
            ],
            "theme": "जी ए कुलकर्णी पुस्तके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्रसव",
                "उद्गम",
                "उत्पत्ती",
                "प्रकटन"
            ],
            "theme": "जन्म",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "प्राण",
                "अस्तित्व",
                "जीवन",
                "चेतना"
            ],
            "theme": "जगणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "श्वास",
                "धडधड",
                "नाडी",
                "पचन"
            ],
            "theme": "जीवन क्रिया",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "लोकल",
                "पावभाजी",
                "बॉलिवूड",
                "डबेवाला"
            ],
            "theme": "मुंबई",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दुर्गापूजा",
                "संदेश",
                "हावडा पूल",
                "ट्राम"
            ],
            "theme": "कोलकत्ता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कुतुब मिनार",
                "छोले भटुरे",
                "संसद",
                "चांदणी चौक"
            ],
            "theme": "दिल्ली",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पट",
                "चेक",
                "प्यादे",
                "एल पसांट"
            ],
            "theme": "बुद्धिबळ शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ऑफसाईड",
                "गोल",
                "पेनल्टी",
                "पास"
            ],
            "theme": "फुटबॉल (सॉकर) शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ड्यूस",
                "व्हॉली",
                "एस",
                "फॉल्ट"
            ],
            "theme": "टेनिस शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकाश",
                "पाणी",
                "माती",
                "अग्नी"
            ],
            "theme": "पंचमहाभूत",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ढगाळ",
                "कोसळणारा",
                "हलकासा",
                "वीजांसह"
            ],
            "theme": "पावसाचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सोमवार",
                "मंगळवार",
                "बुधवार",
                "गुरुवार"
            ],
            "theme": "आठवड्याचे दिवस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घर",
                "कुटुंब",
                "नातेसंबंध",
                "प्रेम"
            ],
            "theme": "कौटुंबिक जीवन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भिंत",
                "छत",
                "दरवाजा",
                "खिडकी"
            ],
            "theme": "घराचे भाग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "पाटी",
                "खडू",
                "वह्या",
                "पुस्तके"
            ],
            "theme": "शालेय साहित्य",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "घड्याळ",
                "कॅलेंडर",
                "वेळ",
                "दिनांक"
            ],
            "theme": "वेळ दर्शक गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शुद्धलेखन",
                "व्याकरण",
                "वाचन",
                "लेखन"
            ],
            "theme": "भाषाशिक्षण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "स्वयंपाकघर",
                "हॉल",
                "बेडरूम",
                "बाथरूम"
            ],
            "theme": "घरातली खोली",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "परवा",
                "काल",
                "आज",
                "उद्या"
            ],
            "theme": "काळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दही",
                "ताक",
                "लोणी",
                "तूप"
            ],
            "theme": "दुग्धजन्य पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ओढा",
                "प्रवाह",
                "धबधबा",
                "सरोवर"
            ],
            "theme": "पाण्याचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नदी",
                "समुद्र",
                "तलाव",
                "विहीर"
            ],
            "theme": "जलस्रोत",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भात",
                "पोहे",
                "साबुदाणा",
                "उपमा"
            ],
            "theme": "उपाहाराचे पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मंद",
                "जोरदार",
                "सोसाट्याचा",
                "झुळूक"
            ],
            "theme": "वाऱ्याचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दंड",
                "कैद",
                "फाशी",
                "शासन"
            ],
            "theme": "शिक्षेच्या संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "आसन",
                "प्राण",
                "ध्यान",
                "मुद्रा"
            ],
            "theme": "योग संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मुकुट",
                "राजदंड",
                "छत्र",
                "राजमुद्रा"
            ],
            "theme": "राजाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हातमाग",
                "नतमस्तक",
                "तरणोपाय",
                "खतरनाक"
            ],
            "theme": "अवयव लपलेले शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तत्वज्ञान",
                "रहस्यमय",
                "चरित्र",
                "अध्यात्मिक"
            ],
            "theme": "साहित्य प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वेड",
                "लय भारी",
                "माऊली",
                "अदृश्य"
            ],
            "theme": "रितेश देशमुख चित्रपट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चमू",
                "गट",
                "संघ",
                "मंडळ"
            ],
            "theme": "समूह",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शाखा",
                "जय",
                "तरण",
                "वाद"
            ],
            "theme": "वि ___",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वाचा",
                "व्यापारी",
                "बोली",
                "सरस्वती"
            ],
            "theme": "वाणी या शब्दाचे विविध अर्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गवळी",
                "कासकर",
                "सुर्वे",
                "निकाजळे"
            ],
            "theme": "मुंबई अंडरवर्ल्ड",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पेपरवाला",
                "स्कूल बस",
                "जॉगिंग",
                "सफाई कामगार"
            ],
            "theme": "सकाळी लवकर दिसणाऱ्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वानखेडे",
                "होळकर",
                "पाटील",
                "मोदी"
            ],
            "theme": "प्रसिद्ध क्रिकेट मैदानं",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आईस्क्रीम",
                "पान",
                "ताक",
                "सुपारी"
            ],
            "theme": "जेवणा नंतर घेतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ताड",
                "माड",
                "खजूर",
                "अशोक"
            ],
            "theme": "सरळ रेषेत उंच वाढणारी झाडे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आवळा",
                "अश्वगंधा",
                "मध",
                "साजूक तूप"
            ],
            "theme": "च्यवनप्राश प्रमुख घटक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पाटलीपुत्र",
                "बिंदुसार",
                "संघमित्रा",
                "कलिंग"
            ],
            "theme": "सम्राट अशोक संबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "धम्मचक्र",
                "लुम्बिनी",
                "शुद्धोधन",
                "दुःख"
            ],
            "theme": "सिद्धार्थ गौतम बुद्ध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चेतक",
                "हल्दीघाटी",
                "चित्तौडगड",
                "उदयसिंह"
            ],
            "theme": "महाराणा प्रताप",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हंस",
                "दूत",
                "गादी",
                "कारण"
            ],
            "theme": "ज्यांच्या मागे 'राज...' लागते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मुरली",
                "चक्र",
                "गंगा",
                "गिरी"
            ],
            "theme": "ज्यांच्या पुढे '...धर' लागते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चुना",
                "शेंडी",
                "थापा",
                "लोणी"
            ],
            "theme": "...लावणे' म्हणजे फसवणे/खोटे बोलणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पुतळा",
                "स्मृती पुरस्कार",
                "टपाल तिकीट",
                "सार्वजनिक सुट्टी"
            ],
            "theme": "महान व्यक्तींची स्मृती जागृत ठेवायचे मार्ग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शिक्का",
                "स्पंज",
                "नोटा",
                "पेन"
            ],
            "theme": "बँक कैशियर कडे असणाऱ्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शाई",
                "बॉल",
                "फाऊंटन",
                "जेल"
            ],
            "theme": "पेन चे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सकाळी",
                "दुपारी",
                "संध्याकाळी",
                "रात्री"
            ],
            "theme": "वेळेचे वर्णन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "किराणा",
                "भाजी",
                "फळं",
                "दूध"
            ],
            "theme": "घरच्या खरेदीच्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कमळ",
                "गुलाब",
                "जाई",
                "मोगरा"
            ],
            "theme": "फुलं",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मोर",
                "घार",
                "तळे",
                "घोडे"
            ],
            "theme": "...गाव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नाग",
                "कोल्हा",
                "बाळा",
                "राजा"
            ],
            "theme": "...पूर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सिंह",
                "देव",
                "जय",
                "प्रबळ"
            ],
            "theme": "...गड",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गुजरात",
                "लोहपुरुष",
                "गृहमंत्री",
                "एकतेचा पुतळा"
            ],
            "theme": "वल्लभभाई पटेल",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "प्रियदर्शिनी",
                "आणीबाणी",
                "ब्लू स्टार",
                "पोखरण"
            ],
            "theme": "इंदिरा गांधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बालदिन",
                "मोतीलाल",
                "डिस्कवरी ऑफ इंडिया",
                "चाचा"
            ],
            "theme": "जवाहरलाल नेहरू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हजार",
                "रोकड",
                "एटीएम",
                2016
            ],
            "theme": "नोटबंदी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भोपाळ",
                1984,
                "वायू",
                "युनियन कार्बाइड"
            ],
            "theme": "भोपाळ वायू दुर्घटना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ताज",
                "कसाब",
                2008,
                "अतिरेकी"
            ],
            "theme": "मुंबई २६/११ हल्ला",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "देऊळ",
                "विहीर",
                "मसाला",
                "हायवे"
            ],
            "theme": "उमेश आणि गिरीश कुलकर्णी चित्रपट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गिरणी",
                "बांधकाम",
                "बेकरी",
                "ज्वालामुखी"
            ],
            "theme": "येथे तुमच्या अंगावर पांढरा थर जमू शकतो",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "नदी",
                "ओढा",
                "कॅनाल",
                "पाट"
            ],
            "theme": "वाहते पाणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "फेसाळते",
                "गढूळ",
                "उथळ",
                "खळाळते"
            ],
            "theme": "पाणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "खडतर",
                "सुखमय",
                "धकाधकीचे",
                "परिपूर्ण"
            ],
            "theme": "जीवन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कच्चा",
                "खडबडीत",
                "वळणावळणाचा",
                "डांबरी"
            ],
            "theme": "रस्ता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आरती",
                "प्रसाद",
                "शंख",
                "तुळस"
            ],
            "theme": "हिंदू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अजान",
                "किब्ला",
                "वजू",
                "सजदा"
            ],
            "theme": "इस्लाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कडा",
                "किरपान",
                "कीर्तन",
                "गुरुद्वारा"
            ],
            "theme": "शीख",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मत्स्य",
                "वामन",
                "गरुड",
                "स्कंद"
            ],
            "theme": "पुराण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ईश",
                "कठ",
                "मैत्री",
                "छांदोग्य"
            ],
            "theme": "उपनिषद",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ऋग्",
                "साम",
                "यजु:",
                "अथर्व"
            ],
            "theme": "वेद",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "व्रात्य",
                "द्वाड",
                "खट्याळ",
                "उनाड"
            ],
            "theme": "खोडकर नटखट या अर्थी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "खळखळाट",
                "उथळ",
                "पाणी",
                "म्हण"
            ],
            "theme": "एक मराठी म्हण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "उदक",
                "तोय",
                "सलील",
                "अंबु"
            ],
            "theme": "पाणी/जल ला समानार्थी शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पंखा",
                "कुलर",
                "एसी",
                "झुरळपंखा"
            ],
            "theme": "थंडी करणारी साधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ऊन",
                "छाया",
                "सावली",
                "तडका"
            ],
            "theme": "प्रकाशाचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "धावणे",
                "थांबणे",
                "चालणे",
                "बसणे"
            ],
            "theme": "हालचाली",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खांदा",
                "तिरडी",
                "मडके",
                "चिता"
            ],
            "theme": "मृत्यूपश्चात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "माठ",
                "सुरई",
                "कुंडी",
                "पणती"
            ],
            "theme": "मातीच्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गुडघा",
                "कंबर",
                "कोपर",
                "मनगट"
            ],
            "theme": "शरीरातील सांधे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हूल",
                "जरीला",
                "झूल",
                "कोसला"
            ],
            "theme": "ज्ञानपीठकार भालचंद्र नेमाडे लिखित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "झोंबी",
                "गोतावळा",
                "नांगरणी",
                "नटरंग"
            ],
            "theme": "आनंद यादव लिखित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सत्तांतर",
                "उंबरठा",
                "बनगरवाडी",
                "करुणाष्टक"
            ],
            "theme": "व्यंकटेश माडगूळकर लिखित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेंढा",
                "मासा",
                "खेकडा",
                "बैल"
            ],
            "theme": "राशी ची चिन्हे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कासव",
                "मगर",
                "पाणघोडा",
                "बेडूक"
            ],
            "theme": "उभयचर",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मोर",
                "उंदीर",
                "रेडा",
                "गरुड"
            ],
            "theme": "विविध देवांची वाहने असलेले प्राणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "नारळी",
                "त्रिपुरी",
                "गुरु",
                "कोजागिरी"
            ],
            "theme": "पौर्णिमा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मंगळ",
                "शनी",
                "बुध",
                "पृथ्वी"
            ],
            "theme": "ग्रह",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तारा",
                "शुक्र",
                "वारा",
                "मंद"
            ],
            "theme": "प्रसिद्ध भावगीत",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कापूस",
                "खोबरे",
                "बर्फ",
                "रस्सा"
            ],
            "theme": "पांढरा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सूत",
                "वात",
                "मलमपट्टी",
                "गादी"
            ],
            "theme": "कापसाचे उपयोग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "फरसाण",
                "कांदा",
                "तर्री",
                "मटकी"
            ],
            "theme": "मिसळीचे घटक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "काश्मीरी",
                "लवंगी",
                "भूत जोलोकिया",
                "ब्याडगी"
            ],
            "theme": "मिरच्यांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्मी",
                "सुतळी",
                "पानपट्टी",
                "आपटबार"
            ],
            "theme": "आवाजी फटाक्यांचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भुई",
                "सुदर्शन",
                "काल",
                "राशी"
            ],
            "theme": "...चक्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "प्लेटीपस",
                "कांगारू",
                "कोआला",
                "वोम्बॅट"
            ],
            "theme": "फक्त ऑस्ट्रेलिया खंडात आढळणारे सस्तन प्रजातीतील प्राणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ट्रायसेरेटॉप्स",
                "व्हेलोसी रॅप्टर",
                "स्टिगॅसॉरस",
                "टिरॅनॉसॉरस"
            ],
            "theme": "डायनासॉर प्रजातीतील प्राणी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चित्ता",
                "जिराफ",
                "पेंगवीन",
                "ध्रुवीय अस्वल"
            ],
            "theme": "भारतात न आढळणारे प्राणी (प्राणिसंग्रहालये वगळता)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रक्त",
                " जास्वंद",
                " माणिक",
                " सफरचंद"
            ],
            "theme": "लाल रंगाच्या वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भांगडा",
                " सलवारखमीज",
                " गहू",
                " हॉकी"
            ],
            "theme": " पंजाबशी संबंधित ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ढाल",
                "करंडक",
                "पदक",
                "चक्र"
            ],
            "theme": "पारितोषिके",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मेण",
                "आइस्क्रीम",
                "मीठ",
                "हृदय"
            ],
            "theme": "विरघळणार्या / पाघळणाऱ्या गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "समुद्र",
                "पोफळी",
                "मोदक",
                "आंबा"
            ],
            "theme": "कोकणातील गोष्टी ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कविता",
                " हुजूरपागा",
                "आनंदाचे झाड",
                "ऋतू हिरवा"
            ],
            "theme": "कवयित्री शांता शेळके यांच्याशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "हात",
                "चौकट",
                "हुकूम",
                "विदुषक"
            ],
            "theme": "पत्ते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गाऊन",
                "तराजू",
                "सर्वोच्च",
                "कायदा"
            ],
            "theme": "न्यायालय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सागरा धरणी",
                "संधी",
                "जागा",
                "नोकरी"
            ],
            "theme": "ही “मिळते” :-)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुतार",
                "लोहपुरुष",
                "साधू बेट",
                "एकता"
            ],
            "theme": "सरदार पटेल पुतळा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लाकूड",
                "रंधा",
                "कपाट",
                "करवत"
            ],
            "theme": "सुतारकाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ऐरण",
                "भट्टी",
                "भाता",
                "घण"
            ],
            "theme": "लोहारकाम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कथा",
                "काम",
                "योग",
                "कळ"
            ],
            "theme": "--सूत्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भाग्य",
                "विधिलिखित",
                "प्रारब्ध",
                "दैव"
            ],
            "theme": "नशीब",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "क्रोध",
                "मद",
                "मत्सर",
                "लोभ"
            ],
            "theme": "षडरिपू पैकी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "राक्षस",
                "मलयकेतू",
                "विक्रमादित्य",
                "चाणक्य"
            ],
            "theme": "मुद्राराक्षस (किंवा चाणक्य कथेमधील) पात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जय",
                "बलदेव सिंग",
                "राधा",
                "कालिया"
            ],
            "theme": "शोले चित्रपटातील पात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जटायू",
                "अंगद",
                "शत्रुघ्न",
                "इंद्रजीत"
            ],
            "theme": "रामायणातील व्यक्ती/पात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंदाज",
                "गाठ",
                "दोरी",
                "भिंत"
            ],
            "theme": "... बांधतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "सूड",
                "विश्रांती",
                "औषध",
                "जीव"
            ],
            "theme": "... घेतात",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शेपटी",
                "कन्नी",
                "मांजा",
                "चरखी"
            ],
            "theme": "पतंग संबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तुझा",
                "रंग",
                "प्रेमा",
                "कसा"
            ],
            "theme": "मराठी नाटक - १",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "दुर्वांची",
                "जुडी",
                "ही",
                "वाहतो"
            ],
            "theme": "मराठी नाटक - २",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चालू",
                "आहे",
                "कोर्ट",
                "शांतता"
            ],
            "theme": "मराठी नाटक - ३",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "पेट्रोल",
                "डिझेल",
                "इथेनॉल",
                "वीज"
            ],
            "theme": "मोटार गाड्यांचे इंधन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "फॅराडे",
                "जनित्र",
                "धक्का",
                "सर्किट"
            ],
            "theme": "वीज/विद्युत संबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कोळसा",
                "अणू",
                "सौर",
                "पवन"
            ],
            "theme": "वीज निर्मितीचे प्रकार/इंधन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गुलाम अली",
                "मेहेंदी हसन",
                "अली सेठी",
                "नूरजहाँ"
            ],
            "theme": "पाकिस्तानी गायक गायिका",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "बेनझीर",
                "झिया",
                "इम्रान",
                "नवाज"
            ],
            "theme": "पाकिस्तानी राजकीय नेते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "झहीर",
                "अक्रम",
                "दलपत",
                "रमीज"
            ],
            "theme": "पाकिस्तानी क्रिकेटपटू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कोडगा",
                "मग्रूर",
                "उद्धट",
                "निर्लज्ज"
            ],
            "theme": "लोकांची कदर न करणारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मूर्ख",
                "अडाणी",
                "अक्कलशून्य",
                "निर्बुद्ध"
            ],
            "theme": "बुद्धी/विचाराचा अभाव असणारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "धूर्त",
                "कपटी",
                "लबाड",
                "बेईमान"
            ],
            "theme": "नीतिमत्तेचा अभाव असणारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खरेदी",
                "विक्री",
                "नफा",
                "तोटा"
            ],
            "theme": "धंद्याची आर्थिक गणित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "उत्पादन",
                "पुरवठा",
                "मागणी",
                "गोदाम"
            ],
            "theme": "धंद्यात मालासंबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "भागीदार",
                "दलाल",
                "ग्राहक",
                "नोकरवर्ग"
            ],
            "theme": "धंद्यातील महत्वाच्या व्यक्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कोआन",
                "इसापनीती",
                "जातक",
                "पंचतंत्र"
            ],
            "theme": "कथा प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "श्लोक",
                "दोहा",
                "अभंग",
                "रुबाई"
            ],
            "theme": "काव्य प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "फार्स",
                "तमाशा",
                "एकांकिका",
                "दशावतार"
            ],
            "theme": "नाट्य प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "डंख",
                "लचका",
                "चावा",
                "दंश"
            ],
            "theme": "प्राण्यांचा तोंडावाटे हल्ला",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शंकर",
                "कात",
                "फणा",
                "पंचमी"
            ],
            "theme": "नागाशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आषाढी एकादशी",
                "शिवरात्र",
                "श्रावणी सोमवार",
                "दत्त जयंती"
            ],
            "theme": "काही उपवास करण्याचे दिवस",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "रोमियो",
                "ऑथेल्लो",
                "शायलॉक",
                "मॅकबेथ"
            ],
            "theme": "शेक्सपिअर च्या नाटकांतली पात्र",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ऑगस्टस",
                "नीरो",
                "मार्कस ऑरेलियस",
                "क्लॉडियस"
            ],
            "theme": "रोमन सम्राट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "युक्लीड",
                "आर्यभट्ट",
                "पायथॅगोरस",
                "आर्किमिडीज"
            ],
            "theme": "प्राचीन गणितज्ञ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भुजंगप्रयात",
                "शार्दूलविक्रीडित",
                "आर्या",
                "मंदाक्रांता"
            ],
            "theme": "कवितेतील वृत्ते",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रांगदा",
                "शकुंतला",
                "सत्यवती",
                "बृहन्नला"
            ],
            "theme": "महाभारतातील स्त्रिया",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मनोरमा",
                "शशिकला",
                "कुमकुम",
                "नादिरा"
            ],
            "theme": "हिंदी चित्रपटातील जुन्या स्त्री चरित्र अभिनेत्री",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अण्णासाहेब किर्लोस्कर",
                "मधुसूदन कालेलकर",
                "वसंत कानेटकर",
                "विद्याधर गोखले"
            ],
            "theme": "प्रसिद्ध मराठी नाटककार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पु. ल. देशपांडे",
                "वि. वा. शिरवाडकर",
                "आचार्य अत्रे",
                "गंगाधर गाडगीळ"
            ],
            "theme": "नाटक व साहित्य दोन्ही क्षेत्रांतले लेखक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "राम गबाले",
                "राजा परांजपे",
                "राजा नेने",
                "शांताराम"
            ],
            "theme": "मराठी चित्रपट दिग्दर्शक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सूत्र",
                "धागा",
                "रेषा",
                "बंध"
            ],
            "theme": "जोडणी दर्शवणाऱ्या संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "व्यास",
                "त्रिज्या",
                "परिघ",
                "क्षेत्रफळ"
            ],
            "theme": "भूमितीतील घटक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "ऋषी",
                "ग्रंथ",
                "कथा",
                "परंपरा"
            ],
            "theme": "भारतीय ज्ञानपरंपरेचे घटक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आसन",
                "पादुका",
                "चक्र",
                "शंख"
            ],
            "theme": "पूजाविधीतील प्रतीक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अधिकार",
                "कर्तव्य",
                "मर्यादा",
                "शिस्त"
            ],
            "theme": "सत्तेशी संबंधित संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "राजा",
                "ऋषी",
                "सेनानी",
                "दूत"
            ],
            "theme": "प्राचीन समाजातील भूमिका",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मार्ग",
                "चक्र",
                "सोपान",
                "प्रवाह"
            ],
            "theme": "प्रक्रिया दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "धर्म",
                "नीती",
                "संयम",
                "कर्तव्य"
            ],
            "theme": "नैतिक संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वन",
                "आश्रम",
                "सभा",
                "रणभूमी"
            ],
            "theme": "महाभारतातील संदर्भस्थळे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भाव",
                "रस",
                "छटा",
                "लय"
            ],
            "theme": "साहित्यिक अनुभूती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गंध",
                "स्पर्श",
                "स्वाद",
                "श्रवण"
            ],
            "theme": "इंद्रियज्ञान",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अनुभव",
                "जाणीव",
                "स्मृती",
                "संवेदना"
            ],
            "theme": "मानसिक प्रक्रिया",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "छत्र",
                "ध्वज",
                "सिंहासन",
                "मुकुट"
            ],
            "theme": "राजसत्ता दर्शवणारी चिन्हे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तप",
                "व्रत",
                "संन्यास",
                "संयम"
            ],
            "theme": "आत्मशुद्धीच्या पद्धती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चिन्ह",
                "प्रतिमा",
                "अर्थ",
                "संकेत"
            ],
            "theme": "प्रतिनिधित्व दर्शवणाऱ्या संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अमरत्व",
                "पुनर्जन्म",
                "भविष्यकथन",
                "कालप्रवास"
            ],
            "theme": "अविश्वसनीय / अतिप्राकृतिक गोष्टी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मधुमती",
                "ओम शांती ओम",
                "कर्ज",
                "मिलन"
            ],
            "theme": "पुनर्जन्मावर आधारित चित्रपट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तारण",
                "हप्ता",
                "व्याज",
                "गहाण"
            ],
            "theme": "कर्जा संबंधी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सुभाषचंद्र बोस",
                "ए. आर. रहमान",
                "सावित्रीबाई फुले",
                "दीपिका पदुकोण"
            ],
            "theme": "जानेवारी मध्ये जन्मलेल्या व्यक्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "छत्रपती शिवाजी महाराज",
                "मोरारजी देसाई",
                "जगजीत सिंह",
                "जयललिता"
            ],
            "theme": "फेब्रुवारी मध्ये जन्मलेल्या व्यक्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "मेरी कोम",
                "आमिर खान",
                "झाकीर हुसेन",
                "शशी थरूर"
            ],
            "theme": "मार्च मध्ये जन्मलेल्या व्यक्ती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "धमक",
                "शार",
                "गार",
                "भडक"
            ],
            "theme": "रंगाचा उठाव दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "झिंगाट",
                "कोंबडी",
                "विश्वविनायक",
                "धडक"
            ],
            "theme": "अजय अतुल यांच्या कलाकृती",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अनुदान",
                "सांत्वन",
                "कुमक",
                "पुनर्वसन"
            ],
            "theme": "आपत्तीचे निराकरण",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "मासळी",
                "गटार",
                "ओले मोजे",
                "शौचालय"
            ],
            "theme": "दुर्गंध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रपटगृह",
                "तळघर",
                "गुहा",
                "रात्र"
            ],
            "theme": "अंधार/अंधाऱ्या जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वाचनालय",
                "ध्यानकक्ष",
                "परीक्षाकेंद्र",
                "स्मशान"
            ],
            "theme": "शांत जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तिमिर",
                "दुरित",
                "व्यंकटी",
                "मैत्र"
            ],
            "theme": "पसायदानातील शब्द (ज्ञानेश्वर)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वैखरी",
                "पापबुद्धी",
                "नीववावे",
                "चत्वार"
            ],
            "theme": "मनाच्या श्लोकांतील शब्द (रामदास)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वनचरे",
                "हरिकथा",
                "एकांताचा वास",
                "आकाशमंडप"
            ],
            "theme": "वृक्षवल्ली आम्हा सोयरे (तुकोबा)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आधार",
                "स्तंभ",
                "पाया",
                "मूळ"
            ],
            "theme": "आधार किंवा बेस दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तर्क",
                "कारण",
                "परिणाम",
                "निष्पत्ती"
            ],
            "theme": "विचारसाखळीतील घटक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "बीज",
                "अंकुर",
                "वाढ",
                "फळ"
            ],
            "theme": "नैसर्गिक विकासक्रम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्पंदन",
                "आवाज",
                "प्रतिध्वनी",
                "लय"
            ],
            "theme": "ध्वनीशी संबंधित संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "ताल",
                "मात्रा",
                "आवर्तन",
                "गती"
            ],
            "theme": "संगीतात्मक रचना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कालावधी",
                "क्षण",
                "फेरफटका",
                "अंतर"
            ],
            "theme": "वेळेशी निगडित शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संत ज्ञानेश्वर",
                100,
                "शिडी",
                "साप"
            ],
            "theme": "सापशिडी खेळ - त्याचे निर्माते वगैरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कवड्या",
                "पट",
                "चिरा",
                "फासे"
            ],
            "theme": "सारीपाट खेळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "शह",
                "राणी",
                64,
                "हत्ती"
            ],
            "theme": "बुद्धिबळ खेळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आणि",
                "किंवा",
                "परंतु",
                "तथापि"
            ],
            "theme": "समुच्चयबोधक जोडशब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "म्हणून",
                "कारण",
                "तेव्हा",
                "जर"
            ],
            "theme": "कारण-परिणाम दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "खरेतर",
                "अर्थात",
                "वस्तुतः",
                "मात्र"
            ],
            "theme": "स्पष्टीकरण/मर्यादा दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठाणे",
                "कल्याण",
                "डोंबिवली",
                "अंबरनाथ"
            ],
            "theme": "मुंबई उपनगरे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लोकल",
                "टॅक्सी",
                "रिक्षा",
                "बस"
            ],
            "theme": "मुंबईतील वाहतूक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "म्हातारीचा बूट",
                "राणीचा बाग",
                "गेटवे",
                "चौपाटी"
            ],
            "theme": "मुंबईतील स्थळे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "खुळखुळा",
                "बोबडे बोल",
                "लाळ",
                "शी शु"
            ],
            "theme": "नवजात शिशु",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गणवेश",
                "मित्र-मैत्रिणी",
                "खेळ",
                "अभ्यास"
            ],
            "theme": "शाळकरी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गॉगल",
                "फॅशन",
                "वाहन",
                "फोन"
            ],
            "theme": "कॉलेज/टीन एजर्स",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "कपडा",
                "कागद",
                "लोखंड",
                "लाकूड"
            ],
            "theme": "साहित्य प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कात्री",
                "सुई",
                "दोरा",
                "पट्टी"
            ],
            "theme": "शिवणकाम साधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "घड्याळ",
                "दिवा",
                "भिंत",
                "खाट"
            ],
            "theme": "घरातील उपयुक्त वस्तू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "गाय",
                "रेडा",
                "म्हैस",
                "कालवड"
            ],
            "theme": "पशुधन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "गवत",
                "सुपीक",
                "धूप",
                "नांगर"
            ],
            "theme": "शेतीतील संदर्भ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "घंटा",
                "शंख",
                "ताशा",
                "तुतारी"
            ],
            "theme": "आवाज करणारी वाद्ये",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "टॉवेल",
                "साबण",
                "शॉवर",
                "पाणी"
            ],
            "theme": "अंघोळ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तलाव",
                "सूर",
                "डुबकी",
                "बटरफ्लाय"
            ],
            "theme": "पोहोणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वाळू",
                "शिंपला",
                "खेकडा",
                "नारळ"
            ],
            "theme": "समुद्रकिनारा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जोग",
                "गिरसप्पा",
                "दूधसागर",
                "ठोसेघर"
            ],
            "theme": "प्रसिद्ध धबधबे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "वेण्णा",
                "लोणार",
                "शिवसागर",
                "विहार"
            ],
            "theme": "महाराष्ट्रातील प्रसिद्ध तलाव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चिखलदरा",
                "तोरणमाळ",
                "माथेरान",
                "पाचगणी"
            ],
            "theme": "महाराष्ट्रातली थंड हवेची ठिकाणे (हिलस्टेशन)",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ठाणे",
                "कचेरी",
                "कारखाना",
                "कार्यालय"
            ],
            "theme": "लोकांच्या कामाच्या जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "चित्रपटगृह",
                "मैफल",
                "उपाहारगृह",
                "क्लब"
            ],
            "theme": "लोकांच्या आनंदात वेळ घालवण्याच्या जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वाहतूक कोंडी",
                "भाजी मंडई",
                "किराणा दुकान",
                "दवाखाना"
            ],
            "theme": "लोकांच्या (नाईलाजाने?) नियमित वेळ घालवण्याच्या जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संजय गांधी",
                "माधवराव सिंधिया",
                "अजित पवार",
                "बिपीन रावत"
            ],
            "theme": "हवाई अपघातात मृत्यू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "राजीव गांधी",
                "इंदिरा गांधी",
                "महात्मा गांधी",
                "बेनझीर भुट्टो"
            ],
            "theme": "घातपात आणि राजकीय हिंसाचारात मृत्यू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "राजेश पायलट",
                "डायना",
                "गोपीनाथ मुंढे",
                "डॉ.श्रीकांत जिचकार"
            ],
            "theme": "रस्त्यावरील वाहन अपघातात मृत्यू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उर्मिला",
                "श्रुतकिर्ती",
                "सीता",
                "मांडवी"
            ],
            "theme": "रघुकुलवधू",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शूर्पणखा",
                "सुलोचना",
                "मंदोदरी",
                "कैकसी"
            ],
            "theme": "रावण कुटुंबीय",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "तारा",
                "रुमा",
                "अंजना",
                "भागाबाई"
            ],
            "theme": "वानर स्त्रिया",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "जलसा",
                "मन्नत",
                "मातोश्री",
                "अँटीला"
            ],
            "theme": "मुंबईतील मान्यवरांची निवासस्थाने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "हक़",
                "अझर",
                "जन्नत",
                "जहर"
            ],
            "theme": "इम्रान हाश्मी अभिनीत चित्रपट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "हैद्राबाद",
                "कर्णधार",
                "पदार्पणात ३ शतके",
                "मॅच फिक्सिंग"
            ],
            "theme": "क्रिकेटपटू मोहम्मद अझरुद्दीनशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकृती",
                "घडण",
                "रचना",
                "संघटन"
            ],
            "theme": "आकारनिर्मितीशी संबंधित शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "संविधान",
                "नियम",
                "कलम",
                "अमलबजावणी"
            ],
            "theme": "व्यवस्थेची चौकट",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "कणा",
                "स्नायू",
                "अवयव",
                "संस्था"
            ],
            "theme": "जैविक संरचना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सोने",
                "जमीन",
                "बिट कॉईन",
                "समभाग"
            ],
            "theme": "गुंतवणुकीचे प्रकार ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "तोळा",
                "पॉलिश",
                "घट",
                "घडणावळ"
            ],
            "theme": "सोनाराचा शब्दसंग्रह",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "निर्देशांक",
                "बुल आणि बेअर",
                "अस्थिरता",
                "लाभांश"
            ],
            "theme": "गुंतवणूकदारांचा शब्दसंग्रह",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "अंगण",
                "परसदार",
                "बाग",
                "गच्ची"
            ],
            "theme": "घराच्या बाहेरील जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "पडवी",
                "ओसरी",
                "व्हरांडा",
                "प्रवेशद्वार"
            ],
            "theme": "घराच्या प्रवेश भागाशी संबंधित जागा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दिवाणखाना",
                "शयनकक्ष",
                "पाहुण्यांची खोली",
                "स्वयंपाकघर"
            ],
            "theme": "राहण्याच्या/वापराच्या मुख्य खोल्या",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "तरंग",
                "तवंग",
                "लाट",
                "जलपर्णी"
            ],
            "theme": "पाण्याच्या पृष्ठभागावर येणारे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "फोडणी",
                "वंगण",
                "बुद्धी",
                "चंपी"
            ],
            "theme": "तेल/तैल",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "जिरे",
                "मोहोरी",
                "तेल",
                "मिरची"
            ],
            "theme": "फोडणी मधील पदार्थ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "ओळख",
                "प्रतिष्ठा",
                "प्रतिमा",
                "सन्मान"
            ],
            "theme": "सामाजिक मान्यता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नाव",
                "उपाधी",
                "हुद्दा",
                "पदवी"
            ],
            "theme": "ओळख दर्शवणारी साधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "चिन्ह",
                "मुद्रा",
                "ठसा",
                "खूण"
            ],
            "theme": "ओळख पटवणारे घटक",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वाहन",
                "मार्ग",
                "दिशा",
                "गंतव्य"
            ],
            "theme": "प्रवासाशी संबंधित शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "साधन",
                "पद्धत",
                "यंत्रणा",
                "उपाय"
            ],
            "theme": "कार्यसाधने",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सेतू",
                "दुवा",
                "जोड",
                "संपर्क"
            ],
            "theme": "जोडणी दर्शवणाऱ्या संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उद्गम",
                "स्रोत",
                "उगम",
                "मूळस्थान"
            ],
            "theme": "सुरुवात दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "नदी",
                "ओढा",
                "प्रवाह",
                "खाडी"
            ],
            "theme": "जलप्रणाली",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "विचार",
                "कल्पना",
                "स्फुरण",
                "प्रेरणा"
            ],
            "theme": "मानसिक उगम",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "सीमा",
                "कक्षा",
                "परिघ",
                "मर्यादा"
            ],
            "theme": "आवाक्य दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "अधिकारक्षेत्र",
                "प्रांत",
                "हद्द",
                "परिसर"
            ],
            "theme": "प्रशासनिक मर्यादा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "दृष्टीक्षेप",
                "आकलन",
                "समज",
                "जाणीव"
            ],
            "theme": "मानसिक सीमा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "भार",
                "दाब",
                "ताण",
                "घनता"
            ],
            "theme": "भौतिक संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "जबाबदारी",
                "दायित्व",
                "ओझे",
                "कर्तव्य"
            ],
            "theme": "मानसिक/सामाजिक भार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "गंभीरता",
                "तीव्रता",
                "प्रखरता",
                "घनपणा"
            ],
            "theme": "तीव्रतेची छटा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "चेष्टा",
                "मस्करी",
                "टिंगल",
                "फिरकी"
            ],
            "theme": "हलक्या फुलक्या चिडवाचिडवीचे प्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "मुद्रा",
                "पदन्यास",
                "नेत्राभिनय",
                "गिरकी"
            ],
            "theme": "नृत्याशी संबंधित",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "अलारिप्पु",
                "जतीस्वरम्",
                "वर्णम्",
                "तिल्लाना"
            ],
            "theme": "भरतनाट्यम नृत्याचे ४ भाग",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "आकाशगंगा",
                "धूमकेतू",
                "कृष्णविवर",
                "कक्षा"
            ],
            "theme": "खगोलशास्त्रीय संज्ञा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "कुंडली",
                "राहू",
                "केतू",
                "ग्रहदशा"
            ],
            "theme": "ज्योतिष शास्त्रीय संज्ञा",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वेधशाळा",
                "अंतराळ यान",
                "दुर्बीण",
                "कृत्रिम उपग्रह"
            ],
            "theme": "मानवाचा अंतराळ वेध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "वामा",
                "भार्या",
                "पत्नी",
                "अर्धांगिनी"
            ],
            "theme": "पत्नी/बायको समानार्थी",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "लक्ष्मी",
                "सरस्वती",
                "पार्वती",
                "दुर्गा"
            ],
            "theme": "हिंदू देवींची नावे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "आर्या",
                "मंदाक्रान्ता",
                "शार्दूलविक्रीडित",
                "वसंततिलका"
            ],
            "theme": "काव्यातील वृत्तप्रकार",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "स्वच्छ",
                "सात्विक",
                "निर्मळ",
                "पवित्र"
            ],
            "theme": "समान गुण दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "खरपूस",
                "साजूक",
                "खमंग",
                "ताजे"
            ],
            "theme": "अन्नपदार्थांची विशेषणे",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "काठोकाठ",
                "तृप्त",
                "संपृक्त",
                "पूर्ण"
            ],
            "theme": "संतुष्टता/पूर्णता दर्शवणारे शब्द",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "संप",
                "घेराव",
                "उठाव",
                "बंद"
            ],
            "theme": "सामूहिक विरोध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "उपोषण",
                "राजीनामा",
                "आत्मक्लेश",
                "आत्महत्या"
            ],
            "theme": "व्यक्तीने केलेले टोकाचे/प्रतीकात्मक निषेध",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "वाद",
                "भांडण",
                "कलह",
                "खटका"
            ],
            "theme": "दोन लोकांमधील दुरावा / तणाव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "दृश्य",
                "प्रतिमा",
                "छटा",
                "आभास"
            ],
            "theme": "दृष्टीअनुभव",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "भास",
                "भ्रम",
                "छल",
                "माया"
            ],
            "theme": "खोटे आकलन",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "सत्य",
                "वास्तव",
                "अर्थ",
                "तथ्य"
            ],
            "theme": "खरेपणा दर्शवणाऱ्या संकल्पना",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ],
    [
        {
            "words": [
                "उद्रेक",
                "भरमार",
                "सुळसुळाट",
                "फ़ैलाव"
            ],
            "theme": "मोठ्या प्रमाणावर अनियंत्रित वाढ",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 0
        },
        {
            "words": [
                "शिखर",
                "कडा",
                "टोक",
                "सुळका"
            ],
            "theme": "टोकदार उंच उभा दगड",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 1
        },
        {
            "words": [
                "समृद्धी",
                "विपुलता",
                "सुकाळ",
                "सुबत्ता"
            ],
            "theme": "भरपूर उपलब्धता",
            "sharedBy": "एक हितचिंतक",
            "difficulty": 2
        }
    ]
];